//src/command/utils/sembols.js
 

const layers = {
  0: { name: '0', frozen: false, visible: true, colorIndex: 7, color: 16777215 },
  kirmizi: { name: '18', frozen: false, visible: true, colorIndex: 1, color: 16711680 },
  yesil: { name: 'test', frozen: false, visible: true, colorIndex: 1, color: 65280 },
  mavi: { name: 'test', frozen: false, visible: true, colorIndex: 1, color: 255 },
  sari: { name: 'test', frozen: false, visible: true, colorIndex: 1, color: 16776960 },
  magenta: { name: 'test', frozen: false, visible: true, colorIndex: 1, color: 16711935 },
  cyan: { name: 'test', frozen: false, visible: true, colorIndex: 1, color: 65535 },
  gray: { name: 'test', frozen: false, visible: true, colorIndex: 8, color: 12632256 },
  AKSYAZI: { name: 'AKSYAZI', frozen: false, visible: true, colorIndex: 9, color: 12632256 }
};
const kirmizi = layers.kirmizi
const mavi = layers.mavi
const yesil = layers.yesil
const gray = layers.gray

const op_gray = {
  color: gray.color,
  colorIndex: gray.colorIndex,
  layer: gray.name,
  // lineType:layer.lineType,
  shape: true,
  hasContinuousLinetypePattern: false
}
const op_yesil = {
  color: yesil.color,
  colorIndex: yesil.colorIndex,
  layer: gray.name,
  // lineType:layer.lineType,
  shape: true,
  hasContinuousLinetypePattern: false
}
const Scl = 1// 0.75
const rowHeight = 50 * Scl
 

export const createSembolListe =( ) => {

const result=[
  {
    "type": "LWPOLYLINE",
    "vertices": [
      {
        "x": 0,
        "y": 0
      },
      {
        "x": 1000,
        "y": 0
      },
      {
        "x": 1000,
        "y": 1500
      },
      {
        "x": 0,
        "y": 1500
      }
    ],
    "handle": "493",
    "ownerHandle": "1F",
    "layer": "Doc_Sembol_Listesi",
    "shape": true,
    "hasContinuousLinetypePattern": false
  },
  {
    "type": "LWPOLYLINE",
    "vertices": [
      {
        "x": 10,
        "y": 10
      },
      {
        "x": 990,
        "y": 10
      },
      {
        "x": 990,
        "y": 1490
      },
      {
        "x": 10,
        "y": 1490
      }
    ],
    "handle": "494",
    "ownerHandle": "1F",
    "layer": "Doc_Sembol_Listesi",
    "shape": true,
    "hasContinuousLinetypePattern": false
  },
  {
    "type": "LWPOLYLINE",
    "vertices": [
      {
        "x": 20,
        "y": 20
      },
      {
        "x": 980,
        "y": 20
      },
      {
        "x": 980,
        "y": 1070
      },
      {
        "x": 20,
        "y": 1070
      }
    ],
    "handle": "495",
    "ownerHandle": "1F",
    "layer": "Doc_Sembol_Listesi",
    "shape": true,
    "hasContinuousLinetypePattern": false
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 20,
        "y": 1020,
        "z": 0
      },
      {
        "x": 980,
        "y": 1020,
        "z": 0
      }
    ],
    "handle": "496",
    "ownerHandle": "1F",
    "layer": "Doc_Sembol_Listesi"
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 20,
        "y": 970,
        "z": 0
      },
      {
        "x": 980,
        "y": 970,
        "z": 0
      }
    ],
    "handle": "497",
    "ownerHandle": "1F",
    "layer": "Doc_Sembol_Listesi"
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 20,
        "y": 920,
        "z": 0
      },
      {
        "x": 980,
        "y": 920,
        "z": 0
      }
    ],
    "handle": "498",
    "ownerHandle": "1F",
    "layer": "Doc_Sembol_Listesi"
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 20,
        "y": 870,
        "z": 0
      },
      {
        "x": 980,
        "y": 870,
        "z": 0
      }
    ],
    "handle": "499",
    "ownerHandle": "1F",
    "layer": "Doc_Sembol_Listesi"
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 20,
        "y": 820,
        "z": 0
      },
      {
        "x": 980,
        "y": 820,
        "z": 0
      }
    ],
    "handle": "49A",
    "ownerHandle": "1F",
    "layer": "Doc_Sembol_Listesi"
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 20,
        "y": 770,
        "z": 0
      },
      {
        "x": 980,
        "y": 770,
        "z": 0
      }
    ],
    "handle": "49B",
    "ownerHandle": "1F",
    "layer": "Doc_Sembol_Listesi"
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 20,
        "y": 720,
        "z": 0
      },
      {
        "x": 980,
        "y": 720,
        "z": 0
      }
    ],
    "handle": "49C",
    "ownerHandle": "1F",
    "layer": "Doc_Sembol_Listesi"
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 20,
        "y": 670,
        "z": 0
      },
      {
        "x": 980,
        "y": 670,
        "z": 0
      }
    ],
    "handle": "49D",
    "ownerHandle": "1F",
    "layer": "Doc_Sembol_Listesi"
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 20,
        "y": 620,
        "z": 0
      },
      {
        "x": 980,
        "y": 620,
        "z": 0
      }
    ],
    "handle": "49E",
    "ownerHandle": "1F",
    "layer": "Doc_Sembol_Listesi"
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 20,
        "y": 570,
        "z": 0
      },
      {
        "x": 980,
        "y": 570,
        "z": 0
      }
    ],
    "handle": "49F",
    "ownerHandle": "1F",
    "layer": "Doc_Sembol_Listesi"
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 20,
        "y": 520,
        "z": 0
      },
      {
        "x": 980,
        "y": 520,
        "z": 0
      }
    ],
    "handle": "4A0",
    "ownerHandle": "1F",
    "layer": "Doc_Sembol_Listesi"
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 20,
        "y": 470,
        "z": 0
      },
      {
        "x": 980,
        "y": 470,
        "z": 0
      }
    ],
    "handle": "4A1",
    "ownerHandle": "1F",
    "layer": "Doc_Sembol_Listesi"
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 20,
        "y": 420,
        "z": 0
      },
      {
        "x": 980,
        "y": 420,
        "z": 0
      }
    ],
    "handle": "4A2",
    "ownerHandle": "1F",
    "layer": "Doc_Sembol_Listesi"
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 20,
        "y": 370,
        "z": 0
      },
      {
        "x": 980,
        "y": 370,
        "z": 0
      }
    ],
    "handle": "4A3",
    "ownerHandle": "1F",
    "layer": "Doc_Sembol_Listesi"
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 20,
        "y": 320,
        "z": 0
      },
      {
        "x": 980,
        "y": 320,
        "z": 0
      }
    ],
    "handle": "4A4",
    "ownerHandle": "1F",
    "layer": "Doc_Sembol_Listesi"
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 20,
        "y": 270,
        "z": 0
      },
      {
        "x": 980,
        "y": 270,
        "z": 0
      }
    ],
    "handle": "4A5",
    "ownerHandle": "1F",
    "layer": "Doc_Sembol_Listesi"
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 20,
        "y": 220,
        "z": 0
      },
      {
        "x": 980,
        "y": 220,
        "z": 0
      }
    ],
    "handle": "4A6",
    "ownerHandle": "1F",
    "layer": "Doc_Sembol_Listesi"
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 20,
        "y": 170,
        "z": 0
      },
      {
        "x": 980,
        "y": 170,
        "z": 0
      }
    ],
    "handle": "4A7",
    "ownerHandle": "1F",
    "layer": "Doc_Sembol_Listesi"
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 20,
        "y": 120,
        "z": 0
      },
      {
        "x": 980,
        "y": 120,
        "z": 0
      }
    ],
    "handle": "4A8",
    "ownerHandle": "1F",
    "layer": "Doc_Sembol_Listesi"
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 20,
        "y": 70,
        "z": 0
      },
      {
        "x": 980,
        "y": 70,
        "z": 0
      }
    ],
    "handle": "4A9",
    "ownerHandle": "1F",
    "layer": "Doc_Sembol_Listesi"
  },
  {
    "type": "CIRCLE",
    "handle": "4AA",
    "ownerHandle": "1F",
    "layer": "Doc_Sembol_Listesi",
    "center": {
      "x": 525.0797159761041,
      "y": 145.9998486985778,
      "z": 0
    },
    "radius": 2.999999999999999,
    "extendedData": {
      "applicationName": "AcDbBlockRepETag"
    }
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 525.0683279795174,
        "y": 142.9998703130666,
        "z": 0
      },
      {
        "x": 525.0398579880512,
        "y": 135.4999243492889,
        "z": 0
      }
    ],
    "handle": "4AB",
    "ownerHandle": "1F",
    "layer": "Doc_Sembol_Listesi",
    "extendedData": {
      "applicationName": "AcDbBlockRepETag"
    }
  },
  {
    "type": "CIRCLE",
    "handle": "4AD",
    "ownerHandle": "1F",
    "layer": "Doc_Sembol_Listesi",
    "center": {
      "x": 525.0797159761041,
      "y": 95.99984869857781,
      "z": 0
    },
    "radius": 2.999999999999999,
    "extendedData": {
      "applicationName": "AcDbBlockRepETag"
    }
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 525.0683279795174,
        "y": 92.9998703130666,
        "z": 0
      },
      {
        "x": 525.0398579880512,
        "y": 85.4999243492889,
        "z": 0
      }
    ],
    "handle": "4AE",
    "ownerHandle": "1F",
    "layer": "Doc_Sembol_Listesi",
    "extendedData": {
      "applicationName": "AcDbBlockRepETag"
    }
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 527.6789563065267,
        "y": 97.4978305758716,
        "z": 0
      },
      {
        "x": 522.4804756456797,
        "y": 94.50186682128378,
        "z": 0
      }
    ],
    "handle": "4AF",
    "ownerHandle": "1F",
    "layer": "Doc_Sembol_Listesi",
    "extendedData": {
      "applicationName": "AcDbBlockRepETag"
    }
  },
  {
    "type": "CIRCLE",
    "handle": "4B0",
    "ownerHandle": "1F",
    "layer": "Doc_Sembol_Listesi",
    "center": {
      "x": 525.0797159761041,
      "y": 45.9998486985778,
      "z": 0
    },
    "radius": 2.999999999999999,
    "extendedData": {
      "applicationName": "AcDbBlockRepETag"
    }
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 525.0683279795174,
        "y": 42.99987031306659,
        "z": 0
      },
      {
        "x": 525.0398579880512,
        "y": 35.49992434928891,
        "z": 0
      }
    ],
    "handle": "4B1",
    "ownerHandle": "1F",
    "layer": "Doc_Sembol_Listesi",
    "extendedData": {
      "applicationName": "AcDbBlockRepETag"
    }
  },
  {
    "type": "LWPOLYLINE",
    "vertices": [
      {
        "x": 523.5817340988087,
        "y": 48.59908902900087
      },
      {
        "x": 519.8367794055739,
        "y": 55.09718985505924
      },
      {
        "x": 517.6707457968878,
        "y": 53.84887162398104
      }
    ],
    "handle": "4B2",
    "ownerHandle": "1F",
    "layer": "Doc_Sembol_Listesi",
    "shape": false,
    "hasContinuousLinetypePattern": false,
    "extendedData": {
      "applicationName": "AcDbBlockRepETag"
    }
  },
  {
    "type": "LWPOLYLINE",
    "vertices": [
      {
        "x": 526.5973879672327,
        "y": 48.5876415278708
      },
      {
        "x": 530.3915679450565,
        "y": 55.05712360110351
      },
      {
        "x": 528.2350739206468,
        "y": 56.32185026037814
      }
    ],
    "handle": "4B3",
    "ownerHandle": "1F",
    "layer": "Doc_Sembol_Listesi",
    "shape": false,
    "hasContinuousLinetypePattern": false,
    "extendedData": {
      "applicationName": "AcDbBlockRepETag"
    }
  },
  {
    "type": "ARC",
    "handle": "4B4",
    "ownerHandle": "1F",
    "layer": "Doc_Sembol_Listesi",
    "center": {
      "x": 524.2607125504746,
      "y": 456,
      "z": 0
    },
    "radius": 7,
    "startAngle": 3.141592653588884,
    "endAngle": 6.283185307178677,
    "angleLength": 3.1415926535897927,
    "extendedData": {
      "applicationName": "AcDbBlockRepETag"
    }
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 524.2607125504691,
        "y": 449,
        "z": 0
      },
      {
        "x": 524.260712550451,
        "y": 428,
        "z": 0
      }
    ],
    "handle": "4B5",
    "ownerHandle": "1F",
    "layer": "Doc_Sembol_Listesi",
    "extendedData": {
      "applicationName": "AcDbBlockRepETag"
    }
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 531.2607125504691,
        "y": 448.9999999999936,
        "z": 0
      },
      {
        "x": 517.2607125504692,
        "y": 449.0000000000064,
        "z": 0
      }
    ],
    "handle": "4B6",
    "ownerHandle": "1F",
    "layer": "Doc_Sembol_Listesi",
    "extendedData": {
      "applicationName": "AcDbBlockRepETag"
    }
  },
  {
    "type": "ARC",
    "handle": "4B8",
    "ownerHandle": "1F",
    "layer": "Doc_Sembol_Listesi",
    "center": {
      "x": 524.2607125504746,
      "y": 406,
      "z": 0
    },
    "radius": 7,
    "startAngle": 3.141592653588884,
    "endAngle": 6.283185307178677,
    "angleLength": 3.1415926535897927,
    "extendedData": {
      "applicationName": "AcDbBlockRepETag"
    }
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 517.2607125504746,
        "y": 406.0000000000059,
        "z": 0
      },
      {
        "x": 524.2607125504746,
        "y": 406,
        "z": 0
      }
    ],
    "handle": "4B9",
    "ownerHandle": "1F",
    "layer": "Doc_Sembol_Listesi",
    "extendedData": {
      "applicationName": "AcDbBlockRepETag"
    }
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 524.2607125504746,
        "y": 406,
        "z": 0
      },
      {
        "x": 524.2607125504691,
        "y": 399,
        "z": 0
      }
    ],
    "handle": "4BA",
    "ownerHandle": "1F",
    "layer": "Doc_Sembol_Listesi",
    "extendedData": {
      "applicationName": "AcDbBlockRepETag"
    }
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 524.2607125504691,
        "y": 399,
        "z": 0
      },
      {
        "x": 524.260712550451,
        "y": 378,
        "z": 0
      }
    ],
    "handle": "4BB",
    "ownerHandle": "1F",
    "layer": "Doc_Sembol_Listesi",
    "extendedData": {
      "applicationName": "AcDbBlockRepETag"
    }
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 531.2607125504691,
        "y": 398.9999999999941,
        "z": 0
      },
      {
        "x": 517.2607125504692,
        "y": 399.0000000000059,
        "z": 0
      }
    ],
    "handle": "4BC",
    "ownerHandle": "1F",
    "layer": "Doc_Sembol_Listesi",
    "extendedData": {
      "applicationName": "AcDbBlockRepETag"
    }
  },
  {
    "type": "ARC",
    "handle": "4BD",
    "ownerHandle": "1F",
    "layer": "Doc_Sembol_Listesi",
    "center": {
      "x": 524.2607125504746,
      "y": 355.9999999999996,
      "z": 0
    },
    "radius": 7,
    "startAngle": 3.141592653588884,
    "endAngle": 6.283185307178677,
    "angleLength": 3.1415926535897927,
    "extendedData": {
      "applicationName": "AcDbBlockRepETag"
    }
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 524.2607125504746,
        "y": 355.9999999999936,
        "z": 0
      },
      {
        "x": 524.260712550451,
        "y": 327.9999999999995,
        "z": 0
      }
    ],
    "handle": "4BE",
    "ownerHandle": "1F",
    "layer": "Doc_Sembol_Listesi",
    "extendedData": {
      "applicationName": "AcDbBlockRepETag"
    }
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 531.2607125504691,
        "y": 348.9999999999936,
        "z": 0
      },
      {
        "x": 517.2607125504692,
        "y": 349.0000000000055,
        "z": 0
      }
    ],
    "handle": "4BF",
    "ownerHandle": "1F",
    "layer": "Doc_Sembol_Listesi",
    "extendedData": {
      "applicationName": "AcDbBlockRepETag"
    }
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 524.2607125504746,
        "y": 355.9999999999936,
        "z": 0
      },
      {
        "x": 531.2607125504746,
        "y": 355.9999999999877,
        "z": 0
      }
    ],
    "handle": "4C0",
    "ownerHandle": "1F",
    "layer": "Doc_Sembol_Listesi"
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 70,
        "y": 1070,
        "z": 0
      },
      {
        "x": 70,
        "y": 20,
        "z": 0
      }
    ],
    "handle": "4C1",
    "ownerHandle": "1F",
    "layer": "Doc_Sembol_Listesi"
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 500,
        "y": 1070,
        "z": 0
      },
      {
        "x": 500,
        "y": 20,
        "z": 0
      }
    ],
    "handle": "4C2",
    "ownerHandle": "1F",
    "layer": "Doc_Sembol_Listesi"
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 550,
        "y": 1070,
        "z": 0
      },
      {
        "x": 550,
        "y": 20,
        "z": 0
      }
    ],
    "handle": "4C3",
    "ownerHandle": "1F",
    "layer": "Doc_Sembol_Listesi"
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 740,
        "y": 1070,
        "z": 0
      },
      {
        "x": 740,
        "y": 20,
        "z": 0
      }
    ],
    "handle": "4C4",
    "ownerHandle": "1F",
    "layer": "Doc_Sembol_Listesi"
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 790,
        "y": 1070,
        "z": 0
      },
      {
        "x": 790,
        "y": 20,
        "z": 0
      }
    ],
    "handle": "4C5",
    "ownerHandle": "1F",
    "layer": "Doc_Sembol_Listesi",
    "colorIndex": 1,
    "color": 16711680
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 260,
        "y": 1070,
        "z": 0
      },
      {
        "x": 260,
        "y": 20,
        "z": 0
      }
    ],
    "handle": "4C6",
    "ownerHandle": "1F",
    "layer": "Doc_Sembol_Listesi"
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 310,
        "y": 1070,
        "z": 0
      },
      {
        "x": 310,
        "y": 20,
        "z": 0
      }
    ],
    "handle": "4C7",
    "ownerHandle": "1F",
    "layer": "Doc_Sembol_Listesi"
  },
  {
    "type": "MTEXT",
    "handle": "4C8",
    "ownerHandle": "1F",
    "layer": "Doc_Sembol_Listesi",
    "position": {
      "x": 165,
      "y": 995,
      "z": 0
    },
    "height": 9,
    "width": 190.0007882175355,
    "attachmentPoint": 5,
    "drawingDirection": 5,
    "text": "{\\fVerdana|b1|i0|c0|p34;ANA KOLON HATTI \\PKOLON HATTI}",
    "directionVector": {
      "x": 0.9999999998757351,
      "y": -0.0000157648229072,
      "z": 0
    }
  },
  {
    "type": "MTEXT",
    "handle": "4C9",
    "ownerHandle": "1F",
    "layer": "Doc_Sembol_Listesi",
    "position": {
      "x": 165,
      "y": 944.9689867876745,
      "z": 0
    },
    "height": 9,
    "width": 190.0007891953712,
    "attachmentPoint": 5,
    "drawingDirection": 5,
    "text": "{\\fVerdana|b1|i0|c0|p34;TOPRAKLAMA KABLOSU}",
    "directionVector": {
      "x": 0.9999999998757351,
      "y": -0.0000157648229072,
      "z": 0
    }
  },
  {
    "type": "MTEXT",
    "handle": "4CA",
    "ownerHandle": "1F",
    "layer": "Doc_Sembol_Listesi",
    "position": {
      "x": 165,
      "y": 895,
      "z": 0
    },
    "height": 9,
    "width": 190.0007882175357,
    "attachmentPoint": 5,
    "drawingDirection": 5,
    "text": "{\\fVerdana|b1|i0|c162|p34;1\\fVerdana|b1|i0|c0|p34; NOLU LiNYE}",
    "directionVector": {
      "x": 0.9999999998757351,
      "y": -0.0000157648229072,
      "z": 0
    }
  },
  {
    "type": "LWPOLYLINE",
    "vertices": [
      {
        "x": 24.99999999994179,
        "y": 187.5000000000214
      },
      {
        "x": 64.99999999993452,
        "y": 187.4999999999777
      },
      {
        "x": 64.99999999994907,
        "y": 202.4999999999777
      },
      {
        "x": 24.99999999994179,
        "y": 202.5000000000214
      }
    ],
    "handle": "4CC",
    "ownerHandle": "1F",
    "layer": "Doc_Sembol_Listesi",
    "shape": true,
    "hasContinuousLinetypePattern": false
  },
  {
    "type": "LWPOLYLINE",
    "vertices": [
      {
        "x": 25,
        "y": 237.500000000025
      },
      {
        "x": 64.99999999998545,
        "y": 237.4999999999813
      },
      {
        "x": 65,
        "y": 252.4999999999813
      },
      {
        "x": 25,
        "y": 252.500000000025
      }
    ],
    "handle": "4CE",
    "ownerHandle": "1F",
    "layer": "Doc_Sembol_Listesi",
    "shape": true,
    "hasContinuousLinetypePattern": false
  },
  {
    "type": "LWPOLYLINE",
    "vertices": [
      {
        "x": 24.99999999994179,
        "y": 137.5000000000214
      },
      {
        "x": 64.99999999993452,
        "y": 137.4999999999777
      },
      {
        "x": 64.99999999994907,
        "y": 152.4999999999777
      },
      {
        "x": 24.99999999994179,
        "y": 152.5000000000213
      }
    ],
    "handle": "4D0",
    "ownerHandle": "1F",
    "layer": "Doc_Sembol_Listesi",
    "colorIndex": 1,
    "color": 16711680,
    "shape": true,
    "hasContinuousLinetypePattern": false
  },
  {
    "type": "LWPOLYLINE",
    "vertices": [
      {
        "x": 24.99999999994179,
        "y": 87.50000000002136
      },
      {
        "x": 64.99999999993452,
        "y": 87.49999999997772
      },
      {
        "x": 64.99999999994907,
        "y": 102.4999999999777
      },
      {
        "x": 24.99999999994179,
        "y": 102.5000000000213
      }
    ],
    "handle": "4D2",
    "ownerHandle": "1F",
    "layer": "Doc_Sembol_Listesi",
    "colorIndex": 1,
    "color": 16711680,
    "shape": true,
    "hasContinuousLinetypePattern": false
  },
  {
    "type": "LWPOLYLINE",
    "vertices": [
      {
        "x": 37.4999999999618,
        "y": 52.4999999999618
      },
      {
        "x": 52.4999999999618,
        "y": 52.4999999999618
      },
      {
        "x": 52.4999999999618,
        "y": 37.4999999999618
      },
      {
        "x": 37.4999999999618,
        "y": 37.4999999999618
      }
    ],
    "handle": "4D4",
    "ownerHandle": "1F",
    "layer": "Doc_Sembol_Listesi",
    "shape": true,
    "hasContinuousLinetypePattern": false
  },
  {
    "type": "LWPOLYLINE",
    "vertices": [
      {
        "x": 52.4999999999618,
        "y": 37.4999999999618
      },
      {
        "x": 37.4999999999618,
        "y": 52.4999999999618
      },
      {
        "x": 37.4999999999618,
        "y": 37.4999999999618
      },
      {
        "x": 52.4999999999618,
        "y": 52.4999999999618
      },
      {
        "x": 59.9999999999618,
        "y": 44.99999999996179
      },
      {
        "x": 52.4999999999618,
        "y": 37.4999999999618
      }
    ],
    "handle": "4D5",
    "ownerHandle": "1F",
    "layer": "Doc_Sembol_Listesi",
    "shape": false,
    "hasContinuousLinetypePattern": false
  },
  {
    "type": "CIRCLE",
    "handle": "4D6",
    "ownerHandle": "1F",
    "layer": "Doc_Sembol_Listesi",
    "center": {
      "x": 525.1594319522573,
      "y": 245.9998486985778,
      "z": 0
    },
    "radius": 2.999999999999999,
    "extendedData": {
      "applicationName": "AcDbBlockRepETag"
    }
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 525.1480439556726,
        "y": 242.9998703130666,
        "z": 0
      },
      {
        "x": 525.1195739642062,
        "y": 235.4999243492889,
        "z": 0
      }
    ],
    "handle": "4D7",
    "ownerHandle": "1F",
    "layer": "Doc_Sembol_Listesi",
    "extendedData": {
      "applicationName": "AcDbBlockRepETag"
    }
  },
  {
    "type": "CIRCLE",
    "handle": "4D9",
    "ownerHandle": "1F",
    "layer": "Doc_Sembol_Listesi",
    "center": {
      "x": 525.2391479283614,
      "y": 194.2130437835433,
      "z": 0
    },
    "radius": 2.999999999999999,
    "extendedData": {
      "applicationName": "AcDbBlockRepETag"
    }
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 525.2277599317749,
        "y": 191.2130653980323,
        "z": 0
      },
      {
        "x": 525.1992899403103,
        "y": 183.7131194342544,
        "z": 0
      }
    ],
    "handle": "4DA",
    "ownerHandle": "1F",
    "layer": "Doc_Sembol_Listesi",
    "extendedData": {
      "applicationName": "AcDbBlockRepETag"
    }
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 527.838388258784,
        "y": 195.7110256608373,
        "z": 0
      },
      {
        "x": 522.6399075979388,
        "y": 192.7150619062495,
        "z": 0
      }
    ],
    "handle": "4DB",
    "ownerHandle": "1F",
    "layer": "Doc_Sembol_Listesi",
    "extendedData": {
      "applicationName": "AcDbBlockRepETag"
    }
  },
  {
    "type": "LWPOLYLINE",
    "vertices": [
      {
        "x": 267.8319818265736,
        "y": 982.4289169517724
      },
      {
        "x": 278,
        "y": 982.4289169517724
      },
      {
        "x": 278,
        "y": 1007.593255674597
      },
      {
        "x": 267.8319818265736,
        "y": 1007.593255674597
      }
    ],
    "handle": "4DC",
    "ownerHandle": "1F",
    "layer": "Doc_Sembol_Listesi",
    "shape": true,
    "hasContinuousLinetypePattern": false
  },
  {
    "type": "CIRCLE",
    "handle": "4DD",
    "ownerHandle": "1F",
    "layer": "Doc_Sembol_Listesi",
    "center": {
      "x": 272.9159909132868,
      "y": 995.0110863318041,
      "z": 0
    },
    "radius": 4.060205687531357
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 264.2491305629192,
        "y": 990.185220371779,
        "z": 0
      },
      {
        "x": 280.9172976306399,
        "y": 999.8147796282209,
        "z": 0
      }
    ],
    "handle": "4DE",
    "ownerHandle": "1F",
    "layer": "Doc_Sembol_Listesi"
  },
  {
    "type": "LWPOLYLINE",
    "vertices": [
      {
        "x": 292.0000000000009,
        "y": 982.4289169517724
      },
      {
        "x": 302.1680181734273,
        "y": 982.4289169517724
      },
      {
        "x": 302.1680181734273,
        "y": 1007.593255674597
      },
      {
        "x": 292.0000000000009,
        "y": 1007.593255674597
      }
    ],
    "handle": "4DF",
    "ownerHandle": "1F",
    "layer": "Doc_Sembol_Listesi",
    "shape": true,
    "hasContinuousLinetypePattern": false
  },
  {
    "type": "CIRCLE",
    "handle": "4E0",
    "ownerHandle": "1F",
    "layer": "Doc_Sembol_Listesi",
    "center": {
      "x": 297.0840090867141,
      "y": 995.0110863318041,
      "z": 0
    },
    "radius": 4.060205687531357
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 288.4171487363465,
        "y": 985.185220371779,
        "z": 0
      },
      {
        "x": 305.0853158040673,
        "y": 994.814779628221,
        "z": 0
      }
    ],
    "handle": "4E1",
    "ownerHandle": "1F",
    "layer": "Doc_Sembol_Listesi"
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 288.4171487363465,
        "y": 990.185220371779,
        "z": 0
      },
      {
        "x": 305.0853158040673,
        "y": 999.8147796282209,
        "z": 0
      }
    ],
    "handle": "4E2",
    "ownerHandle": "1F",
    "layer": "Doc_Sembol_Listesi"
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 288.4171487363465,
        "y": 995.1852203717789,
        "z": 0
      },
      {
        "x": 305.0853158040673,
        "y": 1004.814779628221,
        "z": 0
      }
    ],
    "handle": "4E3",
    "ownerHandle": "1F",
    "layer": "Doc_Sembol_Listesi"
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 267.8319818265736,
        "y": 929.4178306385875,
        "z": 0
      },
      {
        "x": 278,
        "y": 929.4178306385875,
        "z": 0
      }
    ],
    "handle": "4E4",
    "ownerHandle": "1F",
    "layer": "Doc_Sembol_Listesi"
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 267.8319818265736,
        "y": 960.5821693614124,
        "z": 0
      },
      {
        "x": 278,
        "y": 960.5821693614124,
        "z": 0
      }
    ],
    "handle": "4E5",
    "ownerHandle": "1F",
    "layer": "Doc_Sembol_Listesi"
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 292,
        "y": 929.4178306385875,
        "z": 0
      },
      {
        "x": 302.1680181734264,
        "y": 929.4178306385875,
        "z": 0
      }
    ],
    "handle": "4E6",
    "ownerHandle": "1F",
    "layer": "Doc_Sembol_Listesi"
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 292,
        "y": 960.5821693614124,
        "z": 0
      },
      {
        "x": 302.1680181734264,
        "y": 960.5821693614124,
        "z": 0
      }
    ],
    "handle": "4E7",
    "ownerHandle": "1F",
    "layer": "Doc_Sembol_Listesi"
  },
  {
    "type": "LWPOLYLINE",
    "vertices": [
      {
        "x": 267.8319818265736,
        "y": 932.4178306385874
      },
      {
        "x": 278,
        "y": 932.4178306385874
      },
      {
        "x": 278,
        "y": 957.5821693614125
      },
      {
        "x": 267.8319818265736,
        "y": 957.5821693614125
      }
    ],
    "handle": "4E8",
    "ownerHandle": "1F",
    "layer": "Doc_Sembol_Listesi",
    "shape": true,
    "hasContinuousLinetypePattern": false
  },
  {
    "type": "CIRCLE",
    "handle": "4E9",
    "ownerHandle": "1F",
    "layer": "Doc_Sembol_Listesi",
    "center": {
      "x": 272.9159909132868,
      "y": 945.0000000186191,
      "z": 0
    },
    "radius": 4.060205687531357
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 264.2491305629192,
        "y": 940.1741340585941,
        "z": 0
      },
      {
        "x": 280.9172976306399,
        "y": 949.8036933150361,
        "z": 0
      }
    ],
    "handle": "4EA",
    "ownerHandle": "1F",
    "layer": "Doc_Sembol_Listesi"
  },
  {
    "type": "LWPOLYLINE",
    "vertices": [
      {
        "x": 292,
        "y": 932.4178306385874
      },
      {
        "x": 302.1680181734264,
        "y": 932.4178306385874
      },
      {
        "x": 302.1680181734264,
        "y": 957.5821693614125
      },
      {
        "x": 292,
        "y": 957.5821693614125
      }
    ],
    "handle": "4EB",
    "ownerHandle": "1F",
    "layer": "Doc_Sembol_Listesi",
    "shape": true,
    "hasContinuousLinetypePattern": false
  },
  {
    "type": "CIRCLE",
    "handle": "4EC",
    "ownerHandle": "1F",
    "layer": "Doc_Sembol_Listesi",
    "center": {
      "x": 297.0840090867132,
      "y": 945.0000000186191,
      "z": 0
    },
    "radius": 4.060205687531357
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 288.4171487363456,
        "y": 935.174134058594,
        "z": 0
      },
      {
        "x": 305.0853158040663,
        "y": 944.803693315036,
        "z": 0
      }
    ],
    "handle": "4ED",
    "ownerHandle": "1F",
    "layer": "Doc_Sembol_Listesi"
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 288.4171487363456,
        "y": 940.1741340585941,
        "z": 0
      },
      {
        "x": 305.0853158040663,
        "y": 949.8036933150361,
        "z": 0
      }
    ],
    "handle": "4EE",
    "ownerHandle": "1F",
    "layer": "Doc_Sembol_Listesi"
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 288.4171487363456,
        "y": 945.174134058594,
        "z": 0
      },
      {
        "x": 305.0853158040663,
        "y": 954.803693315036,
        "z": 0
      }
    ],
    "handle": "4EF",
    "ownerHandle": "1F",
    "layer": "Doc_Sembol_Listesi"
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 55.09433232768788,
        "y": 807.0614536136817,
        "z": 0
      },
      {
        "x": 59.75726187389227,
        "y": 811.7184364732784,
        "z": 0
      }
    ],
    "handle": "4F0",
    "ownerHandle": "1F",
    "layer": "Doc_Sembol_Listesi"
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 51.98577723689959,
        "y": 807.5789573818874,
        "z": 0
      },
      {
        "x": 47.84110996089293,
        "y": 811.4598907788715,
        "z": 0
      }
    ],
    "handle": "4F1",
    "ownerHandle": "1F",
    "layer": "Doc_Sembol_Listesi"
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 54.05825062340591,
        "y": 813.7883209546526,
        "z": 0
      },
      {
        "x": 51.98577723689959,
        "y": 807.5789573818874,
        "z": 0
      }
    ],
    "handle": "4F2",
    "ownerHandle": "1F",
    "layer": "Doc_Sembol_Listesi"
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 53.53993144459673,
        "y": 798.7822749393489,
        "z": 0
      },
      {
        "x": 58.46189511529519,
        "y": 803.6979750089777,
        "z": 0
      }
    ],
    "handle": "4F3",
    "ownerHandle": "1F",
    "layer": "Doc_Sembol_Listesi"
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 46.28660906138247,
        "y": 798.2649345297796,
        "z": 0
      },
      {
        "x": 50.17236865617451,
        "y": 802.1457535393965,
        "z": 0
      }
    ],
    "handle": "4F4",
    "ownerHandle": "1F",
    "layer": "Doc_Sembol_Listesi"
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 50.17236865617451,
        "y": 802.1457535393965,
        "z": 0
      },
      {
        "x": 53.53993144459673,
        "y": 798.7822749393489,
        "z": 0
      }
    ],
    "handle": "4F5",
    "ownerHandle": "1F",
    "layer": "Doc_Sembol_Listesi"
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 58.46189511529519,
        "y": 803.6979750089777,
        "z": 0
      },
      {
        "x": 55.09433232768788,
        "y": 807.0614536136817,
        "z": 0
      }
    ],
    "handle": "4F6",
    "ownerHandle": "1F",
    "layer": "Doc_Sembol_Listesi"
  },
  {
    "type": "CIRCLE",
    "handle": "4F7",
    "ownerHandle": "1F",
    "layer": "Doc_Sembol_Listesi",
    "center": {
      "x": 55.58539988929988,
      "y": 792.5001649365258,
      "z": 0
    },
    "radius": 2.482555303661673
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 47.58205738797551,
        "y": 811.459894843163,
        "z": 0
      },
      {
        "x": 54.05825062340591,
        "y": 813.7883209546526,
        "z": 0
      }
    ],
    "handle": "4F8",
    "ownerHandle": "1F",
    "layer": "Doc_Sembol_Listesi"
  },
  {
    "type": "CIRCLE",
    "handle": "4F9",
    "ownerHandle": "1F",
    "layer": "Doc_Sembol_Listesi",
    "center": {
      "x": 34.66096734840539,
      "y": 792.5004948095847,
      "z": 0
    },
    "radius": 2.482555303661673
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 42.40094928877079,
        "y": 802.1458883408886,
        "z": 0
      },
      {
        "x": 49.84658151268376,
        "y": 809.5820315920246,
        "z": 0
      }
    ],
    "handle": "4FA",
    "ownerHandle": "1F",
    "layer": "Doc_Sembol_Listesi"
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 53.56552070350153,
        "y": 790.9393508823086,
        "z": 0
      },
      {
        "x": 36.43447929649847,
        "y": 808.4399594056849,
        "z": 0
      }
    ],
    "handle": "4FB",
    "ownerHandle": "1F",
    "layer": "Doc_Sembol_Listesi"
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 45,
        "y": 799.6896551439967,
        "z": 0
      },
      {
        "x": 45,
        "y": 779.6896551439967,
        "z": 0
      }
    ],
    "handle": "4FC",
    "ownerHandle": "1F",
    "layer": "Doc_Sembol_Listesi"
  },
  {
    "type": "LWPOLYLINE",
    "vertices": [
      {
        "x": 40,
        "y": 774.6896551439967
      },
      {
        "x": 50,
        "y": 774.6896551439967
      },
      {
        "x": 50,
        "y": 784.6896551439968
      },
      {
        "x": 40,
        "y": 784.6896551439968
      }
    ],
    "handle": "4FD",
    "ownerHandle": "1F",
    "layer": "Doc_Sembol_Listesi",
    "shape": true,
    "hasContinuousLinetypePattern": false
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 40,
        "y": 779.6896551439967,
        "z": 0
      },
      {
        "x": 65,
        "y": 779.6896551439967,
        "z": 0
      }
    ],
    "handle": "4FE",
    "ownerHandle": "1F",
    "layer": "Doc_Sembol_Listesi"
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 65,
        "y": 779.6896551439967,
        "z": 0
      },
      {
        "x": 65,
        "y": 790.017609632865,
        "z": 0
      }
    ],
    "handle": "4FF",
    "ownerHandle": "1F",
    "layer": "Doc_Sembol_Listesi"
  },
  {
    "type": "CIRCLE",
    "handle": "500",
    "ownerHandle": "1F",
    "layer": "Doc_Sembol_Listesi",
    "center": {
      "x": 65,
      "y": 792.5001649365258,
      "z": 0
    },
    "radius": 2.482555303661673
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 56.99998016650898,
        "y": 748.6221027313732,
        "z": 0
      },
      {
        "x": 61.66290971271337,
        "y": 753.2790855909698,
        "z": 0
      }
    ],
    "handle": "501",
    "ownerHandle": "1F",
    "layer": "Doc_Sembol_Listesi"
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 53.89142507572069,
        "y": 749.1396064995788,
        "z": 0
      },
      {
        "x": 49.74675779971403,
        "y": 753.0205398965627,
        "z": 0
      }
    ],
    "handle": "502",
    "ownerHandle": "1F",
    "layer": "Doc_Sembol_Listesi"
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 55.96389846222701,
        "y": 755.348970072344,
        "z": 0
      },
      {
        "x": 53.89142507572069,
        "y": 749.1396064995788,
        "z": 0
      }
    ],
    "handle": "503",
    "ownerHandle": "1F",
    "layer": "Doc_Sembol_Listesi"
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 55.44557928341783,
        "y": 740.3429240570402,
        "z": 0
      },
      {
        "x": 60.36754295411629,
        "y": 745.258624126669,
        "z": 0
      }
    ],
    "handle": "504",
    "ownerHandle": "1F",
    "layer": "Doc_Sembol_Listesi"
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 48.19225690020357,
        "y": 739.8255836474709,
        "z": 0
      },
      {
        "x": 52.07801649499561,
        "y": 743.7064026570879,
        "z": 0
      }
    ],
    "handle": "505",
    "ownerHandle": "1F",
    "layer": "Doc_Sembol_Listesi"
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 52.07801649499561,
        "y": 743.7064026570879,
        "z": 0
      },
      {
        "x": 55.44557928341783,
        "y": 740.3429240570402,
        "z": 0
      }
    ],
    "handle": "506",
    "ownerHandle": "1F",
    "layer": "Doc_Sembol_Listesi"
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 60.36754295411629,
        "y": 745.258624126669,
        "z": 0
      },
      {
        "x": 56.99998016650898,
        "y": 748.6221027313732,
        "z": 0
      }
    ],
    "handle": "507",
    "ownerHandle": "1F",
    "layer": "Doc_Sembol_Listesi"
  },
  {
    "type": "CIRCLE",
    "handle": "508",
    "ownerHandle": "1F",
    "layer": "Doc_Sembol_Listesi",
    "center": {
      "x": 55.47116854232263,
      "y": 732.5,
      "z": 0
    },
    "radius": 2.482555303661673
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 49.4877052267966,
        "y": 753.0205439608543,
        "z": 0
      },
      {
        "x": 55.96389846222701,
        "y": 755.348970072344,
        "z": 0
      }
    ],
    "handle": "509",
    "ownerHandle": "1F",
    "layer": "Doc_Sembol_Listesi"
  },
  {
    "type": "CIRCLE",
    "handle": "50A",
    "ownerHandle": "1F",
    "layer": "Doc_Sembol_Listesi",
    "center": {
      "x": 34.54673600142815,
      "y": 732.500329873059,
      "z": 0
    },
    "radius": 2.482555303661673
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 44.30659712759188,
        "y": 743.70653745858,
        "z": 0
      },
      {
        "x": 51.75222935150486,
        "y": 751.1426807097159,
        "z": 0
      }
    ],
    "handle": "50B",
    "ownerHandle": "1F",
    "layer": "Doc_Sembol_Listesi"
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 55.47116854232263,
        "y": 732.5,
        "z": 0
      },
      {
        "x": 38.34012713531956,
        "y": 750.0006085233763,
        "z": 0
      }
    ],
    "handle": "50C",
    "ownerHandle": "1F",
    "layer": "Doc_Sembol_Listesi"
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 54.47059660114792,
        "y": 645.1227241849992,
        "z": 0
      },
      {
        "x": 50.25405452528048,
        "y": 649.070958837452,
        "z": 0
      }
    ],
    "handle": "50D",
    "ownerHandle": "1F",
    "layer": "Doc_Sembol_Listesi"
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 56.54306998765424,
        "y": 651.3320877577643,
        "z": 0
      },
      {
        "x": 54.47059660114792,
        "y": 645.1227241849992,
        "z": 0
      }
    ],
    "handle": "50E",
    "ownerHandle": "1F",
    "layer": "Doc_Sembol_Listesi"
  },
  {
    "type": "CIRCLE",
    "handle": "50F",
    "ownerHandle": "1F",
    "layer": "Doc_Sembol_Listesi",
    "center": {
      "x": 53.45128935652065,
      "y": 630.9393508823123,
      "z": 0
    },
    "radius": 2.482555303661673
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 50.25405452528048,
        "y": 649.070958837452,
        "z": 0
      },
      {
        "x": 56.54306998765424,
        "y": 651.3320877577643,
        "z": 0
      }
    ],
    "handle": "510",
    "ownerHandle": "1F",
    "layer": "Doc_Sembol_Listesi"
  },
  {
    "type": "CIRCLE",
    "handle": "511",
    "ownerHandle": "1F",
    "layer": "Doc_Sembol_Listesi",
    "center": {
      "x": 32.52685681562616,
      "y": 630.9396807553712,
      "z": 0
    },
    "radius": 2.482555303661673
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 44.88576865301911,
        "y": 639.6896551440004,
        "z": 0
      },
      {
        "x": 52.33140087693209,
        "y": 647.1257983951363,
        "z": 0
      }
    ],
    "handle": "512",
    "ownerHandle": "1F",
    "layer": "Doc_Sembol_Listesi"
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 53.45128935652065,
        "y": 630.9393508823123,
        "z": 0
      },
      {
        "x": 36.32024794951758,
        "y": 648.4399594056886,
        "z": 0
      }
    ],
    "handle": "513",
    "ownerHandle": "1F",
    "layer": "Doc_Sembol_Listesi"
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 54.47059660114792,
        "y": 695.1227241849956,
        "z": 0
      },
      {
        "x": 50.25405452528048,
        "y": 699.0709588374484,
        "z": 0
      }
    ],
    "handle": "514",
    "ownerHandle": "1F",
    "layer": "Doc_Sembol_Listesi"
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 56.54306998765424,
        "y": 701.3320877577607,
        "z": 0
      },
      {
        "x": 54.47059660114792,
        "y": 695.1227241849956,
        "z": 0
      }
    ],
    "handle": "515",
    "ownerHandle": "1F",
    "layer": "Doc_Sembol_Listesi"
  },
  {
    "type": "CIRCLE",
    "handle": "516",
    "ownerHandle": "1F",
    "layer": "Doc_Sembol_Listesi",
    "center": {
      "x": 53.45128935652065,
      "y": 680.9393508823086,
      "z": 0
    },
    "radius": 2.482555303661673
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 50.25405452528048,
        "y": 699.0709588374484,
        "z": 0
      },
      {
        "x": 56.54306998765424,
        "y": 701.3320877577607,
        "z": 0
      }
    ],
    "handle": "517",
    "ownerHandle": "1F",
    "layer": "Doc_Sembol_Listesi"
  },
  {
    "type": "CIRCLE",
    "handle": "518",
    "ownerHandle": "1F",
    "layer": "Doc_Sembol_Listesi",
    "center": {
      "x": 32.52685681562616,
      "y": 680.9396807553675,
      "z": 0
    },
    "radius": 2.482555303661673
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 44.88576865301911,
        "y": 689.6896551439968,
        "z": 0
      },
      {
        "x": 52.33140087693209,
        "y": 697.1257983951327,
        "z": 0
      }
    ],
    "handle": "519",
    "ownerHandle": "1F",
    "layer": "Doc_Sembol_Listesi"
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 53.45128935652065,
        "y": 680.9393508823086,
        "z": 0
      },
      {
        "x": 36.32024794951758,
        "y": 698.4399594056849,
        "z": 0
      }
    ],
    "handle": "51A",
    "ownerHandle": "1F",
    "layer": "Doc_Sembol_Listesi"
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 59.42349913909675,
        "y": 650.0693145716159,
        "z": 0
      },
      {
        "x": 55.20695706322931,
        "y": 654.0175492240686,
        "z": 0
      }
    ],
    "handle": "51B",
    "ownerHandle": "1F",
    "layer": "Doc_Sembol_Listesi"
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 57.31522810116257,
        "y": 652.0434318978423,
        "z": 0
      },
      {
        "x": 60.85301562814584,
        "y": 655.5767107453048,
        "z": 0
      }
    ],
    "handle": "51C",
    "ownerHandle": "1F",
    "layer": "Doc_Sembol_Listesi"
  },
  {
    "type": "LWPOLYLINE",
    "vertices": [
      {
        "x": 512.4999999999945,
        "y": 932.4999999999981
      },
      {
        "x": 537.4999999999945,
        "y": 932.4999999999981
      },
      {
        "x": 537.4999999999945,
        "y": 957.4999999999981
      },
      {
        "x": 512.4999999999945,
        "y": 957.4999999999981
      }
    ],
    "handle": "51D",
    "ownerHandle": "1F",
    "layer": "Doc_Sembol_Listesi",
    "shape": true,
    "hasContinuousLinetypePattern": false
  },
  {
    "type": "CIRCLE",
    "handle": "51E",
    "ownerHandle": "1F",
    "layer": "Doc_Sembol_Listesi",
    "center": {
      "x": 525,
      "y": 945,
      "z": 0
    },
    "radius": 10
  },
  {
    "type": "CIRCLE",
    "handle": "51F",
    "ownerHandle": "1F",
    "layer": "Doc_Sembol_Listesi",
    "center": {
      "x": 525,
      "y": 945,
      "z": 0
    },
    "radius": 5
  },
  {
    "type": "LWPOLYLINE",
    "vertices": [
      {
        "x": 512.4999999999945,
        "y": 882.5000000037579
      },
      {
        "x": 537.4999999999945,
        "y": 882.5000000037579
      },
      {
        "x": 537.4999999999945,
        "y": 907.5000000037579
      },
      {
        "x": 512.4999999999945,
        "y": 907.5000000037579
      }
    ],
    "handle": "520",
    "ownerHandle": "1F",
    "layer": "Doc_Sembol_Listesi",
    "shape": true,
    "hasContinuousLinetypePattern": false
  },
  {
    "type": "CIRCLE",
    "handle": "521",
    "ownerHandle": "1F",
    "layer": "Doc_Sembol_Listesi",
    "center": {
      "x": 525,
      "y": 895.0000000037599,
      "z": 0
    },
    "radius": 10
  },
  {
    "type": "LWPOLYLINE",
    "vertices": [
      {
        "x": 512.4999999999945,
        "y": 832.5000000074338
      },
      {
        "x": 537.4999999999945,
        "y": 832.5000000074338
      },
      {
        "x": 537.4999999999945,
        "y": 857.5000000074338
      },
      {
        "x": 512.4999999999945,
        "y": 857.5000000074338
      }
    ],
    "handle": "522",
    "ownerHandle": "1F",
    "layer": "0",
    "lineweight": -3,
    "shape": true,
    "hasContinuousLinetypePattern": false
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 512.4999999999945,
        "y": 907.5000000037579,
        "z": 0
      },
      {
        "x": 517.9289321881315,
        "y": 902.0710678156229,
        "z": 0
      }
    ],
    "handle": "523",
    "ownerHandle": "1F",
    "layer": "Doc_Sembol_Listesi"
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 532.0710678118611,
        "y": 887.9289321918914,
        "z": 0
      },
      {
        "x": 537.4999999999945,
        "y": 882.5000000037579,
        "z": 0
      }
    ],
    "handle": "524",
    "ownerHandle": "1F",
    "layer": "Doc_Sembol_Listesi"
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 537.4999999999945,
        "y": 907.5000000037579,
        "z": 0
      },
      {
        "x": 532.071067811863,
        "y": 902.0710678156285,
        "z": 0
      }
    ],
    "handle": "525",
    "ownerHandle": "1F",
    "layer": "Doc_Sembol_Listesi"
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 517.9289321881333,
        "y": 887.9289321918967,
        "z": 0
      },
      {
        "x": 512.4999999999945,
        "y": 882.5000000037579,
        "z": 0
      }
    ],
    "handle": "526",
    "ownerHandle": "1F",
    "layer": "Doc_Sembol_Listesi"
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 512.4999999999945,
        "y": 851.5000000074338,
        "z": 0
      },
      {
        "x": 537.4999999999945,
        "y": 851.5000000074338,
        "z": 0
      }
    ],
    "handle": "527",
    "ownerHandle": "1F",
    "layer": "0",
    "lineweight": -3
  },
  {
    "type": "LWPOLYLINE",
    "vertices": [
      {
        "x": 512.4999999999945,
        "y": 782.5000000037606
      },
      {
        "x": 537.4999999999945,
        "y": 782.5000000037606
      },
      {
        "x": 537.4999999999945,
        "y": 807.5000000037608
      },
      {
        "x": 512.4999999999945,
        "y": 807.5000000037608
      }
    ],
    "handle": "528",
    "ownerHandle": "1F",
    "layer": "0",
    "lineweight": -3,
    "shape": true,
    "hasContinuousLinetypePattern": false
  },
  {
    "type": "CIRCLE",
    "handle": "529",
    "ownerHandle": "1F",
    "layer": "0",
    "lineweight": -3,
    "center": {
      "x": 525.000000003065,
      "y": 804.5000000037606,
      "z": 0
    },
    "radius": 2
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 512.4999999999945,
        "y": 801.5000000037606,
        "z": 0
      },
      {
        "x": 537.4999999999945,
        "y": 801.5000000037606,
        "z": 0
      }
    ],
    "handle": "52A",
    "ownerHandle": "1F",
    "layer": "0",
    "lineweight": -3
  },
  {
    "type": "LWPOLYLINE",
    "vertices": [
      {
        "x": 512.4999999999945,
        "y": 732.5000000037599
      },
      {
        "x": 537.4999999999945,
        "y": 732.5000000037599
      },
      {
        "x": 537.4999999999945,
        "y": 757.5000000037599
      },
      {
        "x": 512.4999999999945,
        "y": 757.5000000037599
      }
    ],
    "handle": "52B",
    "ownerHandle": "1F",
    "layer": "Doc_Sembol_Listesi",
    "colorIndex": 1,
    "color": 16711680,
    "shape": true,
    "hasContinuousLinetypePattern": false
  },
  {
    "type": "CIRCLE",
    "handle": "52C",
    "ownerHandle": "1F",
    "layer": "Doc_Sembol_Listesi",
    "colorIndex": 1,
    "color": 16711680,
    "center": {
      "x": 524.9999999999945,
      "y": 751.5000000037599,
      "z": 0
    },
    "radius": 2
  },
  {
    "type": "CIRCLE",
    "handle": "52D",
    "ownerHandle": "1F",
    "layer": "0",
    "lineweight": -3,
    "center": {
      "x": 525.0000000030667,
      "y": 845.0000000037602,
      "z": 0
    },
    "radius": 2
  },
  {
    "type": "CIRCLE",
    "handle": "52E",
    "ownerHandle": "1F",
    "layer": "Doc_Sembol_Listesi",
    "colorIndex": 1,
    "color": 16711680,
    "center": {
      "x": 530.9999999999945,
      "y": 738.5000000037599,
      "z": 0
    },
    "radius": 2
  },
  {
    "type": "CIRCLE",
    "handle": "52F",
    "ownerHandle": "1F",
    "layer": "Doc_Sembol_Listesi",
    "colorIndex": 1,
    "color": 16711680,
    "center": {
      "x": 518.9999999999945,
      "y": 738.5000000037599,
      "z": 0
    },
    "radius": 2
  },
  {
    "type": "LWPOLYLINE",
    "vertices": [
      {
        "x": 512.4999999999945,
        "y": 682.5000000037599
      },
      {
        "x": 537.4999999999945,
        "y": 682.5000000037599
      },
      {
        "x": 537.4999999999945,
        "y": 707.5000000037599
      },
      {
        "x": 512.4999999999945,
        "y": 707.5000000037599
      }
    ],
    "handle": "530",
    "ownerHandle": "1F",
    "layer": "Doc_Sembol_Listesi",
    "colorIndex": 1,
    "color": 16711680,
    "shape": true,
    "hasContinuousLinetypePattern": false
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 512.4999999999945,
        "y": 701.5000000037599,
        "z": 0
      },
      {
        "x": 537.4999999999945,
        "y": 701.5000000037599,
        "z": 0
      }
    ],
    "handle": "531",
    "ownerHandle": "1F",
    "layer": "Doc_Sembol_Listesi",
    "colorIndex": 1,
    "color": 16711680
  },
  {
    "type": "LWPOLYLINE",
    "vertices": [
      {
        "x": 512.5000000030595,
        "y": 632.500000003758
      },
      {
        "x": 537.5000000030595,
        "y": 632.500000003758
      },
      {
        "x": 537.5000000030595,
        "y": 657.500000003758
      },
      {
        "x": 512.5000000030595,
        "y": 657.500000003758
      }
    ],
    "handle": "532",
    "ownerHandle": "1F",
    "layer": "Doc_Sembol_Listesi",
    "shape": true,
    "hasContinuousLinetypePattern": false
  },
  {
    "type": "CIRCLE",
    "handle": "533",
    "ownerHandle": "1F",
    "layer": "Doc_Sembol_Listesi",
    "center": {
      "x": 525.000000003065,
      "y": 645.0000000037599,
      "z": 0
    },
    "radius": 10
  },
  {
    "type": "MTEXT",
    "handle": "534",
    "ownerHandle": "1F",
    "layer": "Doc_Sembol_Listesi",
    "position": {
      "x": 525.0001970648991,
      "y": 645.000098531571,
      "z": 0
    },
    "height": 9,
    "width": 24.9999999968934,
    "attachmentPoint": 5,
    "drawingDirection": 5,
    "text": "{\\fTimes New Roman|b0|i0|c162|p18;\\C0;M}",
    "directionVector": {
      "x": 0.9999999998757351,
      "y": -0.0000157648229071,
      "z": 0
    }
  },
  {
    "type": "LWPOLYLINE",
    "vertices": [
      {
        "x": 512.5000000030595,
        "y": 582.500000003758
      },
      {
        "x": 537.5000000030595,
        "y": 582.500000003758
      },
      {
        "x": 537.5000000030595,
        "y": 607.500000003758
      },
      {
        "x": 512.5000000030595,
        "y": 607.500000003758
      }
    ],
    "handle": "535",
    "ownerHandle": "1F",
    "layer": "Doc_Sembol_Listesi",
    "shape": true,
    "hasContinuousLinetypePattern": false
  },
  {
    "type": "CIRCLE",
    "handle": "536",
    "ownerHandle": "1F",
    "layer": "Doc_Sembol_Listesi",
    "center": {
      "x": 525.000000003065,
      "y": 595.0000000037599,
      "z": 0
    },
    "radius": 10
  },
  {
    "type": "LWPOLYLINE",
    "vertices": [
      {
        "x": 514.2746336066156,
        "y": 532.500000003758
      },
      {
        "x": 539.2746336066156,
        "y": 532.500000003758
      },
      {
        "x": 539.2746336066156,
        "y": 557.500000003758
      },
      {
        "x": 514.2746336066156,
        "y": 557.500000003758
      }
    ],
    "handle": "537",
    "ownerHandle": "1F",
    "layer": "Doc_Sembol_Listesi",
    "shape": true,
    "hasContinuousLinetypePattern": false
  },
  {
    "type": "CIRCLE",
    "handle": "538",
    "ownerHandle": "1F",
    "layer": "Doc_Sembol_Listesi",
    "center": {
      "x": 526.7746336066211,
      "y": 545.0000000037599,
      "z": 0
    },
    "radius": 10
  },
  {
    "type": "LWPOLYLINE",
    "vertices": [
      {
        "x": 512.5000000030595,
        "y": 482.5000000037575
      },
      {
        "x": 537.5000000030595,
        "y": 482.5000000037575
      },
      {
        "x": 537.5000000030595,
        "y": 507.5000000037575
      },
      {
        "x": 512.5000000030595,
        "y": 507.5000000037575
      }
    ],
    "handle": "539",
    "ownerHandle": "1F",
    "layer": "Doc_Sembol_Listesi",
    "shape": true,
    "hasContinuousLinetypePattern": false
  },
  {
    "type": "CIRCLE",
    "handle": "53A",
    "ownerHandle": "1F",
    "layer": "Doc_Sembol_Listesi",
    "center": {
      "x": 525.000000003065,
      "y": 495.0000000037594,
      "z": 0
    },
    "radius": 10
  },
  {
    "type": "MTEXT",
    "handle": "53B",
    "ownerHandle": "1F",
    "layer": "Doc_Sembol_Listesi",
    "position": {
      "x": 165,
      "y": 794.9689867876745,
      "z": 0
    },
    "height": 9,
    "width": 190.0007891953712,
    "attachmentPoint": 5,
    "drawingDirection": 5,
    "text": "{\\fVerdana|b1|i0|c0|p34;TOPRAKLAMA KABLOSU}",
    "directionVector": {
      "x": 0.9999999998757351,
      "y": -0.0000157648229071,
      "z": 0
    }
  },
  {
    "type": "MTEXT",
    "handle": "53C",
    "ownerHandle": "1F",
    "layer": "Doc_Sembol_Listesi",
    "position": {
      "x": 165,
      "y": 744.9689867876745,
      "z": 0
    },
    "height": 9,
    "width": 190.0007891953712,
    "attachmentPoint": 5,
    "drawingDirection": 5,
    "text": "{\\fVerdana|b1|i0|c162|p34;TERMİK MANYETİK ŞALTER}",
    "directionVector": {
      "x": 0.9999999998757351,
      "y": -0.0000157648229071,
      "z": 0
    }
  },
  {
    "type": "MTEXT",
    "handle": "53D",
    "ownerHandle": "1F",
    "layer": "Doc_Sembol_Listesi",
    "position": {
      "x": 165,
      "y": 694.9689867876745,
      "z": 0
    },
    "height": 9,
    "width": 190.0007891953712,
    "attachmentPoint": 5,
    "drawingDirection": 5,
    "text": "{\\fVerdana|b1|i0|c162|p34;ŞALTER}",
    "directionVector": {
      "x": 0.9999999998757351,
      "y": -0.0000157648229071,
      "z": 0
    }
  },
  {
    "type": "MTEXT",
    "handle": "53E",
    "ownerHandle": "1F",
    "layer": "Doc_Sembol_Listesi",
    "position": {
      "x": 165,
      "y": 644.9689867876745,
      "z": 0
    },
    "height": 9,
    "width": 190.0007891953712,
    "attachmentPoint": 5,
    "drawingDirection": 5,
    "text": "{\\fVerdana|b1|i0|c162|p34;KAÇAK AKIM ve\\PYANGIN KORUMA ŞALTERİ}",
    "directionVector": {
      "x": 0.9999999998757351,
      "y": -0.0000157648229071,
      "z": 0
    }
  },
  {
    "type": "CIRCLE",
    "handle": "542",
    "ownerHandle": "1F",
    "layer": "Doc_Sembol_Listesi",
    "center": {
      "x": 284.9999999999991,
      "y": 595,
      "z": 0
    },
    "radius": 9
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 278.63603896932,
        "y": 601.3639610306782,
        "z": 0
      },
      {
        "x": 291.3639610306773,
        "y": 588.63603896932,
        "z": 0
      }
    ],
    "handle": "543",
    "ownerHandle": "1F",
    "layer": "Doc_Sembol_Listesi"
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 278.63603896932,
        "y": 588.63603896932,
        "z": 0
      },
      {
        "x": 291.3639610306782,
        "y": 601.3639610306782,
        "z": 0
      }
    ],
    "handle": "544",
    "ownerHandle": "1F",
    "layer": "Doc_Sembol_Listesi"
  },
  {
    "type": "CIRCLE",
    "handle": "545",
    "ownerHandle": "1F",
    "layer": "Doc_Sembol_Listesi",
    "center": {
      "x": 284.9999999999991,
      "y": 545,
      "z": 0
    },
    "radius": 9
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 278.63603896932,
        "y": 538.63603896932,
        "z": 0
      },
      {
        "x": 291.3639610306782,
        "y": 551.3639610306781,
        "z": 0
      }
    ],
    "handle": "546",
    "ownerHandle": "1F",
    "layer": "Doc_Sembol_Listesi"
  },
  {
    "type": "LWPOLYLINE",
    "vertices": [
      {
        "x": 269.9999999999591,
        "y": 180.0000000000286
      },
      {
        "x": 299.9999999999591,
        "y": 180.0000000000286
      },
      {
        "x": 299.9999999999591,
        "y": 210.0000000000286
      },
      {
        "x": 269.9999999999591,
        "y": 210.0000000000286
      }
    ],
    "handle": "547",
    "ownerHandle": "1F",
    "layer": "Doc_Sembol_Listesi",
    "shape": true,
    "hasContinuousLinetypePattern": false
  },
  {
    "type": "LWPOLYLINE",
    "vertices": [
      {
        "x": 272.4999999999591,
        "y": 182.5000000000286
      },
      {
        "x": 297.4999999999591,
        "y": 182.5000000000286
      },
      {
        "x": 297.4999999999591,
        "y": 187.0000000000286
      },
      {
        "x": 272.4999999999591,
        "y": 187.0000000000286
      }
    ],
    "handle": "548",
    "ownerHandle": "1F",
    "layer": "Doc_Sembol_Listesi",
    "shape": true,
    "hasContinuousLinetypePattern": false
  },
  {
    "type": "LWPOLYLINE",
    "vertices": [
      {
        "x": 272.4999999999591,
        "y": 189.5000000000286
      },
      {
        "x": 297.4999999999591,
        "y": 189.5000000000286
      },
      {
        "x": 297.4999999999591,
        "y": 194.0000000000586
      },
      {
        "x": 272.4999999999591,
        "y": 194.0000000000586
      }
    ],
    "handle": "549",
    "ownerHandle": "1F",
    "layer": "Doc_Sembol_Listesi",
    "shape": true,
    "hasContinuousLinetypePattern": false
  },
  {
    "type": "LWPOLYLINE",
    "vertices": [
      {
        "x": 272.4999999999591,
        "y": 195.9999999999986
      },
      {
        "x": 297.4999999999591,
        "y": 195.9999999999986
      },
      {
        "x": 297.4999999999591,
        "y": 200.4999999999987
      },
      {
        "x": 272.4999999999591,
        "y": 200.4999999999987
      }
    ],
    "handle": "54A",
    "ownerHandle": "1F",
    "layer": "Doc_Sembol_Listesi",
    "shape": true,
    "hasContinuousLinetypePattern": false
  },
  {
    "type": "LWPOLYLINE",
    "vertices": [
      {
        "x": 272.4999999999591,
        "y": 202.9999999999986
      },
      {
        "x": 297.4999999999591,
        "y": 202.9999999999986
      },
      {
        "x": 297.4999999999591,
        "y": 207.4999999999986
      },
      {
        "x": 272.4999999999591,
        "y": 207.4999999999986
      }
    ],
    "handle": "54B",
    "ownerHandle": "1F",
    "layer": "Doc_Sembol_Listesi",
    "shape": true,
    "hasContinuousLinetypePattern": false
  },
  {
    "type": "LWPOLYLINE",
    "vertices": [
      {
        "x": 269.9999999999591,
        "y": 80.0000000000282
      },
      {
        "x": 299.9999999999591,
        "y": 80.0000000000282
      },
      {
        "x": 299.9999999999591,
        "y": 110.0000000000282
      },
      {
        "x": 269.9999999999591,
        "y": 110.0000000000282
      }
    ],
    "handle": "54C",
    "ownerHandle": "1F",
    "layer": "Doc_Sembol_Listesi",
    "shape": true,
    "hasContinuousLinetypePattern": false
  },
  {
    "type": "LWPOLYLINE",
    "vertices": [
      {
        "x": 272.4999999999591,
        "y": 82.5000000000282
      },
      {
        "x": 297.4999999999591,
        "y": 82.5000000000282
      },
      {
        "x": 297.4999999999591,
        "y": 107.5000000000282
      },
      {
        "x": 272.4999999999591,
        "y": 107.5000000000282
      }
    ],
    "handle": "54D",
    "ownerHandle": "1F",
    "layer": "Doc_Sembol_Listesi",
    "shape": true,
    "hasContinuousLinetypePattern": false
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 272.4999999999591,
        "y": 95.0000000000282,
        "z": 0
      },
      {
        "x": 297.4999999999591,
        "y": 95.0000000000282,
        "z": 0
      }
    ],
    "handle": "54E",
    "ownerHandle": "1F",
    "layer": "Doc_Sembol_Listesi"
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 284.9999999999991,
        "y": 107.5000000000282,
        "z": 0
      },
      {
        "x": 284.9999999999991,
        "y": 82.5000000000282,
        "z": 0
      }
    ],
    "handle": "54F",
    "ownerHandle": "1F",
    "layer": "Doc_Sembol_Listesi"
  },
  {
    "type": "LWPOLYLINE",
    "vertices": [
      {
        "x": 269.9999999999591,
        "y": 130.0000000000282
      },
      {
        "x": 299.9999999999591,
        "y": 130.0000000000282
      },
      {
        "x": 299.9999999999591,
        "y": 160.0000000000282
      },
      {
        "x": 269.9999999999591,
        "y": 160.0000000000282
      }
    ],
    "handle": "550",
    "ownerHandle": "1F",
    "layer": "Doc_Sembol_Listesi",
    "shape": true,
    "hasContinuousLinetypePattern": false
  },
  {
    "type": "LWPOLYLINE",
    "vertices": [
      {
        "x": 272.4999999999591,
        "y": 132.5000000000282
      },
      {
        "x": 297.4999999999591,
        "y": 132.5000000000282
      },
      {
        "x": 297.4999999999591,
        "y": 137.0000000000282
      },
      {
        "x": 272.4999999999591,
        "y": 137.0000000000282
      }
    ],
    "handle": "552",
    "ownerHandle": "1F",
    "layer": "Doc_Sembol_Listesi",
    "shape": true,
    "hasContinuousLinetypePattern": false
  },
  {
    "type": "LWPOLYLINE",
    "vertices": [
      {
        "x": 272.4999999999591,
        "y": 139.5000000000282
      },
      {
        "x": 297.4999999999591,
        "y": 139.5000000000282
      },
      {
        "x": 297.4999999999591,
        "y": 144.0000000000582
      },
      {
        "x": 272.4999999999591,
        "y": 144.0000000000582
      }
    ],
    "handle": "553",
    "ownerHandle": "1F",
    "layer": "Doc_Sembol_Listesi",
    "shape": true,
    "hasContinuousLinetypePattern": false
  },
  {
    "type": "LWPOLYLINE",
    "vertices": [
      {
        "x": 272.4999999999591,
        "y": 145.9999999999982
      },
      {
        "x": 297.4999999999591,
        "y": 145.9999999999982
      },
      {
        "x": 297.4999999999591,
        "y": 150.4999999999982
      },
      {
        "x": 272.4999999999591,
        "y": 150.4999999999982
      }
    ],
    "handle": "554",
    "ownerHandle": "1F",
    "layer": "Doc_Sembol_Listesi",
    "shape": true,
    "hasContinuousLinetypePattern": false
  },
  {
    "type": "LWPOLYLINE",
    "vertices": [
      {
        "x": 272.4999999999591,
        "y": 152.9999999999982
      },
      {
        "x": 297.4999999999591,
        "y": 152.9999999999982
      },
      {
        "x": 297.4999999999591,
        "y": 157.4999999999981
      },
      {
        "x": 272.4999999999591,
        "y": 157.4999999999981
      }
    ],
    "handle": "555",
    "ownerHandle": "1F",
    "layer": "Doc_Sembol_Listesi",
    "shape": true,
    "hasContinuousLinetypePattern": false
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 284.9999999999591,
        "y": 157.4999999999981,
        "z": 0
      },
      {
        "x": 284.9999999999591,
        "y": 152.9999999999982,
        "z": 0
      }
    ],
    "handle": "556",
    "ownerHandle": "1F",
    "layer": "Doc_Sembol_Listesi"
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 284.9999999999591,
        "y": 150.4999999999982,
        "z": 0
      },
      {
        "x": 284.9999999999991,
        "y": 145.9999999999982,
        "z": 0
      }
    ],
    "handle": "557",
    "ownerHandle": "1F",
    "layer": "Doc_Sembol_Listesi"
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 284.9999999999991,
        "y": 144.0000000000582,
        "z": 0
      },
      {
        "x": 284.9999999999991,
        "y": 139.5000000000282,
        "z": 0
      }
    ],
    "handle": "558",
    "ownerHandle": "1F",
    "layer": "Doc_Sembol_Listesi"
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 284.9999999999991,
        "y": 137.0000000000282,
        "z": 0
      },
      {
        "x": 284.9999999999991,
        "y": 132.5000000000282,
        "z": 0
      }
    ],
    "handle": "559",
    "ownerHandle": "1F",
    "layer": "Doc_Sembol_Listesi"
  },
  {
    "type": "LWPOLYLINE",
    "vertices": [
      {
        "x": 269.9999999999591,
        "y": 30.00000000002865
      },
      {
        "x": 299.9999999999591,
        "y": 30.00000000002865
      },
      {
        "x": 299.9999999999591,
        "y": 60.00000000002865
      },
      {
        "x": 269.9999999999591,
        "y": 60.00000000002865
      }
    ],
    "handle": "55A",
    "ownerHandle": "1F",
    "layer": "Doc_Sembol_Listesi",
    "shape": true,
    "hasContinuousLinetypePattern": false
  },
  {
    "type": "LWPOLYLINE",
    "vertices": [
      {
        "x": 272.4999999999591,
        "y": 32.50000000002865
      },
      {
        "x": 297.4999999999591,
        "y": 32.50000000002865
      },
      {
        "x": 297.4999999999591,
        "y": 57.50000000002865
      },
      {
        "x": 272.4999999999591,
        "y": 57.50000000002865
      }
    ],
    "handle": "55C",
    "ownerHandle": "1F",
    "layer": "Doc_Sembol_Listesi",
    "shape": true,
    "hasContinuousLinetypePattern": false
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 272.4999999999591,
        "y": 45.00000000002865,
        "z": 0
      },
      {
        "x": 297.4999999999591,
        "y": 45.00000000002865,
        "z": 0
      }
    ],
    "handle": "55D",
    "ownerHandle": "1F",
    "layer": "Doc_Sembol_Listesi"
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 284.9999999999991,
        "y": 57.50000000002865,
        "z": 0
      },
      {
        "x": 284.9999999999991,
        "y": 32.50000000002865,
        "z": 0
      }
    ],
    "handle": "55E",
    "ownerHandle": "1F",
    "layer": "Doc_Sembol_Listesi"
  },
  {
    "type": "CIRCLE",
    "handle": "55F",
    "ownerHandle": "1F",
    "layer": "Doc_Sembol_Listesi",
    "center": {
      "x": 284.9999999999991,
      "y": 394.9999999999986,
      "z": 0
    },
    "radius": 9
  },
  {
    "type": "CIRCLE",
    "handle": "560",
    "ownerHandle": "1F",
    "layer": "Doc_Sembol_Listesi",
    "center": {
      "x": 284.9999999999991,
      "y": 344.9999999999982,
      "z": 0
    },
    "radius": 9
  },
  {
    "type": "CIRCLE",
    "handle": "561",
    "ownerHandle": "1F",
    "layer": "Doc_Sembol_Listesi",
    "center": {
      "x": 284.9999999999991,
      "y": 394.9999999999991,
      "z": 0
    },
    "radius": 6
  },
  {
    "type": "CIRCLE",
    "handle": "562",
    "ownerHandle": "1F",
    "layer": "Doc_Sembol_Listesi",
    "center": {
      "x": 284.9999999999991,
      "y": 344.9999999999986,
      "z": 0
    },
    "radius": 6
  },
  {
    "type": "CIRCLE",
    "handle": "563",
    "ownerHandle": "1F",
    "layer": "Doc_Sembol_Listesi",
    "center": {
      "x": 284.9999999999991,
      "y": 294.9999999999982,
      "z": 0
    },
    "radius": 9
  },
  {
    "type": "CIRCLE",
    "handle": "564",
    "ownerHandle": "1F",
    "layer": "Doc_Sembol_Listesi",
    "center": {
      "x": 284.9999999999991,
      "y": 294.9999999999986,
      "z": 0
    },
    "radius": 4.5
  },
  {
    "type": "LWPOLYLINE",
    "vertices": [
      {
        "x": 269.9999999871952,
        "y": 242.4999999854699
      },
      {
        "x": 299.9999999871952,
        "y": 242.4999999854699
      },
      {
        "x": 299.9999999871952,
        "y": 247.4999999854699
      },
      {
        "x": 269.9999999871952,
        "y": 247.4999999854699
      }
    ],
    "handle": "565",
    "ownerHandle": "1F",
    "layer": "Doc_Sembol_Listesi",
    "shape": true,
    "hasContinuousLinetypePattern": false
  },
  {
    "type": "LWPOLYLINE",
    "vertices": [
      {
        "x": 299.9999999871952,
        "y": 244.9999999999986
      },
      {
        "x": 302.4999999999991,
        "y": 244.9999999999986
      },
      {
        "x": 302.4999999999991,
        "y": 249.9999999999986
      },
      {
        "x": 267.4999999999991,
        "y": 249.9999999999986
      },
      {
        "x": 267.4999999999991,
        "y": 244.9999999999986
      },
      {
        "x": 269.9999999871952,
        "y": 244.9999999999986
      }
    ],
    "handle": "566",
    "ownerHandle": "1F",
    "layer": "Doc_Sembol_Listesi",
    "shape": false,
    "hasContinuousLinetypePattern": false
  },
  {
    "type": "ARC",
    "handle": "567",
    "ownerHandle": "1F",
    "layer": "Doc_Sembol_Listesi",
    "center": {
      "x": 284.9999999999991,
      "y": 249.9999999999986,
      "z": 0
    },
    "radius": 2.500000014528723,
    "startAngle": 0,
    "endAngle": 3.141592653589793,
    "angleLength": 3.141592653589793
  },
  {
    "type": "CIRCLE",
    "handle": "568",
    "ownerHandle": "1F",
    "layer": "Doc_Sembol_Listesi",
    "center": {
      "x": 284.9999999999991,
      "y": 495,
      "z": 0
    },
    "radius": 5.399999999999999
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 281.1816233815916,
        "y": 491.1816233815916,
        "z": 0
      },
      {
        "x": 288.8183766184066,
        "y": 498.8183766184065,
        "z": 0
      }
    ],
    "handle": "569",
    "ownerHandle": "1F",
    "layer": "Doc_Sembol_Listesi"
  },
  {
    "type": "CIRCLE",
    "handle": "56B",
    "ownerHandle": "1F",
    "layer": "Doc_Sembol_Listesi",
    "center": {
      "x": 284.9999999999991,
      "y": 445,
      "z": 0
    },
    "radius": 5.399999999999999
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 281.1816233815916,
        "y": 441.1816233815925,
        "z": 0
      },
      {
        "x": 288.8183766184066,
        "y": 448.8183766184074,
        "z": 0
      }
    ],
    "handle": "56C",
    "ownerHandle": "1F",
    "layer": "Doc_Sembol_Listesi"
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 284.9999999999991,
        "y": 489.6000000000003,
        "z": 0
      },
      {
        "x": 284.9999999999991,
        "y": 484.6000000000003,
        "z": 0
      }
    ],
    "handle": "56D",
    "ownerHandle": "1F",
    "layer": "Doc_Sembol_Listesi"
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 282.4999999999991,
        "y": 487.1000000000003,
        "z": 0
      },
      {
        "x": 287.4999999999991,
        "y": 487.1000000000003,
        "z": 0
      }
    ],
    "handle": "56E",
    "ownerHandle": "1F",
    "layer": "Doc_Sembol_Listesi"
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 284.9999999999991,
        "y": 439.5999999999999,
        "z": 0
      },
      {
        "x": 284.9999999999991,
        "y": 434.5999999999999,
        "z": 0
      }
    ],
    "handle": "56F",
    "ownerHandle": "1F",
    "layer": "Doc_Sembol_Listesi"
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 282.4999999999991,
        "y": 437.0999999999999,
        "z": 0
      },
      {
        "x": 287.4999999999991,
        "y": 437.0999999999999,
        "z": 0
      }
    ],
    "handle": "570",
    "ownerHandle": "1F",
    "layer": "Doc_Sembol_Listesi"
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 288.8183766184056,
        "y": 491.1816233815916,
        "z": 0
      },
      {
        "x": 281.1816233815916,
        "y": 498.8183766184065,
        "z": 0
      }
    ],
    "handle": "571",
    "ownerHandle": "1F",
    "layer": "Doc_Sembol_Listesi"
  },
  {
    "type": "MTEXT",
    "handle": "572",
    "ownerHandle": "1F",
    "layer": "Doc_Sembol_Listesi",
    "position": {
      "x": 405,
      "y": 594.9689867876745,
      "z": 0
    },
    "height": 9,
    "width": 190.0007891953712,
    "attachmentPoint": 5,
    "drawingDirection": 5,
    "text": "{\\fVerdana|b1|i0|c162|p34;ARMATÜR}",
    "directionVector": {
      "x": 0.9999999998757351,
      "y": -0.0000157648229072,
      "z": 0
    }
  },
  {
    "type": "MTEXT",
    "handle": "573",
    "ownerHandle": "1F",
    "layer": "Doc_Sembol_Listesi",
    "position": {
      "x": 405,
      "y": 544.9689867876745,
      "z": 0
    },
    "height": 9,
    "width": 190.0007891953712,
    "attachmentPoint": 5,
    "drawingDirection": 5,
    "text": "{\\fVerdana|b1|i0|c162|p34;ETANJ ARMATÜR}",
    "directionVector": {
      "x": 0.9999999998757351,
      "y": -0.0000157648229072,
      "z": 0
    }
  },
  {
    "type": "MTEXT",
    "handle": "574",
    "ownerHandle": "1F",
    "layer": "Doc_Sembol_Listesi",
    "position": {
      "x": 405,
      "y": 494.9689867876745,
      "z": 0
    },
    "height": 9,
    "width": 190.0007891953712,
    "attachmentPoint": 5,
    "drawingDirection": 5,
    "text": "{\\fVerdana|b1|i0|c162|p34;APLİK}",
    "directionVector": {
      "x": 0.9999999998757351,
      "y": -0.0000157648229072,
      "z": 0
    }
  },
  {
    "type": "MTEXT",
    "handle": "575",
    "ownerHandle": "1F",
    "layer": "Doc_Sembol_Listesi",
    "position": {
      "x": 405,
      "y": 444.9689867876745,
      "z": 0
    },
    "height": 9,
    "width": 190.0007891953712,
    "attachmentPoint": 5,
    "drawingDirection": 5,
    "text": "{\\fVerdana|b1|i0|c162|p34;ETANJ APLİK}",
    "directionVector": {
      "x": 0.9999999998757351,
      "y": -0.0000157648229072,
      "z": 0
    }
  },
  {
    "type": "MTEXT",
    "handle": "576",
    "ownerHandle": "1F",
    "layer": "Doc_Sembol_Listesi",
    "position": {
      "x": 405,
      "y": 394.9689867876746,
      "z": 0
    },
    "height": 9,
    "width": 190.0007891953712,
    "attachmentPoint": 5,
    "drawingDirection": 5,
    "text": "{\\fVerdana|b1|i0|c162|p34;LED SPOT}",
    "directionVector": {
      "x": 0.9999999998757351,
      "y": -0.0000157648229072,
      "z": 0
    }
  },
  {
    "type": "MTEXT",
    "handle": "577",
    "ownerHandle": "1F",
    "layer": "Doc_Sembol_Listesi",
    "position": {
      "x": 405,
      "y": 344.9689867876746,
      "z": 0
    },
    "height": 9,
    "width": 190.0007891953712,
    "attachmentPoint": 5,
    "drawingDirection": 5,
    "text": "{\\fVerdana|b1|i0|c162|p34;ETANJ LED SPOT}",
    "directionVector": {
      "x": 0.9999999998757351,
      "y": -0.0000157648229072,
      "z": 0
    }
  },
  {
    "type": "MTEXT",
    "handle": "578",
    "ownerHandle": "1F",
    "layer": "Doc_Sembol_Listesi",
    "position": {
      "x": 405,
      "y": 294.9689867876746,
      "z": 0
    },
    "height": 9,
    "width": 190.0007891953712,
    "attachmentPoint": 5,
    "drawingDirection": 5,
    "text": "{\\fVerdana|b1|i0|c162|p34;HAVUZ TİPİ ARMATÜR}",
    "directionVector": {
      "x": 0.9999999998757351,
      "y": -0.0000157648229072,
      "z": 0
    }
  },
  {
    "type": "MTEXT",
    "handle": "579",
    "ownerHandle": "1F",
    "layer": "Doc_Sembol_Listesi",
    "position": {
      "x": 405,
      "y": 244.9689867876746,
      "z": 0
    },
    "height": 9,
    "width": 190.0007891953712,
    "attachmentPoint": 5,
    "drawingDirection": 5,
    "text": "{\\fVerdana|b1|i0|c162|p34;TABLO ARMATÜRÜ}",
    "directionVector": {
      "x": 0.9999999998757351,
      "y": -0.0000157648229072,
      "z": 0
    }
  },
  {
    "type": "MTEXT",
    "handle": "57A",
    "ownerHandle": "1F",
    "layer": "Doc_Sembol_Listesi",
    "position": {
      "x": 405,
      "y": 194.9689867876745,
      "z": 0
    },
    "height": 9,
    "width": 190.0007891953712,
    "attachmentPoint": 5,
    "drawingDirection": 5,
    "text": "{\\fVerdana|b1|i0|c162|p34;ASMA TİP FLOÜRESAN}",
    "directionVector": {
      "x": 0.9999999998757351,
      "y": -0.0000157648229072,
      "z": 0
    }
  },
  {
    "type": "MTEXT",
    "handle": "57B",
    "ownerHandle": "1F",
    "layer": "Doc_Sembol_Listesi",
    "position": {
      "x": 405,
      "y": 144.9689867876745,
      "z": 0
    },
    "height": 9,
    "width": 190.0007891953712,
    "attachmentPoint": 5,
    "drawingDirection": 5,
    "text": "{\\fVerdana|b1|i0|c162|p34;ASMA TİP ETANJ FLOÜRESAN}",
    "directionVector": {
      "x": 0.9999999998757351,
      "y": -0.0000157648229072,
      "z": 0
    }
  },
  {
    "type": "MTEXT",
    "handle": "57C",
    "ownerHandle": "1F",
    "layer": "Doc_Sembol_Listesi",
    "position": {
      "x": 405,
      "y": 94.96898678767457,
      "z": 0
    },
    "height": 9,
    "width": 190.0007891953712,
    "attachmentPoint": 5,
    "drawingDirection": 5,
    "text": "{\\fVerdana|b1|i0|c162|p34;ASMA TİP LED ARMATÜR}",
    "directionVector": {
      "x": 0.9999999998757351,
      "y": -0.0000157648229071,
      "z": 0
    }
  },
  {
    "type": "MTEXT",
    "handle": "57D",
    "ownerHandle": "1F",
    "layer": "Doc_Sembol_Listesi",
    "position": {
      "x": 405,
      "y": 44.96898678767457,
      "z": 0
    },
    "height": 9,
    "width": 190.0007891953712,
    "attachmentPoint": 5,
    "drawingDirection": 5,
    "text": "{\\fVerdana|b1|i0|c162|p34;ASMA TİP ETANJ ARMATÜR}",
    "directionVector": {
      "x": 0.9999999998757351,
      "y": -0.0000157648229071,
      "z": 0
    }
  },
  {
    "type": "MTEXT",
    "handle": "57E",
    "ownerHandle": "1F",
    "layer": "Doc_Sembol_Listesi",
    "position": {
      "x": 165,
      "y": 244.9689867876746,
      "z": 0
    },
    "height": 9,
    "width": 190.0007891953712,
    "attachmentPoint": 5,
    "drawingDirection": 5,
    "text": "{\\fVerdana|b1|i0|c162|p34;ANA DAĞITIM PANOSU}",
    "directionVector": {
      "x": 0.9999999998757351,
      "y": -0.0000157648229071,
      "z": 0
    }
  },
  {
    "type": "MTEXT",
    "handle": "57F",
    "ownerHandle": "1F",
    "layer": "Doc_Sembol_Listesi",
    "position": {
      "x": 165,
      "y": 194.9689867876745,
      "z": 0
    },
    "height": 9,
    "width": 190.0007891953712,
    "attachmentPoint": 5,
    "drawingDirection": 5,
    "text": "{\\fVerdana|b1|i0|c162|p34;TALİ PANO}",
    "directionVector": {
      "x": 0.9999999998757351,
      "y": -0.0000157648229072,
      "z": 0
    }
  },
  {
    "type": "MTEXT",
    "handle": "580",
    "ownerHandle": "1F",
    "layer": "Doc_Sembol_Listesi",
    "colorIndex": 1,
    "color": 16711680,
    "position": {
      "x": 165,
      "y": 144.9689867876745,
      "z": 0
    },
    "height": 9,
    "width": 190.0007891953712,
    "attachmentPoint": 5,
    "drawingDirection": 5,
    "text": "{\\fVerdana|b1|i0|c162|p34;KUVVET TALİ PANO}",
    "directionVector": {
      "x": 0.9999999998757351,
      "y": -0.0000157648229072,
      "z": 0
    }
  },
  {
    "type": "MTEXT",
    "handle": "581",
    "ownerHandle": "1F",
    "layer": "Doc_Sembol_Listesi",
    "colorIndex": 1,
    "color": 16711680,
    "position": {
      "x": 165,
      "y": 94.96898678767457,
      "z": 0
    },
    "height": 9,
    "width": 190.0007891953712,
    "attachmentPoint": 5,
    "drawingDirection": 5,
    "text": "{\\fVerdana|b1|i0|c162|p34;KUVVET ANA PANO}",
    "directionVector": {
      "x": 0.9999999998757351,
      "y": -0.0000157648229072,
      "z": 0
    }
  },
  {
    "type": "MTEXT",
    "handle": "582",
    "ownerHandle": "1F",
    "layer": "Doc_Sembol_Listesi",
    "position": {
      "x": 165,
      "y": 44.96898678767457,
      "z": 0
    },
    "height": 9,
    "width": 190.0007891953712,
    "attachmentPoint": 5,
    "drawingDirection": 5,
    "text": "{\\fVerdana|b1|i0|c162|p34;KOFRE}",
    "directionVector": {
      "x": 0.9999999998757351,
      "y": -0.0000157648229072,
      "z": 0
    }
  },
  {
    "type": "MTEXT",
    "handle": "583",
    "ownerHandle": "1F",
    "layer": "Doc_Sembol_Listesi",
    "position": {
      "x": 645,
      "y": 244.9689867876746,
      "z": 0
    },
    "height": 9,
    "width": 190.0007891953712,
    "attachmentPoint": 5,
    "drawingDirection": 5,
    "text": "{\\fVerdana|b1|i0|c162|p34;ANAHTAR}",
    "directionVector": {
      "x": 0.9999999998757351,
      "y": -0.0000157648229071,
      "z": 0
    }
  },
  {
    "type": "MTEXT",
    "handle": "584",
    "ownerHandle": "1F",
    "layer": "Doc_Sembol_Listesi",
    "position": {
      "x": 645,
      "y": 194.9689867876745,
      "z": 0
    },
    "height": 9,
    "width": 190.0007891953712,
    "attachmentPoint": 5,
    "drawingDirection": 5,
    "text": "{\\fVerdana|b1|i0|c162|p34;ETANJ ANAHTAR}",
    "directionVector": {
      "x": 0.9999999998757351,
      "y": -0.0000157648229072,
      "z": 0
    }
  },
  {
    "type": "MTEXT",
    "handle": "585",
    "ownerHandle": "1F",
    "layer": "Doc_Sembol_Listesi",
    "position": {
      "x": 645,
      "y": 144.9689867876745,
      "z": 0
    },
    "height": 9,
    "width": 190.0007891953712,
    "attachmentPoint": 5,
    "drawingDirection": 5,
    "text": "{\\fVerdana|b1|i0|c162|p34;KOMÜTATÖR ANAHTAR}",
    "directionVector": {
      "x": 0.9999999998757351,
      "y": -0.0000157648229071,
      "z": 0
    }
  },
  {
    "type": "MTEXT",
    "handle": "586",
    "ownerHandle": "1F",
    "layer": "Doc_Sembol_Listesi",
    "position": {
      "x": 645,
      "y": 94.96898678767457,
      "z": 0
    },
    "height": 9,
    "width": 190.0007891953712,
    "attachmentPoint": 5,
    "drawingDirection": 5,
    "text": "{\\fVerdana|b1|i0|c162|p34;ETANJ KOMÜTATÖR ANAHTAR}",
    "directionVector": {
      "x": 0.9999999998757351,
      "y": -0.0000157648229071,
      "z": 0
    }
  },
  {
    "type": "MTEXT",
    "handle": "587",
    "ownerHandle": "1F",
    "layer": "Doc_Sembol_Listesi",
    "position": {
      "x": 645,
      "y": 44.96898678767457,
      "z": 0
    },
    "height": 9,
    "width": 190.0007891953712,
    "attachmentPoint": 5,
    "drawingDirection": 5,
    "text": "{\\fVerdana|b1|i0|c162|p34;VAVİYEN ANAHTAR}",
    "directionVector": {
      "x": 0.9999999998757351,
      "y": -0.0000157648229072,
      "z": 0
    }
  },
  {
    "type": "MTEXT",
    "handle": "588",
    "ownerHandle": "1F",
    "layer": "Doc_Sembol_Listesi",
    "position": {
      "x": 645,
      "y": 444.9689867876745,
      "z": 0
    },
    "height": 9,
    "width": 190.0007891953712,
    "attachmentPoint": 5,
    "drawingDirection": 5,
    "text": "{\\fVerdana|b1|i0|c162|p34; PRİZ}",
    "directionVector": {
      "x": 0.9999999998757351,
      "y": -0.0000157648229072,
      "z": 0
    }
  },
  {
    "type": "MTEXT",
    "handle": "589",
    "ownerHandle": "1F",
    "layer": "Doc_Sembol_Listesi",
    "position": {
      "x": 645,
      "y": 394.9689867876746,
      "z": 0
    },
    "height": 9,
    "width": 190.0007891953712,
    "attachmentPoint": 5,
    "drawingDirection": 5,
    "text": "\\pt135;{\\fVerdana|b1|i0|c162|p34;ETANJ PRİZ}",
    "directionVector": {
      "x": 0.9999999998757351,
      "y": -0.0000157648229072,
      "z": 0
    }
  },
  {
    "type": "MTEXT",
    "handle": "58A",
    "ownerHandle": "1F",
    "layer": "Doc_Sembol_Listesi",
    "position": {
      "x": 645,
      "y": 344.9689867876746,
      "z": 0
    },
    "height": 9,
    "width": 190.0007891953712,
    "attachmentPoint": 5,
    "drawingDirection": 5,
    "text": "{\\fVerdana|b1|i0|c162|p34;KAPAKLI PRİZ}",
    "directionVector": {
      "x": 0.9999999998757351,
      "y": -0.0000157648229072,
      "z": 0
    }
  },
  {
    "type": "ARC",
    "handle": "58B",
    "ownerHandle": "1F",
    "layer": "Doc_Sembol_Listesi",
    "colorIndex": 1,
    "color": 16711680,
    "center": {
      "x": 524.2607125504746,
      "y": 306,
      "z": 0
    },
    "radius": 7,
    "startAngle": 3.141592653588884,
    "endAngle": 6.283185307178677,
    "angleLength": 3.1415926535897927,
    "extendedData": {
      "applicationName": "AcDbBlockRepETag"
    }
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 524.2607125504691,
        "y": 299,
        "z": 0
      },
      {
        "x": 524.260712550451,
        "y": 278,
        "z": 0
      }
    ],
    "handle": "58C",
    "ownerHandle": "1F",
    "layer": "Doc_Sembol_Listesi",
    "colorIndex": 1,
    "color": 16711680,
    "extendedData": {
      "applicationName": "AcDbBlockRepETag"
    }
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 531.2607125504691,
        "y": 298.9999999999936,
        "z": 0
      },
      {
        "x": 517.2607125504692,
        "y": 299.0000000000064,
        "z": 0
      }
    ],
    "handle": "58D",
    "ownerHandle": "1F",
    "layer": "Doc_Sembol_Listesi",
    "colorIndex": 1,
    "color": 16711680,
    "extendedData": {
      "applicationName": "AcDbBlockRepETag"
    }
  },
  {
    "type": "MTEXT",
    "handle": "58E",
    "ownerHandle": "1F",
    "layer": "Doc_Sembol_Listesi",
    "colorIndex": 1,
    "color": 16711680,
    "position": {
      "x": 517.5933097928191,
      "y": 309.3735736449892,
      "z": 0
    },
    "height": 10,
    "width": 30.20638263841812,
    "attachmentPoint": 5,
    "drawingDirection": 5,
    "text": "{\\fTimes New Roman|b0|i0|c162|p18;3}",
    "directionVector": {
      "x": 1e-16,
      "y": 1,
      "z": 0
    }
  },
  {
    "type": "MTEXT",
    "handle": "590",
    "ownerHandle": "1F",
    "layer": "Doc_Sembol_Listesi",
    "colorIndex": 1,
    "color": 16711680,
    "position": {
      "x": 645,
      "y": 294.9689867876746,
      "z": 0
    },
    "height": 9,
    "width": 190.0007891953712,
    "attachmentPoint": 5,
    "drawingDirection": 5,
    "text": "{\\fVerdana|b1|i0|c162|p34;ÜÇ FAZ PRİZ}",
    "directionVector": {
      "x": 0.9999999998757351,
      "y": -0.0000157648229072,
      "z": 0
    }
  },
  {
    "type": "LWPOLYLINE",
    "vertices": [
      {
        "x": 30.00000000000364,
        "y": 330
      },
      {
        "x": 60.00000000000364,
        "y": 330
      },
      {
        "x": 60.00000000000364,
        "y": 360
      },
      {
        "x": 30.00000000000364,
        "y": 360
      }
    ],
    "handle": "591",
    "ownerHandle": "1F",
    "layer": "Doc_Sembol_Listesi",
    "shape": true,
    "hasContinuousLinetypePattern": false
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 30.00000000000364,
        "y": 355,
        "z": 0
      },
      {
        "x": 60.00000000000364,
        "y": 355,
        "z": 0
      }
    ],
    "handle": "592",
    "ownerHandle": "1F",
    "layer": "Doc_Sembol_Listesi"
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 30.00000000000364,
        "y": 350,
        "z": 0
      },
      {
        "x": 60.00000000000364,
        "y": 350,
        "z": 0
      }
    ],
    "handle": "593",
    "ownerHandle": "1F",
    "layer": "Doc_Sembol_Listesi"
  },
  {
    "type": "MTEXT",
    "handle": "594",
    "ownerHandle": "1F",
    "layer": "Doc_Sembol_Listesi",
    "position": {
      "x": 45.00000000850741,
      "y": 345.0000000001292,
      "z": 0
    },
    "height": 8,
    "width": 30.00000000000006,
    "attachmentPoint": 5,
    "drawingDirection": 5,
    "text": "{\\fTimes New Roman|b0|i0|c162|p18;Wh}"
  },
  {
    "type": "LWPOLYLINE",
    "vertices": [
      {
        "x": 30.00000000749969,
        "y": 379.9999999994479
      },
      {
        "x": 60.00000000749969,
        "y": 379.9999999994479
      },
      {
        "x": 60.00000000749969,
        "y": 409.9999999994479
      },
      {
        "x": 30.00000000749969,
        "y": 409.9999999994479
      }
    ],
    "handle": "595",
    "ownerHandle": "1F",
    "layer": "Doc_Sembol_Listesi",
    "shape": true,
    "hasContinuousLinetypePattern": false
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 30.00000000749969,
        "y": 404.9999999994479,
        "z": 0
      },
      {
        "x": 60.00000000749969,
        "y": 404.9999999994479,
        "z": 0
      }
    ],
    "handle": "596",
    "ownerHandle": "1F",
    "layer": "Doc_Sembol_Listesi"
  },
  {
    "type": "MTEXT",
    "handle": "597",
    "ownerHandle": "1F",
    "layer": "Doc_Sembol_Listesi",
    "position": {
      "x": 45.00000001600528,
      "y": 394.9999999995771,
      "z": 0
    },
    "height": 8,
    "width": 30.00000000000006,
    "attachmentPoint": 5,
    "drawingDirection": 5,
    "text": "{\\fTimes New Roman|b0|i0|c162|p18;Wh}"
  },
  {
    "type": "LWPOLYLINE",
    "vertices": [
      {
        "x": 30,
        "y": 280
      },
      {
        "x": 60,
        "y": 280
      },
      {
        "x": 60,
        "y": 310
      },
      {
        "x": 30,
        "y": 310
      }
    ],
    "handle": "598",
    "ownerHandle": "1F",
    "layer": "Doc_Sembol_Listesi",
    "shape": true,
    "hasContinuousLinetypePattern": false
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 30,
        "y": 305,
        "z": 0
      },
      {
        "x": 60,
        "y": 305,
        "z": 0
      }
    ],
    "handle": "599",
    "ownerHandle": "1F",
    "layer": "Doc_Sembol_Listesi"
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 30,
        "y": 300,
        "z": 0
      },
      {
        "x": 60,
        "y": 300,
        "z": 0
      }
    ],
    "handle": "59A",
    "ownerHandle": "1F",
    "layer": "Doc_Sembol_Listesi"
  },
  {
    "type": "MTEXT",
    "handle": "59B",
    "ownerHandle": "1F",
    "layer": "Doc_Sembol_Listesi",
    "position": {
      "x": 45.00000000850377,
      "y": 295.000000000131,
      "z": 0
    },
    "height": 9,
    "width": 190.0007891953712,
    "attachmentPoint": 5,
    "drawingDirection": 5,
    "text": "{\\fTimes New Roman|b0|i0|c162|p18;Var}",
    "directionVector": {
      "x": 0.9999999998757351,
      "y": -0.0000157648229071,
      "z": 0
    }
  },
  {
    "type": "MTEXT",
    "handle": "59C",
    "ownerHandle": "1F",
    "layer": "Doc_Sembol_Listesi",
    "position": {
      "x": 165,
      "y": 294.9689867876746,
      "z": 0
    },
    "height": 9,
    "width": 190.0007891953712,
    "attachmentPoint": 5,
    "drawingDirection": 5,
    "text": "{\\fVerdana|b1|i0|c162|p34;REAKTİF SAYAÇ}",
    "directionVector": {
      "x": 0.9999999998757351,
      "y": -0.0000157648229072,
      "z": 0
    }
  },
  {
    "type": "MTEXT",
    "handle": "59D",
    "ownerHandle": "1F",
    "layer": "Doc_Sembol_Listesi",
    "position": {
      "x": 165,
      "y": 344.9689867876746,
      "z": 0
    },
    "height": 9,
    "width": 190.0007891953712,
    "attachmentPoint": 5,
    "drawingDirection": 5,
    "text": "{\\fVerdana|b1|i0|c162|p34;ÜÇ FAZ SAYAÇ}",
    "directionVector": {
      "x": 0.9999999998757351,
      "y": -0.0000157648229072,
      "z": 0
    }
  },
  {
    "type": "MTEXT",
    "handle": "59E",
    "ownerHandle": "1F",
    "layer": "Doc_Sembol_Listesi",
    "position": {
      "x": 165,
      "y": 394.9689867876746,
      "z": 0
    },
    "height": 9,
    "width": 190.0007891953712,
    "attachmentPoint": 5,
    "drawingDirection": 5,
    "text": "{\\fVerdana|b1|i0|c162|p34;TEK FAZ SAYAÇ}",
    "directionVector": {
      "x": 0.9999999998757351,
      "y": -0.0000157648229072,
      "z": 0
    }
  },
  {
    "type": "MTEXT",
    "handle": "59F",
    "ownerHandle": "1F",
    "layer": "Doc_Sembol_Listesi",
    "position": {
      "x": 645,
      "y": 944.9689867876745,
      "z": 0
    },
    "height": 9,
    "width": 190.0007891953712,
    "attachmentPoint": 5,
    "drawingDirection": 5,
    "text": "{\\fVerdana|b1|i0|c162|p34;ÇAMAŞIR MAKİNASI}",
    "directionVector": {
      "x": 0.9999999998757351,
      "y": -0.0000157648229072,
      "z": 0
    }
  },
  {
    "type": "MTEXT",
    "handle": "5A0",
    "ownerHandle": "1F",
    "layer": "Doc_Sembol_Listesi",
    "position": {
      "x": 645,
      "y": 894.968986787674,
      "z": 0
    },
    "height": 9,
    "width": 190.0007891953712,
    "attachmentPoint": 5,
    "drawingDirection": 5,
    "text": "{\\fVerdana|b1|i0|c162|p34;BULAŞIK MAKİNASI}",
    "directionVector": {
      "x": 0.9999999998757351,
      "y": -0.0000157648229072,
      "z": 0
    }
  },
  {
    "type": "MTEXT",
    "handle": "5A1",
    "ownerHandle": "1F",
    "layer": "Doc_Sembol_Listesi",
    "position": {
      "x": 645,
      "y": 844.9689867876745,
      "z": 0
    },
    "height": 9,
    "width": 190.0007891953712,
    "attachmentPoint": 5,
    "drawingDirection": 5,
    "text": "{\\fVerdana|b1|i0|c162|p34;FIRIN}",
    "directionVector": {
      "x": 0.9999999998757351,
      "y": -0.0000157648229072,
      "z": 0
    }
  },
  {
    "type": "MTEXT",
    "handle": "5A2",
    "ownerHandle": "1F",
    "layer": "Doc_Sembol_Listesi",
    "position": {
      "x": 645,
      "y": 794.9689867876745,
      "z": 0
    },
    "height": 9,
    "width": 190.0007891953712,
    "attachmentPoint": 5,
    "drawingDirection": 5,
    "text": "{\\fVerdana|b1|i0|c162|p34;KLİMA}",
    "directionVector": {
      "x": 0.9999999998757351,
      "y": -0.0000157648229072,
      "z": 0
    }
  },
  {
    "type": "MTEXT",
    "handle": "5A3",
    "ownerHandle": "1F",
    "layer": "Doc_Sembol_Listesi",
    "colorIndex": 1,
    "color": 16711680,
    "position": {
      "x": 645,
      "y": 744.9689867876745,
      "z": 0
    },
    "height": 9,
    "width": 190.0007891953712,
    "attachmentPoint": 5,
    "drawingDirection": 5,
    "text": "{\\fVerdana|b1|i0|c162|p34;OCAK}",
    "directionVector": {
      "x": 0.9999999998757351,
      "y": -0.0000157648229072,
      "z": 0
    }
  },
  {
    "type": "MTEXT",
    "handle": "5A4",
    "ownerHandle": "1F",
    "layer": "Doc_Sembol_Listesi",
    "colorIndex": 1,
    "color": 16711680,
    "position": {
      "x": 645,
      "y": 694.9689867876745,
      "z": 0
    },
    "height": 9,
    "width": 190.0007891953712,
    "attachmentPoint": 5,
    "drawingDirection": 5,
    "text": "{\\fVerdana|b1|i0|c162|p34;BUZ DOLABI}",
    "directionVector": {
      "x": 0.9999999998757351,
      "y": -0.0000157648229072,
      "z": 0
    }
  },
  {
    "type": "MTEXT",
    "handle": "5A5",
    "ownerHandle": "1F",
    "layer": "Doc_Sembol_Listesi",
    "position": {
      "x": 645,
      "y": 644.9689867876745,
      "z": 0
    },
    "height": 9,
    "width": 190.0007891953712,
    "attachmentPoint": 5,
    "drawingDirection": 5,
    "text": "{\\fVerdana|b1|i0|c162|p34;MOTOR}",
    "directionVector": {
      "x": 0.9999999998757351,
      "y": -0.0000157648229072,
      "z": 0
    }
  },
  {
    "type": "MTEXT",
    "handle": "5A6",
    "ownerHandle": "1F",
    "layer": "Doc_Sembol_Listesi",
    "position": {
      "x": 645,
      "y": 594.9689867876745,
      "z": 0
    },
    "height": 9,
    "width": 190.0007891953712,
    "attachmentPoint": 5,
    "drawingDirection": 5,
    "text": "{\\fVerdana|b1|i0|c162|p34;FAN}",
    "directionVector": {
      "x": 0.9999999998757351,
      "y": -0.0000157648229072,
      "z": 0
    }
  },
  {
    "type": "MTEXT",
    "handle": "5A7",
    "ownerHandle": "1F",
    "layer": "Doc_Sembol_Listesi",
    "position": {
      "x": 645,
      "y": 544.9689867876745,
      "z": 0
    },
    "height": 9,
    "width": 190.0007891953712,
    "attachmentPoint": 5,
    "drawingDirection": 5,
    "text": "{\\fVerdana|b1|i0|c162|p34;HİDROFOR}",
    "directionVector": {
      "x": 0.9999999998757351,
      "y": -0.0000157648229072,
      "z": 0
    }
  },
  {
    "type": "MTEXT",
    "handle": "5A8",
    "ownerHandle": "1F",
    "layer": "Doc_Sembol_Listesi",
    "position": {
      "x": 645,
      "y": 494.9689867876745,
      "z": 0
    },
    "height": 9,
    "width": 190.0007891953712,
    "attachmentPoint": 5,
    "drawingDirection": 5,
    "text": "{\\fVerdana|b1|i0|c162|p34;GENERATÖR}",
    "directionVector": {
      "x": 0.9999999998757351,
      "y": -0.0000157648229072,
      "z": 0
    }
  },
  {
    "type": "LWPOLYLINE",
    "vertices": [
      {
        "x": 507.5031355668397,
        "y": 982.6770475548029
      },
      {
        "x": 542.4999999999945,
        "y": 982.4999999999981
      },
      {
        "x": 542.4999999999945,
        "y": 1007.499999999998
      },
      {
        "x": 507.5031355668397,
        "y": 1007.677047554803
      }
    ],
    "handle": "5A9",
    "ownerHandle": "1F",
    "layer": "Doc_Sembol_Listesi",
    "shape": true,
    "hasContinuousLinetypePattern": false
  },
  {
    "type": "MTEXT",
    "handle": "5AA",
    "ownerHandle": "1F",
    "layer": "Doc_Sembol_Listesi",
    "position": {
      "x": 645,
      "y": 994.9689867876745,
      "z": 0
    },
    "height": 9,
    "width": 190.0007891953712,
    "attachmentPoint": 5,
    "drawingDirection": 5,
    "text": "{\\fVerdana|b1|i0|c162|p34;CİHAZ GENEL GÖSTERİM}",
    "directionVector": {
      "x": 0.9999999998757351,
      "y": -0.0000157648229072,
      "z": 0
    }
  },
  {
    "type": "MTEXT",
    "handle": "5AB",
    "ownerHandle": "1F",
    "layer": "Doc_Sembol_Listesi",
    "position": {
      "x": 524.9999999999945,
      "y": 994.9999999999981,
      "z": 0
    },
    "height": 6,
    "width": 24.99999999999983,
    "attachmentPoint": 5,
    "drawingDirection": 5,
    "text": "{\\fTimes New Roman|b0|i0|c162|p18;CİHAZ}"
  },
  {
    "type": "LWPOLYLINE",
    "vertices": [
      {
        "x": 37.5,
        "y": 537.5
      },
      {
        "x": 52.5,
        "y": 537.5
      },
      {
        "x": 52.5,
        "y": 552.5
      },
      {
        "x": 37.5,
        "y": 552.5
      }
    ],
    "handle": "5AD",
    "ownerHandle": "1F",
    "layer": "Doc_Sembol_Listesi",
    "shape": true,
    "hasContinuousLinetypePattern": false
  },
  {
    "type": "MTEXT",
    "handle": "5AE",
    "ownerHandle": "1F",
    "layer": "Doc_Sembol_Listesi",
    "position": {
      "x": 45,
      "y": 545,
      "z": 0
    },
    "height": 5,
    "width": 100,
    "attachmentPoint": 5,
    "drawingDirection": 5,
    "text": "{\\fTimes New Roman|b0|i0|c162|p18;BOX}"
  },
  {
    "type": "LWPOLYLINE",
    "vertices": [
      {
        "x": 37.50000000013188,
        "y": 487.5000000001636
      },
      {
        "x": 52.50000000013187,
        "y": 487.5000000001636
      },
      {
        "x": 52.50000000013187,
        "y": 502.5000000001637
      },
      {
        "x": 37.50000000013188,
        "y": 502.5000000001637
      }
    ],
    "handle": "5AF",
    "ownerHandle": "1F",
    "layer": "Doc_Sembol_Listesi",
    "shape": true,
    "hasContinuousLinetypePattern": false
  },
  {
    "type": "MTEXT",
    "handle": "5B0",
    "ownerHandle": "1F",
    "layer": "Doc_Sembol_Listesi",
    "position": {
      "x": 45.00000000013187,
      "y": 495.0000000001637,
      "z": 0
    },
    "height": 4,
    "width": 15.00000000000003,
    "attachmentPoint": 5,
    "drawingDirection": 5,
    "text": "{\\fTimes New Roman|b0|i0|c162|p18;Direk}"
  },
  {
    "type": "CIRCLE",
    "handle": "5B1",
    "ownerHandle": "1F",
    "layer": "Doc_Sembol_Listesi",
    "center": {
      "x": 45,
      "y": 445,
      "z": 0
    },
    "radius": 7.50000000426462
  },
  {
    "type": "MTEXT",
    "handle": "5B2",
    "ownerHandle": "1F",
    "layer": "Doc_Sembol_Listesi",
    "position": {
      "x": 45.00000000426462,
      "y": 444.9999999999991,
      "z": 0
    },
    "height": 4,
    "width": 15.00000000000003,
    "attachmentPoint": 5,
    "drawingDirection": 5,
    "text": "{\\fTimes New Roman|b0|i0|c162|p18;Direk}"
  },
  {
    "type": "MTEXT",
    "handle": "5B3",
    "ownerHandle": "1F",
    "layer": "Doc_Sembol_Listesi",
    "position": {
      "x": 165,
      "y": 544.9689867876745,
      "z": 0
    },
    "height": 9,
    "width": 190.0007891953712,
    "attachmentPoint": 5,
    "drawingDirection": 5,
    "text": "{\\fVerdana|b1|i0|c162|p34;ŞEBEKE DAĞITIM KUTUSU}",
    "directionVector": {
      "x": 0.9999999998757351,
      "y": -0.0000157648229072,
      "z": 0
    }
  },
  {
    "type": "MTEXT",
    "handle": "5B4",
    "ownerHandle": "1F",
    "layer": "Doc_Sembol_Listesi",
    "position": {
      "x": 165,
      "y": 494.9689867876745,
      "z": 0
    },
    "height": 9,
    "width": 190.0007891953712,
    "attachmentPoint": 5,
    "drawingDirection": 5,
    "text": "{\\fVerdana|b1|i0|c162|p34;ŞEBEKE DEMiR DİREĞİ}",
    "directionVector": {
      "x": 0.9999999998757351,
      "y": -0.0000157648229072,
      "z": 0
    }
  },
  {
    "type": "MTEXT",
    "handle": "5B5",
    "ownerHandle": "1F",
    "layer": "Doc_Sembol_Listesi",
    "position": {
      "x": 165,
      "y": 444.9689867876745,
      "z": 0
    },
    "height": 9,
    "width": 190.0007891953712,
    "attachmentPoint": 5,
    "drawingDirection": 5,
    "text": "{\\fVerdana|b1|i0|c162|p34;ŞEBEKE AĞAÇ-BETON DİREK}",
    "directionVector": {
      "x": 0.9999999998757351,
      "y": -0.0000157648229072,
      "z": 0
    }
  },
  {
    "type": "MTEXT",
    "handle": "5B6",
    "ownerHandle": "1F",
    "layer": "Doc_Sembol_Listesi",
    "position": {
      "x": 405,
      "y": 994.9689867876745,
      "z": 0
    },
    "height": 9,
    "width": 190.0007891953712,
    "attachmentPoint": 5,
    "drawingDirection": 5,
    "text": "\\pt135;{\\fVerdana|b1|i0|c162|p34;1 ve 3 FAZ ANAHTARLI OTOMATİK SİGORTA}",
    "directionVector": {
      "x": 0.9999999998757351,
      "y": -0.0000157648229072,
      "z": 0
    }
  },
  {
    "type": "MTEXT",
    "handle": "5B7",
    "ownerHandle": "1F",
    "layer": "Doc_Sembol_Listesi",
    "position": {
      "x": 405,
      "y": 944.9689867876745,
      "z": 0
    },
    "height": 9,
    "width": 190.0007891953712,
    "attachmentPoint": 5,
    "drawingDirection": 5,
    "text": "\\pt135;{\\fVerdana|b1|i0|c162|p34;1 ve 3 FAZ BIÇAKLI SİGORTA}",
    "directionVector": {
      "x": 0.9999999998757351,
      "y": -0.0000157648229072,
      "z": 0
    }
  },
  {
    "type": "LWPOLYLINE",
    "vertices": [
      {
        "x": 767.4999999999999,
        "y": 350
      },
      {
        "x": 752.5,
        "y": 350
      },
      {
        "x": 752.5,
        "y": 340
      },
      {
        "x": 777.5,
        "y": 340
      },
      {
        "x": 767.4999999999999,
        "y": 350
      },
      {
        "x": 767.4999999999999,
        "y": 340
      }
    ],
    "handle": "5B8",
    "ownerHandle": "1F",
    "layer": "Doc_Sembol_Listesi",
    "colorIndex": 1,
    "color": 16711680,
    "shape": false,
    "hasContinuousLinetypePattern": false
  },
  {
    "type": "MTEXT",
    "handle": "5B9",
    "ownerHandle": "1F",
    "layer": "Doc_Sembol_Listesi",
    "colorIndex": 1,
    "color": 16711680,
    "position": {
      "x": 760,
      "y": 345,
      "z": 0
    },
    "height": 5.14437347300571,
    "width": 15.00015764636491,
    "attachmentPoint": 5,
    "drawingDirection": 5,
    "text": "{\\fVerdana|b1|i0|c0|p34;KO}",
    "directionVector": {
      "x": 0.9999999998757351,
      "y": -0.0000157648229072,
      "z": 0
    }
  },
  {
    "type": "LWPOLYLINE",
    "vertices": [
      {
        "x": 760,
        "y": 290
      },
      {
        "x": 770,
        "y": 290
      },
      {
        "x": 770,
        "y": 300
      },
      {
        "x": 760,
        "y": 300
      }
    ],
    "handle": "5BA",
    "ownerHandle": "1F",
    "layer": "Doc_Sembol_Listesi",
    "colorIndex": 1,
    "color": 16711680,
    "shape": true,
    "hasContinuousLinetypePattern": false
  },
  {
    "type": "CIRCLE",
    "handle": "5BB",
    "ownerHandle": "1F",
    "layer": "Doc_Sembol_Listesi",
    "colorIndex": 1,
    "color": 16711680,
    "center": {
      "x": 765,
      "y": 295,
      "z": 0
    },
    "radius": 4
  },
  {
    "type": "LWPOLYLINE",
    "vertices": [
      {
        "x": 750,
        "y": 440
      },
      {
        "x": 780,
        "y": 440
      },
      {
        "x": 780,
        "y": 450
      },
      {
        "x": 750,
        "y": 450
      }
    ],
    "handle": "5BC",
    "ownerHandle": "1F",
    "layer": "Doc_Sembol_Listesi",
    "colorIndex": 1,
    "color": 16711680,
    "shape": true,
    "hasContinuousLinetypePattern": false
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 760,
        "y": 450,
        "z": 0
      },
      {
        "x": 759.9998423516499,
        "y": 440.0000000024852,
        "z": 0
      }
    ],
    "handle": "5BD",
    "ownerHandle": "1F",
    "layer": "Doc_Sembol_Listesi",
    "colorIndex": 1,
    "color": 16711680
  },
  {
    "type": "CIRCLE",
    "handle": "5BE",
    "ownerHandle": "1F",
    "layer": "Doc_Sembol_Listesi",
    "colorIndex": 1,
    "color": 16711680,
    "center": {
      "x": 754.9999999990413,
      "y": 445,
      "z": 0
    },
    "radius": 4
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 765,
        "y": 485,
        "z": 0
      },
      {
        "x": 765,
        "y": 505,
        "z": 0
      }
    ],
    "handle": "5BF",
    "ownerHandle": "1F",
    "layer": "Doc_Sembol_Listesi",
    "colorIndex": 1,
    "color": 16711680
  },
  {
    "type": "ARC",
    "handle": "5C0",
    "ownerHandle": "1F",
    "layer": "Doc_Sembol_Listesi",
    "colorIndex": 1,
    "color": 16711680,
    "center": {
      "x": 765,
      "y": 495,
      "z": 0
    },
    "radius": 10,
    "startAngle": 4.71238898038469,
    "endAngle": 1.5707963267948966,
    "angleLength": -3.141592653589793
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 765,
        "y": 495,
        "z": 0
      },
      {
        "x": 755,
        "y": 495,
        "z": 0
      }
    ],
    "handle": "5C1",
    "ownerHandle": "1F",
    "layer": "Doc_Sembol_Listesi",
    "colorIndex": 1,
    "color": 16711680
  },
  {
    "type": "LWPOLYLINE",
    "vertices": [
      {
        "x": 769.8136696895671,
        "y": 488.4167875194398
      },
      {
        "x": 767.8152813270135,
        "y": 489.7007609789143
      },
      {
        "x": 767.8152813270135,
        "y": 493.0770888555125
      },
      {
        "x": 770.5749893486063,
        "y": 495.3596532100637
      },
      {
        "x": 770.5749893486063,
        "y": 498.4031024198047
      },
      {
        "x": 767.8152813270135,
        "y": 500.5905843583969
      }
    ],
    "handle": "5C2",
    "ownerHandle": "1F",
    "layer": "Doc_Sembol_Listesi",
    "colorIndex": 1,
    "color": 16711680,
    "shape": false,
    "hasContinuousLinetypePattern": false
  },
  {
    "type": "CIRCLE",
    "handle": "5C3",
    "ownerHandle": "1F",
    "layer": "Doc_Sembol_Listesi",
    "colorIndex": 1,
    "color": 16711680,
    "center": {
      "x": 763.0000000000381,
      "y": 395,
      "z": 0
    },
    "radius": 4
  },
  {
    "type": "CIRCLE",
    "handle": "5C4",
    "ownerHandle": "1F",
    "layer": "Doc_Sembol_Listesi",
    "colorIndex": 1,
    "color": 16711680,
    "center": {
      "x": 767.0000000000381,
      "y": 395,
      "z": 0
    },
    "radius": 4
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 771.0000000000381,
        "y": 395,
        "z": 0
      },
      {
        "x": 776.0000000000382,
        "y": 395,
        "z": 0
      }
    ],
    "handle": "5C5",
    "ownerHandle": "1F",
    "layer": "Doc_Sembol_Listesi",
    "colorIndex": 1,
    "color": 16711680
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 759.0000000000381,
        "y": 395,
        "z": 0
      },
      {
        "x": 754.0000000000381,
        "y": 395,
        "z": 0
      }
    ],
    "handle": "5C6",
    "ownerHandle": "1F",
    "layer": "Doc_Sembol_Listesi",
    "colorIndex": 1,
    "color": 16711680
  },
  {
    "type": "LWPOLYLINE",
    "vertices": [
      {
        "x": 757.5,
        "y": 235
      },
      {
        "x": 772.5,
        "y": 235
      },
      {
        "x": 772.5,
        "y": 255
      },
      {
        "x": 757.5,
        "y": 255
      }
    ],
    "handle": "5C7",
    "ownerHandle": "1F",
    "layer": "Doc_Sembol_Listesi",
    "colorIndex": 1,
    "color": 16711680,
    "shape": true,
    "hasContinuousLinetypePattern": false
  },
  {
    "type": "LWPOLYLINE",
    "vertices": [
      {
        "x": 760,
        "y": 244.5
      },
      {
        "x": 770,
        "y": 244.5
      },
      {
        "x": 770,
        "y": 252.5
      },
      {
        "x": 760,
        "y": 252.5
      }
    ],
    "handle": "5C8",
    "ownerHandle": "1F",
    "layer": "Doc_Sembol_Listesi",
    "colorIndex": 1,
    "color": 16711680,
    "shape": true,
    "hasContinuousLinetypePattern": false
  },
  {
    "type": "CIRCLE",
    "handle": "5C9",
    "ownerHandle": "1F",
    "layer": "Doc_Sembol_Listesi",
    "colorIndex": 1,
    "color": 16711680,
    "center": {
      "x": 765,
      "y": 242,
      "z": 0
    },
    "radius": 1.5
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 760,
        "y": 239.5,
        "z": 0
      },
      {
        "x": 770,
        "y": 239.5,
        "z": 0
      }
    ],
    "handle": "5CA",
    "ownerHandle": "1F",
    "layer": "Doc_Sembol_Listesi",
    "colorIndex": 1,
    "color": 16711680
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 760,
        "y": 238,
        "z": 0
      },
      {
        "x": 770,
        "y": 238,
        "z": 0
      }
    ],
    "handle": "5CB",
    "ownerHandle": "1F",
    "layer": "Doc_Sembol_Listesi",
    "colorIndex": 1,
    "color": 16711680
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 760,
        "y": 236.5,
        "z": 0
      },
      {
        "x": 770,
        "y": 236.5,
        "z": 0
      }
    ],
    "handle": "5CC",
    "ownerHandle": "1F",
    "layer": "Doc_Sembol_Listesi",
    "colorIndex": 1,
    "color": 16711680
  },
  {
    "type": "MTEXT",
    "handle": "5CD",
    "ownerHandle": "1F",
    "layer": "Doc_Sembol_Listesi",
    "colorIndex": 1,
    "color": 16711680,
    "position": {
      "x": 885,
      "y": 244.9689867876746,
      "z": 0
    },
    "height": 9,
    "width": 190.0007891953712,
    "attachmentPoint": 5,
    "drawingDirection": 5,
    "text": "{\\fVerdana|b1|i0|c162|p34;İNTERKON}",
    "directionVector": {
      "x": 0.9999999998757351,
      "y": -0.0000157648229072,
      "z": 0
    }
  },
  {
    "type": "LWPOLYLINE",
    "vertices": [
      {
        "x": 752.5,
        "y": 190
      },
      {
        "x": 767.500157644501,
        "y": 190
      },
      {
        "x": 767.500157644501,
        "y": 199.9997635251711
      },
      {
        "x": 752.5,
        "y": 199.9997635251711
      }
    ],
    "handle": "5CE",
    "ownerHandle": "1F",
    "layer": "Doc_Sembol_Listesi",
    "colorIndex": 1,
    "color": 16711680,
    "shape": true,
    "hasContinuousLinetypePattern": false
  },
  {
    "type": "ARC",
    "handle": "5CF",
    "ownerHandle": "1F",
    "layer": "Doc_Sembol_Listesi",
    "colorIndex": 1,
    "color": 16711680,
    "center": {
      "x": 767.500157644501,
      "y": 194.9998817625855,
      "z": 0
    },
    "radius": 4.999881762585545,
    "startAngle": 4.71238898038469,
    "endAngle": 1.5707963267948966,
    "angleLength": -3.141592653589793
  },
  {
    "type": "MTEXT",
    "handle": "5D0",
    "ownerHandle": "1F",
    "layer": "Doc_Sembol_Listesi",
    "colorIndex": 1,
    "color": 16711680,
    "position": {
      "x": 760,
      "y": 195,
      "z": 0
    },
    "height": 5.14437347300571,
    "width": 15.00015764636491,
    "attachmentPoint": 5,
    "drawingDirection": 5,
    "text": "{\\fVerdana|b1|i0|c0|p34;KO}",
    "directionVector": {
      "x": 0.9999999998757351,
      "y": -0.0000157648229072,
      "z": 0
    }
  },
  {
    "type": "LWPOLYLINE",
    "vertices": [
      {
        "x": 760,
        "y": 142.5
      },
      {
        "x": 760,
        "y": 137.5
      },
      {
        "x": 770,
        "y": 137.5
      },
      {
        "x": 770,
        "y": 142.5
      },
      {
        "x": 760,
        "y": 142.5
      },
      {
        "x": 752.5,
        "y": 152.5
      },
      {
        "x": 777.5,
        "y": 152.5
      },
      {
        "x": 770,
        "y": 142.5
      }
    ],
    "handle": "5D1",
    "ownerHandle": "1F",
    "layer": "Doc_Sembol_Listesi",
    "colorIndex": 1,
    "color": 16711680,
    "shape": false,
    "hasContinuousLinetypePattern": false
  },
  {
    "type": "MTEXT",
    "handle": "5D2",
    "ownerHandle": "1F",
    "layer": "Doc_Sembol_Listesi",
    "colorIndex": 1,
    "color": 16711680,
    "position": {
      "x": 885,
      "y": 194.9689867876745,
      "z": 0
    },
    "height": 9,
    "width": 190.0007891953712,
    "attachmentPoint": 5,
    "drawingDirection": 5,
    "text": "{\\fVerdana|b1|i0|c162|p34;MERDİVEN OTOMATI}",
    "directionVector": {
      "x": 0.9999999998757351,
      "y": -0.0000157648229072,
      "z": 0
    }
  },
  {
    "type": "MTEXT",
    "handle": "5D3",
    "ownerHandle": "1F",
    "layer": "Doc_Sembol_Listesi",
    "colorIndex": 1,
    "color": 16711680,
    "position": {
      "x": 885,
      "y": 144.9689867876745,
      "z": 0
    },
    "height": 9,
    "width": 190.0007891953712,
    "attachmentPoint": 5,
    "drawingDirection": 5,
    "text": "{\\fVerdana|b1|i0|c162|p34;HOPARLÖR}",
    "directionVector": {
      "x": 0.9999999998757351,
      "y": -0.0000157648229072,
      "z": 0
    }
  },
  {
    "type": "MTEXT",
    "handle": "5D4",
    "ownerHandle": "1F",
    "layer": "Doc_Sembol_Listesi",
    "colorIndex": 1,
    "color": 16711680,
    "position": {
      "x": 885,
      "y": 294.9689867876746,
      "z": 0
    },
    "height": 9,
    "width": 190.0007891953712,
    "attachmentPoint": 5,
    "drawingDirection": 5,
    "text": "{\\fVerdana|b1|i0|c162|p34;KAPI OTOMAT BUTONU}",
    "directionVector": {
      "x": 0.9999999998757351,
      "y": -0.0000157648229072,
      "z": 0
    }
  },
  {
    "type": "MTEXT",
    "handle": "5D5",
    "ownerHandle": "1F",
    "layer": "Doc_Sembol_Listesi",
    "colorIndex": 1,
    "color": 16711680,
    "position": {
      "x": 885,
      "y": 344.9689867876746,
      "z": 0
    },
    "height": 9,
    "width": 190.0007891953712,
    "attachmentPoint": 5,
    "drawingDirection": 5,
    "text": "{\\fVerdana|b1|i0|c162|p34;KAPI OTOMATI}",
    "directionVector": {
      "x": 0.9999999998757351,
      "y": -0.0000157648229072,
      "z": 0
    }
  },
  {
    "type": "MTEXT",
    "handle": "5D6",
    "ownerHandle": "1F",
    "layer": "Doc_Sembol_Listesi",
    "colorIndex": 1,
    "color": 16711680,
    "position": {
      "x": 885,
      "y": 394.9689867876746,
      "z": 0
    },
    "height": 9,
    "width": 190.0007891953712,
    "attachmentPoint": 5,
    "drawingDirection": 5,
    "text": "{\\fVerdana|b1|i0|c162|p34;ZİL TRAFOSU}",
    "directionVector": {
      "x": 0.9999999998757351,
      "y": -0.0000157648229072,
      "z": 0
    }
  },
  {
    "type": "MTEXT",
    "handle": "5D7",
    "ownerHandle": "1F",
    "layer": "Doc_Sembol_Listesi",
    "colorIndex": 1,
    "color": 16711680,
    "position": {
      "x": 885,
      "y": 444.9689867876745,
      "z": 0
    },
    "height": 9,
    "width": 190.0007891953712,
    "attachmentPoint": 5,
    "drawingDirection": 5,
    "text": "{\\fVerdana|b1|i0|c162|p34;ZİL BUTONU}",
    "directionVector": {
      "x": 0.9999999998757351,
      "y": -0.0000157648229072,
      "z": 0
    }
  },
  {
    "type": "MTEXT",
    "handle": "5D8",
    "ownerHandle": "1F",
    "layer": "Doc_Sembol_Listesi",
    "colorIndex": 1,
    "color": 16711680,
    "position": {
      "x": 885,
      "y": 494.9689867876745,
      "z": 0
    },
    "height": 9,
    "width": 190.0007891953712,
    "attachmentPoint": 5,
    "drawingDirection": 5,
    "text": "{\\fVerdana|b1|i0|c162|p34;ZİL}",
    "directionVector": {
      "x": 0.9999999998757351,
      "y": -0.0000157648229072,
      "z": 0
    }
  },
  {
    "type": "LWPOLYLINE",
    "vertices": [
      {
        "x": 747.8228795489485,
        "y": 81.40913799607188
      },
      {
        "x": 757.8228795489485,
        "y": 98.72964607176051
      },
      {
        "x": 759.9879430584097,
        "y": 97.47964607176051
      },
      {
        "x": 760.8228795489485,
        "y": 103.925798494467
      },
      {
        "x": 755.6578160394874,
        "y": 99.97964607176051
      },
      {
        "x": 757.8228795489485,
        "y": 98.72964607176051
      }
    ],
    "handle": "5DA",
    "ownerHandle": "1F",
    "layer": "Doc_Sembol_Listesi",
    "colorIndex": 1,
    "color": 16711680,
    "shape": false,
    "hasContinuousLinetypePattern": false
  },
  {
    "type": "CIRCLE",
    "handle": "5DC",
    "ownerHandle": "1F",
    "layer": "Doc_Sembol_Listesi",
    "colorIndex": 1,
    "color": 16711680,
    "center": {
      "x": 762.0728795489485,
      "y": 106.0908620039281,
      "z": 0
    },
    "radius": 2.500000000000028
  },
  {
    "type": "LWPOLYLINE",
    "vertices": [
      {
        "x": 783.5162552219208,
        "y": 108.5908620039281
      },
      {
        "x": 773.5162552219226,
        "y": 91.2703539282395
      },
      {
        "x": 771.3511917124614,
        "y": 92.5203539282395
      },
      {
        "x": 770.5162552219226,
        "y": 86.07420150553298
      },
      {
        "x": 775.6813187313837,
        "y": 90.0203539282395
      },
      {
        "x": 773.5162552219226,
        "y": 91.2703539282395
      }
    ],
    "handle": "5DE",
    "ownerHandle": "1F",
    "layer": "Doc_Sembol_Listesi",
    "colorIndex": 1,
    "color": 16711680,
    "shape": false,
    "hasContinuousLinetypePattern": false
  },
  {
    "type": "CIRCLE",
    "handle": "5E0",
    "ownerHandle": "1F",
    "layer": "Doc_Sembol_Listesi",
    "colorIndex": 1,
    "color": 16711680,
    "center": {
      "x": 769.2662552219226,
      "y": 83.90913799607188,
      "z": 0
    },
    "radius": 2.500000000000028
  },
  {
    "type": "MTEXT",
    "handle": "5E1",
    "ownerHandle": "1F",
    "layer": "Doc_Sembol_Listesi",
    "colorIndex": 1,
    "color": 16711680,
    "position": {
      "x": 885,
      "y": 94.96898678767457,
      "z": 0
    },
    "height": 9,
    "width": 190.0007891953712,
    "attachmentPoint": 5,
    "drawingDirection": 5,
    "text": "{\\fVerdana|b1|i0|c162|p34;AŞAĞI VE YUKARI HAT GİDİŞLERİ}",
    "directionVector": {
      "x": 0.9999999998757351,
      "y": -0.0000157648229072,
      "z": 0
    }
  },
  {
    "type": "LWPOLYLINE",
    "vertices": [
      {
        "x": 770,
        "y": 40
      },
      {
        "x": 780,
        "y": 40
      },
      {
        "x": 780,
        "y": 50
      },
      {
        "x": 770,
        "y": 50
      }
    ],
    "handle": "5E3",
    "ownerHandle": "1F",
    "layer": "Doc_Sembol_Listesi",
    "shape": true,
    "hasContinuousLinetypePattern": false
  },
  {
    "type": "CIRCLE",
    "handle": "5E5",
    "ownerHandle": "1F",
    "layer": "Doc_Sembol_Listesi",
    "center": {
      "x": 755,
      "y": 45,
      "z": 0
    },
    "radius": 5
  },
  {
    "type": "MTEXT",
    "handle": "5E6",
    "ownerHandle": "1F",
    "layer": "Doc_Sembol_Listesi",
    "position": {
      "x": 885,
      "y": 44.96898678767457,
      "z": 0
    },
    "height": 9,
    "width": 190.0007891953712,
    "attachmentPoint": 5,
    "drawingDirection": 5,
    "text": "{\\fVerdana|b1|i0|c162|p34;YUVARLAK VE KARE BUAT}",
    "directionVector": {
      "x": 0.9999999998757351,
      "y": -0.0000157648229072,
      "z": 0
    }
  },
  {
    "type": "CIRCLE",
    "handle": "5E7",
    "ownerHandle": "1F",
    "layer": "Doc_Sembol_Listesi",
    "center": {
      "x": 53.45128935652065,
      "y": 582.5001649365295,
      "z": 0
    },
    "radius": 2.482555303661673
  },
  {
    "type": "CIRCLE",
    "handle": "5E8",
    "ownerHandle": "1F",
    "layer": "Doc_Sembol_Listesi",
    "center": {
      "x": 32.52685681562616,
      "y": 582.5004948095884,
      "z": 0
    },
    "radius": 2.482555303661673
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 53.45128935652065,
        "y": 582.5001649365295,
        "z": 0
      },
      {
        "x": 33.52162783812673,
        "y": 588.8751527035378,
        "z": 0
      }
    ],
    "handle": "5E9",
    "ownerHandle": "1F",
    "layer": "Doc_Sembol_Listesi"
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 43.48645859732369,
        "y": 585.6876588200338,
        "z": 0
      },
      {
        "x": 43.48645859732369,
        "y": 591.6876588200339,
        "z": 0
      }
    ],
    "handle": "5EA",
    "ownerHandle": "1F",
    "layer": "Doc_Sembol_Listesi"
  },
  {
    "type": "LWPOLYLINE",
    "vertices": [
      {
        "x": 40.48645859732369,
        "y": 591.7481913276747
      },
      {
        "x": 46.48645859732368,
        "y": 591.7481913276747
      },
      {
        "x": 46.48645859732368,
        "y": 596.7481913276746
      },
      {
        "x": 40.48645859732369,
        "y": 596.7481913276746
      }
    ],
    "handle": "5EB",
    "ownerHandle": "1F",
    "layer": "Doc_Sembol_Listesi",
    "shape": true,
    "hasContinuousLinetypePattern": false
  },
  {
    "type": "MTEXT",
    "handle": "5EC",
    "ownerHandle": "1F",
    "layer": "Doc_Sembol_Listesi",
    "position": {
      "x": 165,
      "y": 594.9689867876745,
      "z": 0
    },
    "height": 9,
    "width": 190.0007891953712,
    "attachmentPoint": 5,
    "drawingDirection": 5,
    "text": "{\\fVerdana|b1|i0|c162|p34;KONTAKTÖR}",
    "directionVector": {
      "x": 0.9999999998757351,
      "y": -0.0000157648229072,
      "z": 0
    }
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 25,
        "y": 995,
        "z": 0
      },
      {
        "x": 65,
        "y": 995,
        "z": 0
      }
    ],
    "handle": "5ED",
    "ownerHandle": "1F",
    "layer": "Doc_Sembol_Listesi"
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 25,
        "y": 945,
        "z": 0
      },
      {
        "x": 65,
        "y": 945,
        "z": 0
      }
    ],
    "handle": "5EE",
    "ownerHandle": "1F",
    "layer": "Doc_Sembol_Listesi"
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 25,
        "y": 885,
        "z": 0
      },
      {
        "x": 65,
        "y": 885,
        "z": 0
      }
    ],
    "handle": "5EF",
    "ownerHandle": "1F",
    "layer": "Doc_Sembol_Listesi"
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 25,
        "y": 845,
        "z": 0
      },
      {
        "x": 65,
        "y": 845,
        "z": 0
      }
    ],
    "handle": "5F0",
    "ownerHandle": "1F",
    "layer": "Doc_Sembol_Listesi"
  },
  {
    "type": "CIRCLE",
    "handle": "5F1",
    "ownerHandle": "1F",
    "layer": "Doc_Sembol_Listesi",
    "center": {
      "x": 45,
      "y": 905,
      "z": 0
    },
    "radius": 10
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 45,
        "y": 895,
        "z": 0
      },
      {
        "x": 45,
        "y": 885,
        "z": 0
      }
    ],
    "handle": "5F2",
    "ownerHandle": "1F",
    "layer": "Doc_Sembol_Listesi"
  },
  {
    "type": "MTEXT",
    "handle": "5F3",
    "ownerHandle": "1F",
    "layer": "Doc_Sembol_Listesi",
    "position": {
      "x": 45.03638351940844,
      "y": 904.8103100236603,
      "z": 0
    },
    "height": 10,
    "width": 15.00015764636491,
    "attachmentPoint": 5,
    "drawingDirection": 5,
    "text": "{\\fVerdana|b1|i0|c162|p34;1}",
    "directionVector": {
      "x": 0.9999999998757351,
      "y": -0.0000157648229072,
      "z": 0
    }
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 45,
        "y": 855,
        "z": 0
      },
      {
        "x": 45,
        "y": 835,
        "z": 0
      }
    ],
    "handle": "5F4",
    "ownerHandle": "1F",
    "layer": "Doc_Sembol_Listesi"
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 45,
        "y": 835,
        "z": 0
      },
      {
        "x": 65,
        "y": 835,
        "z": 0
      }
    ],
    "handle": "5F5",
    "ownerHandle": "1F",
    "layer": "Doc_Sembol_Listesi"
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 45,
        "y": 840,
        "z": 0
      },
      {
        "x": 65,
        "y": 840,
        "z": 0
      }
    ],
    "handle": "5F6",
    "ownerHandle": "1F",
    "layer": "Doc_Sembol_Listesi"
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 45,
        "y": 850,
        "z": 0
      },
      {
        "x": 65,
        "y": 850,
        "z": 0
      }
    ],
    "handle": "5F7",
    "ownerHandle": "1F",
    "layer": "Doc_Sembol_Listesi"
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 45,
        "y": 855,
        "z": 0
      },
      {
        "x": 65,
        "y": 855,
        "z": 0
      }
    ],
    "handle": "5F8",
    "ownerHandle": "1F",
    "layer": "Doc_Sembol_Listesi"
  },
  {
    "type": "MTEXT",
    "handle": "5F9",
    "ownerHandle": "1F",
    "layer": "Doc_Sembol_Listesi",
    "position": {
      "x": 165,
      "y": 845,
      "z": 0
    },
    "height": 9,
    "width": 190.0007882175357,
    "attachmentPoint": 5,
    "drawingDirection": 5,
    "text": "{\\fVerdana|b1|i0|c162|p34;ÇOKLU HAT GÖSTERİMİ}",
    "directionVector": {
      "x": 0.9999999998757351,
      "y": -0.0000157648229072,
      "z": 0
    }
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 285,
        "y": 907.5000000000001,
        "z": 0
      },
      {
        "x": 285,
        "y": 895,
        "z": 0
      }
    ],
    "handle": "5FA",
    "ownerHandle": "1F",
    "layer": "Doc_Sembol_Listesi"
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 275,
        "y": 895,
        "z": 0
      },
      {
        "x": 295,
        "y": 895,
        "z": 0
      }
    ],
    "handle": "5FB",
    "ownerHandle": "1F",
    "layer": "Doc_Sembol_Listesi"
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 277.5,
        "y": 892.5,
        "z": 0
      },
      {
        "x": 292.5,
        "y": 892.5,
        "z": 0
      }
    ],
    "handle": "5FC",
    "ownerHandle": "1F",
    "layer": "Doc_Sembol_Listesi"
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 280,
        "y": 890,
        "z": 0
      },
      {
        "x": 290,
        "y": 890,
        "z": 0
      }
    ],
    "handle": "5FD",
    "ownerHandle": "1F",
    "layer": "Doc_Sembol_Listesi"
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 282.5,
        "y": 887.5,
        "z": 0
      },
      {
        "x": 287.5,
        "y": 887.5,
        "z": 0
      }
    ],
    "handle": "5FE",
    "ownerHandle": "1F",
    "layer": "Doc_Sembol_Listesi"
  },
  {
    "type": "MTEXT",
    "handle": "5FF",
    "ownerHandle": "1F",
    "layer": "0",
    "position": {
      "x": 394.6967709506853,
      "y": 1358.610826519313,
      "z": 0
    },
    "height": 20.57749389202285,
    "width": 600.9459032786566,
    "attachmentPoint": 1,
    "drawingDirection": 5,
    "text": "{\\fTimes New Roman|b0|i0|c162|p18;ÖNEMLi NOTLAR}",
    "directionVector": {
      "x": 0.9999999998757351,
      "y": -0.0000157648229072,
      "z": 0
    }
  },
  {
    "type": "MTEXT",
    "handle": "600",
    "ownerHandle": "1F",
    "layer": "0",
    "position": {
      "x": 422.3868180203735,
      "y": 1403.809071741528,
      "z": 0
    },
    "height": 25.72186736502859,
    "width": 600.9459032786566,
    "attachmentPoint": 1,
    "drawingDirection": 5,
    "text": "{\\fArial Narrow|b0|i0|c0|p34;SEMBOLLER}",
    "directionVector": {
      "x": 0.9999999998757351,
      "y": -0.0000157648229072,
      "z": 0
    }
  },
  {
    "type": "MTEXT",
    "handle": "601",
    "ownerHandle": "1F",
    "layer": "0",
    "position": {
      "x": 194.9474758547721,
      "y": 1165.077862142578,
      "z": 0
    },
    "height": 18.00530715552001,
    "width": 600.9459032786566,
    "attachmentPoint": 1,
    "drawingDirection": 5,
    "text": "5-) Panolar baralı tip olacaktır.",
    "directionVector": {
      "x": 0.9999999998757351,
      "y": -0.0000157648229072,
      "z": 0
    }
  },
  {
    "type": "MTEXT",
    "handle": "602",
    "ownerHandle": "1F",
    "layer": "0",
    "position": {
      "x": 194.946938195264,
      "y": 1130.972881842395,
      "z": 0
    },
    "height": 18.00530715552001,
    "width": 691.4292797223262,
    "attachmentPoint": 1,
    "drawingDirection": 5,
    "text": "6-) Panolar teknik eleman tarafından monte edilecektir.",
    "directionVector": {
      "x": 0.9999999998757351,
      "y": -0.0000157648229072,
      "z": 0
    }
  },
  {
    "type": "MTEXT",
    "handle": "603",
    "ownerHandle": "1F",
    "layer": "0",
    "position": {
      "x": 194.9480135126478,
      "y": 1199.18282901169,
      "z": 0
    },
    "height": 18.00530715552001,
    "width": 600.9459032786566,
    "attachmentPoint": 1,
    "drawingDirection": 5,
    "text": "4-) Bağımsız bölümler kodlanacaktır.",
    "directionVector": {
      "x": 0.9999999998757351,
      "y": -0.0000157648229072,
      "z": 0
    }
  },
  {
    "type": "MTEXT",
    "handle": "604",
    "ownerHandle": "1F",
    "layer": "0",
    "position": {
      "x": 194.9486049419511,
      "y": 1236.698293966697,
      "z": 0
    },
    "height": 18.00530715552001,
    "width": 600.9459032786566,
    "attachmentPoint": 1,
    "drawingDirection": 5,
    "text": "3-) Bağlantılar tekniğe uygun yapılacaktır.",
    "directionVector": {
      "x": 0.9999999998757351,
      "y": -0.0000157648229072,
      "z": 0
    }
  },
  {
    "type": "MTEXT",
    "handle": "605",
    "ownerHandle": "1F",
    "layer": "0",
    "position": {
      "x": 197.3771354798209,
      "y": 1310.816884448473,
      "z": 0
    },
    "height": 18.00530715552001,
    "width": 600.9459032786566,
    "attachmentPoint": 1,
    "drawingDirection": 5,
    "text": "{\\fArial Narrow|b0|i0|c0|p34;1-) Tablo yerden1,80m yükseklige monte edilecektir.}",
    "directionVector": {
      "x": 0.9999999998757351,
      "y": -0.0000157648229072,
      "z": 0
    }
  },
  {
    "type": "MTEXT",
    "handle": "606",
    "ownerHandle": "1F",
    "layer": "0",
    "position": {
      "x": 194.9491425985443,
      "y": 1270.803274243595,
      "z": 0
    },
    "height": 18.00530715552001,
    "width": 600.9459032786566,
    "attachmentPoint": 1,
    "drawingDirection": 5,
    "text": "2-) TSE standartlarına uygun malzeme kulanılacaktır",
    "directionVector": {
      "x": 0.9999999998757351,
      "y": -0.0000157648229072,
      "z": 0
    }
  },
  {
    "type": "LWPOLYLINE",
    "vertices": [
      {
        "x": 526.5973879672327,
        "y": 98.58764152787082
      },
      {
        "x": 530.3915679450565,
        "y": 105.0571236011035
      },
      {
        "x": 532.5480619694681,
        "y": 103.7923969418289
      }
    ],
    "handle": "607",
    "ownerHandle": "1F",
    "layer": "Doc_Sembol_Listesi",
    "shape": false,
    "hasContinuousLinetypePattern": false,
    "extendedData": {
      "applicationName": "AcDbBlockRepETag"
    }
  },
  {
    "type": "LWPOLYLINE",
    "vertices": [
      {
        "x": 523.5817340988104,
        "y": 98.59908902900087
      },
      {
        "x": 519.8367794055757,
        "y": 105.0971898550592
      },
      {
        "x": 517.6707457968896,
        "y": 103.848871623981
      }
    ],
    "handle": "608",
    "ownerHandle": "1F",
    "layer": "Doc_Sembol_Listesi",
    "shape": false,
    "hasContinuousLinetypePattern": false,
    "extendedData": {
      "applicationName": "AcDbBlockRepETag"
    }
  },
  {
    "type": "LWPOLYLINE",
    "vertices": [
      {
        "x": 526.5973879672327,
        "y": 148.5876415278708
      },
      {
        "x": 530.3915679450565,
        "y": 155.0571236011035
      },
      {
        "x": 532.5480619694681,
        "y": 153.7923969418289
      }
    ],
    "handle": "609",
    "ownerHandle": "1F",
    "layer": "Doc_Sembol_Listesi",
    "shape": false,
    "hasContinuousLinetypePattern": false,
    "extendedData": {
      "applicationName": "AcDbBlockRepETag"
    }
  },
  {
    "type": "LWPOLYLINE",
    "vertices": [
      {
        "x": 523.5817340988104,
        "y": 148.5990890290008
      },
      {
        "x": 519.8367794055757,
        "y": 155.0971898550592
      },
      {
        "x": 517.6707457968896,
        "y": 153.848871623981
      }
    ],
    "handle": "60A",
    "ownerHandle": "1F",
    "layer": "Doc_Sembol_Listesi",
    "shape": false,
    "hasContinuousLinetypePattern": false,
    "extendedData": {
      "applicationName": "AcDbBlockRepETag"
    }
  },
  {
    "type": "LWPOLYLINE",
    "vertices": [
      {
        "x": 525.250535924948,
        "y": 197.2130221690545
      },
      {
        "x": 525.2790059164126,
        "y": 204.7129681328322
      },
      {
        "x": 522.7790239284877,
        "y": 204.7224581299872
      }
    ],
    "handle": "60B",
    "ownerHandle": "1F",
    "layer": "Doc_Sembol_Listesi",
    "shape": false,
    "hasContinuousLinetypePattern": false,
    "extendedData": {
      "applicationName": "AcDbBlockRepETag"
    }
  },
  {
    "type": "LWPOLYLINE",
    "vertices": [
      {
        "x": 525.1708199488439,
        "y": 248.9998270840888
      },
      {
        "x": 525.1992899403103,
        "y": 256.4997730478665
      },
      {
        "x": 522.6993079523835,
        "y": 256.5092630450217
      }
    ],
    "handle": "60C",
    "ownerHandle": "1F",
    "layer": "Doc_Sembol_Listesi",
    "shape": false,
    "hasContinuousLinetypePattern": false,
    "extendedData": {
      "applicationName": "AcDbBlockRepETag"
    }
  },
  {
    "type": "CIRCLE",
    "handle": "60D",
    "ownerHandle": "1F",
    "layer": "Doc_Sembol_Listesi",
    "colorIndex": 1,
    "color": 16711680,
    "center": {
      "x": 285,
      "y": 645,
      "z": 0
    },
    "radius": 15
  },
  {
    "type": "MTEXT",
    "handle": "60E",
    "ownerHandle": "1F",
    "layer": "Doc_Sembol_Listesi",
    "colorIndex": 1,
    "color": 16711680,
    "position": {
      "x": 284.9207472348389,
      "y": 644.9207472348384,
      "z": 0
    },
    "height": 15,
    "width": 15.00015764636491,
    "attachmentPoint": 5,
    "drawingDirection": 5,
    "text": "{\\fVerdana|b1|i0|c162|p34;A}",
    "directionVector": {
      "x": 0.9999999998757351,
      "y": -0.0000157648229072,
      "z": 0
    }
  },
  {
    "type": "CIRCLE",
    "handle": "60F",
    "ownerHandle": "1F",
    "layer": "Doc_Sembol_Listesi",
    "colorIndex": 1,
    "color": 16711680,
    "center": {
      "x": 285,
      "y": 695,
      "z": 0
    },
    "radius": 15
  },
  {
    "type": "MTEXT",
    "handle": "610",
    "ownerHandle": "1F",
    "layer": "Doc_Sembol_Listesi",
    "colorIndex": 1,
    "color": 16711680,
    "position": {
      "x": 284.9207472348389,
      "y": 694.9207472348384,
      "z": 0
    },
    "height": 15,
    "width": 15.00015764636491,
    "attachmentPoint": 5,
    "drawingDirection": 5,
    "text": "{\\fVerdana|b1|i0|c162|p34;V}",
    "directionVector": {
      "x": 0.9999999998757351,
      "y": -0.0000157648229072,
      "z": 0
    }
  },
  {
    "type": "CIRCLE",
    "handle": "611",
    "ownerHandle": "1F",
    "layer": "Doc_Sembol_Listesi",
    "colorIndex": 1,
    "color": 16711680,
    "center": {
      "x": 285,
      "y": 745,
      "z": 0
    },
    "radius": 15
  },
  {
    "type": "MTEXT",
    "handle": "612",
    "ownerHandle": "1F",
    "layer": "Doc_Sembol_Listesi",
    "colorIndex": 1,
    "color": 16711680,
    "position": {
      "x": 284.9207472348389,
      "y": 744.9207472348384,
      "z": 0
    },
    "height": 15,
    "width": 15.00015764636491,
    "attachmentPoint": 5,
    "drawingDirection": 5,
    "text": "{\\fVerdana|b1|i0|c162|p34;F}",
    "directionVector": {
      "x": 0.9999999998757351,
      "y": -0.0000157648229072,
      "z": 0
    }
  },
  {
    "type": "CIRCLE",
    "handle": "613",
    "ownerHandle": "1F",
    "layer": "Doc_Sembol_Listesi",
    "colorIndex": 1,
    "color": 16711680,
    "center": {
      "x": 285,
      "y": 795,
      "z": 0
    },
    "radius": 15
  },
  {
    "type": "MTEXT",
    "handle": "614",
    "ownerHandle": "1F",
    "layer": "Doc_Sembol_Listesi",
    "colorIndex": 1,
    "color": 16711680,
    "position": {
      "x": 284.9207472348389,
      "y": 794.9207472348384,
      "z": 0
    },
    "height": 7,
    "width": 15.00015764636491,
    "attachmentPoint": 5,
    "drawingDirection": 5,
    "text": "{\\fVerdana|b1|i0|c162|p34;Cos\\fVerdana|b1|i0|c0|p34;%%C}",
    "directionVector": {
      "x": 0.9999999998757351,
      "y": -0.0000157648229072,
      "z": 0
    }
  },
  {
    "type": "CIRCLE",
    "handle": "615",
    "ownerHandle": "1F",
    "layer": "Doc_Sembol_Listesi",
    "colorIndex": 1,
    "color": 16711680,
    "center": {
      "x": 285,
      "y": 845,
      "z": 0
    },
    "radius": 15
  },
  {
    "type": "MTEXT",
    "handle": "616",
    "ownerHandle": "1F",
    "layer": "Doc_Sembol_Listesi",
    "colorIndex": 1,
    "color": 16711680,
    "position": {
      "x": 284.9207472348389,
      "y": 844.9207472348385,
      "z": 0
    },
    "height": 15,
    "width": 15.00015764636491,
    "attachmentPoint": 5,
    "drawingDirection": 5,
    "text": "{\\fVerdana|b1|i0|c162|p34;W}",
    "directionVector": {
      "x": 0.9999999998757351,
      "y": -0.0000157648229072,
      "z": 0
    }
  },
  {
    "type": "MTEXT",
    "handle": "617",
    "ownerHandle": "1F",
    "layer": "Doc_Sembol_Listesi",
    "colorIndex": 1,
    "color": 16711680,
    "position": {
      "x": 404.9999999962501,
      "y": 644.9689867876745,
      "z": 0
    },
    "height": 9,
    "width": 190.0007891953712,
    "attachmentPoint": 5,
    "drawingDirection": 5,
    "text": "\\pt135;{\\fVerdana|b1|i0|c162|p34;AMPERMETRE}",
    "directionVector": {
      "x": 0.9999999998757351,
      "y": -0.0000157648229072,
      "z": 0
    }
  },
  {
    "type": "MTEXT",
    "handle": "618",
    "ownerHandle": "1F",
    "layer": "Doc_Sembol_Listesi",
    "colorIndex": 1,
    "color": 16711680,
    "position": {
      "x": 405,
      "y": 694.9689867876745,
      "z": 0
    },
    "height": 9,
    "width": 190.0007891953712,
    "attachmentPoint": 5,
    "drawingDirection": 5,
    "text": "\\pt135;{\\fVerdana|b1|i0|c162|p34;VOLTMETRE}",
    "directionVector": {
      "x": 0.9999999998757351,
      "y": -0.0000157648229072,
      "z": 0
    }
  },
  {
    "type": "MTEXT",
    "handle": "619",
    "ownerHandle": "1F",
    "layer": "Doc_Sembol_Listesi",
    "colorIndex": 1,
    "color": 16711680,
    "position": {
      "x": 405,
      "y": 744.9689867876745,
      "z": 0
    },
    "height": 9,
    "width": 190.0007891953712,
    "attachmentPoint": 5,
    "drawingDirection": 5,
    "text": "\\pt135;{\\fVerdana|b1|i0|c162|p34;FREKANSMETRE}",
    "directionVector": {
      "x": 0.9999999998757351,
      "y": -0.0000157648229072,
      "z": 0
    }
  },
  {
    "type": "MTEXT",
    "handle": "61A",
    "ownerHandle": "1F",
    "layer": "Doc_Sembol_Listesi",
    "colorIndex": 1,
    "color": 16711680,
    "position": {
      "x": 405,
      "y": 794.9689867876745,
      "z": 0
    },
    "height": 9,
    "width": 190.0007891953712,
    "attachmentPoint": 5,
    "drawingDirection": 5,
    "text": "\\pt135;{\\fVerdana|b1|i0|c162|p34;KOSİNÜS Fİ METRE}",
    "directionVector": {
      "x": 0.9999999998757351,
      "y": -0.0000157648229072,
      "z": 0
    }
  },
  {
    "type": "MTEXT",
    "handle": "61B",
    "ownerHandle": "1F",
    "layer": "Doc_Sembol_Listesi",
    "colorIndex": 1,
    "color": 16711680,
    "position": {
      "x": 405,
      "y": 844.9689867876745,
      "z": 0
    },
    "height": 9,
    "width": 190.0007891953712,
    "attachmentPoint": 5,
    "drawingDirection": 5,
    "text": "\\pt135;{\\fVerdana|b1|i0|c162|p34;WATTMETRE}",
    "directionVector": {
      "x": 0.9999999998757351,
      "y": -0.0000157648229072,
      "z": 0
    }
  },
  {
    "type": "MTEXT",
    "handle": "61C",
    "ownerHandle": "1F",
    "layer": "Doc_Sembol_Listesi",
    "position": {
      "x": 405,
      "y": 894.9689867876745,
      "z": 0
    },
    "height": 9,
    "width": 190.0007891953712,
    "attachmentPoint": 5,
    "drawingDirection": 5,
    "text": "\\pt135;{\\fVerdana|b1|i0|c162|p34;TOPRAKLAMA}",
    "directionVector": {
      "x": 0.9999999998757351,
      "y": -0.0000157648229072,
      "z": 0
    }
  },
  {
    "type": "LWPOLYLINE",
    "vertices": [
      {
        "x": 746.4999999999999,
        "y": 787.5
      },
      {
        "x": 783.4999999999999,
        "y": 787.5
      },
      {
        "x": 783.4999999999999,
        "y": 802.5
      },
      {
        "x": 746.4999999999999,
        "y": 802.5
      }
    ],
    "handle": "61D",
    "ownerHandle": "1F",
    "layer": "Doc_Sembol_Listesi",
    "colorIndex": 1,
    "color": 16711680,
    "shape": true,
    "hasContinuousLinetypePattern": false
  },
  {
    "type": "MTEXT",
    "handle": "61E",
    "ownerHandle": "1F",
    "layer": "Doc_Sembol_Listesi",
    "colorIndex": 1,
    "color": 16711680,
    "position": {
      "x": 885,
      "y": 794.9689867876745,
      "z": 0
    },
    "height": 9,
    "width": 190.0007891953712,
    "attachmentPoint": 5,
    "drawingDirection": 5,
    "text": "{\\fVerdana|b1|i0|c162|p34;YANGIN İHBAR SANTRALİ}",
    "directionVector": {
      "x": 0.9999999998757351,
      "y": -0.0000157648229072,
      "z": 0
    }
  },
  {
    "type": "MTEXT",
    "handle": "61F",
    "ownerHandle": "1F",
    "layer": "Doc_Sembol_Listesi",
    "colorIndex": 1,
    "color": 16711680,
    "position": {
      "x": 764.9998817676804,
      "y": 794.9993496988768,
      "z": 0
    },
    "height": 9,
    "width": 37.00000002361063,
    "attachmentPoint": 5,
    "drawingDirection": 5,
    "text": "{\\fVerdana|b0|i0|c162|p34;Y.İ.S.}",
    "directionVector": {
      "x": 0.9999999998757351,
      "y": -0.0000157648229071,
      "z": 0
    }
  },
  {
    "type": "MTEXT",
    "handle": "620",
    "ownerHandle": "1F",
    "layer": "Doc_Sembol_Listesi",
    "colorIndex": 1,
    "color": 16711680,
    "position": {
      "x": 885,
      "y": 844.9689867876745,
      "z": 0
    },
    "height": 9,
    "width": 190.0007891953712,
    "attachmentPoint": 5,
    "drawingDirection": 5,
    "text": "{\\fVerdana|b1|i0|c162|p34;DAĞITIM KUTUSU}",
    "directionVector": {
      "x": 0.9999999998757351,
      "y": -0.0000157648229072,
      "z": 0
    }
  },
  {
    "type": "LWPOLYLINE",
    "vertices": [
      {
        "x": 746.4999999999999,
        "y": 852.5
      },
      {
        "x": 746.4999999999999,
        "y": 837.5
      },
      {
        "x": 783.4999999999999,
        "y": 837.5
      },
      {
        "x": 783.4999999999999,
        "y": 852.5
      },
      {
        "x": 746.4999999999999,
        "y": 852.5
      },
      {
        "x": 783.4999999999999,
        "y": 837.5
      },
      {
        "x": 783.4999999999999,
        "y": 852.5
      },
      {
        "x": 746.4999999999999,
        "y": 837.5
      }
    ],
    "handle": "621",
    "ownerHandle": "1F",
    "layer": "Doc_Sembol_Listesi",
    "colorIndex": 1,
    "color": 16711680,
    "shape": false,
    "hasContinuousLinetypePattern": false
  },
  {
    "type": "LWPOLYLINE",
    "vertices": [
      {
        "x": 758,
        "y": 555
      },
      {
        "x": 758,
        "y": 545
      },
      {
        "x": 772,
        "y": 545
      },
      {
        "x": 772,
        "y": 555
      }
    ],
    "handle": "622",
    "ownerHandle": "1F",
    "layer": "Doc_Sembol_Listesi",
    "colorIndex": 1,
    "color": 16711680,
    "shape": false,
    "hasContinuousLinetypePattern": false
  },
  {
    "type": "LWPOLYLINE",
    "vertices": [
      {
        "x": 765,
        "y": 545
      },
      {
        "x": 765,
        "y": 525
      }
    ],
    "handle": "623",
    "ownerHandle": "1F",
    "layer": "Doc_Sembol_Listesi",
    "colorIndex": 1,
    "color": 16711680,
    "shape": false,
    "hasContinuousLinetypePattern": false
  },
  {
    "type": "MTEXT",
    "handle": "624",
    "ownerHandle": "1F",
    "layer": "Doc_Sembol_Listesi",
    "colorIndex": 1,
    "color": 16711680,
    "position": {
      "x": 765,
      "y": 550,
      "z": 0
    },
    "height": 7,
    "width": 14.00015764648944,
    "attachmentPoint": 5,
    "drawingDirection": 5,
    "text": "{\\fVerdana|b0|i0|c162|p34;D}",
    "directionVector": {
      "x": 0.9999999998757351,
      "y": -0.0000157648229072,
      "z": 0
    }
  },
  {
    "type": "LWPOLYLINE",
    "vertices": [
      {
        "x": 758,
        "y": 605
      },
      {
        "x": 758,
        "y": 595
      },
      {
        "x": 772,
        "y": 595
      },
      {
        "x": 772,
        "y": 605
      }
    ],
    "handle": "625",
    "ownerHandle": "1F",
    "layer": "Doc_Sembol_Listesi",
    "colorIndex": 1,
    "color": 16711680,
    "shape": false,
    "hasContinuousLinetypePattern": false
  },
  {
    "type": "LWPOLYLINE",
    "vertices": [
      {
        "x": 765,
        "y": 595
      },
      {
        "x": 765,
        "y": 575
      }
    ],
    "handle": "626",
    "ownerHandle": "1F",
    "layer": "Doc_Sembol_Listesi",
    "colorIndex": 1,
    "color": 16711680,
    "shape": false,
    "hasContinuousLinetypePattern": false
  },
  {
    "type": "MTEXT",
    "handle": "627",
    "ownerHandle": "1F",
    "layer": "Doc_Sembol_Listesi",
    "colorIndex": 1,
    "color": 16711680,
    "position": {
      "x": 765,
      "y": 600,
      "z": 0
    },
    "height": 7,
    "width": 14.00015764648944,
    "attachmentPoint": 5,
    "drawingDirection": 5,
    "text": "{\\fVerdana|b0|i0|c162|p34;TV}",
    "directionVector": {
      "x": 0.9999999998757351,
      "y": -0.0000157648229072,
      "z": 0
    }
  },
  {
    "type": "LWPOLYLINE",
    "vertices": [
      {
        "x": 758,
        "y": 655
      },
      {
        "x": 758,
        "y": 645
      },
      {
        "x": 772,
        "y": 645
      },
      {
        "x": 772,
        "y": 655
      }
    ],
    "handle": "628",
    "ownerHandle": "1F",
    "layer": "Doc_Sembol_Listesi",
    "colorIndex": 1,
    "color": 16711680,
    "shape": false,
    "hasContinuousLinetypePattern": false
  },
  {
    "type": "LWPOLYLINE",
    "vertices": [
      {
        "x": 765,
        "y": 645
      },
      {
        "x": 765,
        "y": 625
      }
    ],
    "handle": "629",
    "ownerHandle": "1F",
    "layer": "Doc_Sembol_Listesi",
    "colorIndex": 1,
    "color": 16711680,
    "shape": false,
    "hasContinuousLinetypePattern": false
  },
  {
    "type": "MTEXT",
    "handle": "62A",
    "ownerHandle": "1F",
    "layer": "Doc_Sembol_Listesi",
    "colorIndex": 1,
    "color": 16711680,
    "position": {
      "x": 765,
      "y": 650,
      "z": 0
    },
    "height": 7,
    "width": 14.00015764648944,
    "attachmentPoint": 5,
    "drawingDirection": 5,
    "text": "{\\fVerdana|b0|i0|c162|p34;Tlf}",
    "directionVector": {
      "x": 0.9999999998757351,
      "y": -0.0000157648229072,
      "z": 0
    }
  },
  {
    "type": "MTEXT",
    "handle": "62B",
    "ownerHandle": "1F",
    "layer": "Doc_Sembol_Listesi",
    "colorIndex": 1,
    "color": 16711680,
    "position": {
      "x": 885,
      "y": 544.9689867876745,
      "z": 0
    },
    "height": 9,
    "width": 190.0007891953712,
    "attachmentPoint": 5,
    "drawingDirection": 5,
    "text": "{\\fVerdana|b1|i0|c162|p34;DATA PRİZİ}",
    "directionVector": {
      "x": 0.9999999998757351,
      "y": -0.0000157648229072,
      "z": 0
    }
  },
  {
    "type": "MTEXT",
    "handle": "62C",
    "ownerHandle": "1F",
    "layer": "Doc_Sembol_Listesi",
    "colorIndex": 1,
    "color": 16711680,
    "position": {
      "x": 885,
      "y": 594.9689867876745,
      "z": 0
    },
    "height": 9,
    "width": 190.0007891953712,
    "attachmentPoint": 5,
    "drawingDirection": 5,
    "text": "{\\fVerdana|b1|i0|c162|p34;TV PRİZİ}",
    "directionVector": {
      "x": 0.9999999998757351,
      "y": -0.0000157648229072,
      "z": 0
    }
  },
  {
    "type": "MTEXT",
    "handle": "62D",
    "ownerHandle": "1F",
    "layer": "Doc_Sembol_Listesi",
    "colorIndex": 1,
    "color": 16711680,
    "position": {
      "x": 885,
      "y": 644.9689867876745,
      "z": 0
    },
    "height": 9,
    "width": 190.0007891953712,
    "attachmentPoint": 5,
    "drawingDirection": 5,
    "text": "{\\fVerdana|b1|i0|c162|p34;TELEFON PRİZİ}",
    "directionVector": {
      "x": 0.9999999998757351,
      "y": -0.0000157648229072,
      "z": 0
    }
  },
  {
    "type": "MTEXT",
    "handle": "62E",
    "ownerHandle": "1F",
    "layer": "Doc_Sembol_Listesi",
    "colorIndex": 1,
    "color": 16711680,
    "position": {
      "x": 885,
      "y": 744.9689867876745,
      "z": 0
    },
    "height": 9,
    "width": 190.0007891953712,
    "attachmentPoint": 5,
    "drawingDirection": 5,
    "text": "{\\fVerdana|b1|i0|c162|p34;TV SANTRALİ}",
    "directionVector": {
      "x": 0.9999999998757351,
      "y": -0.0000157648229072,
      "z": 0
    }
  },
  {
    "type": "LWPOLYLINE",
    "vertices": [
      {
        "x": 746.4999999999999,
        "y": 737.5
      },
      {
        "x": 783.4999999999999,
        "y": 737.5
      },
      {
        "x": 783.4999999999999,
        "y": 752.5
      },
      {
        "x": 746.4999999999999,
        "y": 752.5
      }
    ],
    "handle": "62F",
    "ownerHandle": "1F",
    "layer": "Doc_Sembol_Listesi",
    "colorIndex": 1,
    "color": 16711680,
    "shape": true,
    "hasContinuousLinetypePattern": false
  },
  {
    "type": "MTEXT",
    "handle": "630",
    "ownerHandle": "1F",
    "layer": "Doc_Sembol_Listesi",
    "colorIndex": 1,
    "color": 16711680,
    "position": {
      "x": 765.0001182133072,
      "y": 744.9994442840866,
      "z": 0
    },
    "height": 9,
    "width": 37.00000002361063,
    "attachmentPoint": 5,
    "drawingDirection": 5,
    "text": "{\\fVerdana|b0|i0|c162|p34;Tv-S}",
    "directionVector": {
      "x": 0.9999999998757351,
      "y": -0.0000157648229071,
      "z": 0
    }
  },
  {
    "type": "MTEXT",
    "handle": "631",
    "ownerHandle": "1F",
    "layer": "Doc_Sembol_Listesi",
    "colorIndex": 1,
    "color": 16711680,
    "position": {
      "x": 885,
      "y": 694.9689867876745,
      "z": 0
    },
    "height": 9,
    "width": 190.0007891953712,
    "attachmentPoint": 5,
    "drawingDirection": 5,
    "text": "{\\fVerdana|b1|i0|c162|p34;TELEFON SANTRALİ}",
    "directionVector": {
      "x": 0.9999999998757351,
      "y": -0.0000157648229072,
      "z": 0
    }
  },
  {
    "type": "LWPOLYLINE",
    "vertices": [
      {
        "x": 746.4999999999999,
        "y": 687.5
      },
      {
        "x": 783.4999999999999,
        "y": 687.5
      },
      {
        "x": 783.4999999999999,
        "y": 702.5
      },
      {
        "x": 746.4999999999999,
        "y": 702.5
      }
    ],
    "handle": "632",
    "ownerHandle": "1F",
    "layer": "Doc_Sembol_Listesi",
    "colorIndex": 1,
    "color": 16711680,
    "shape": true,
    "hasContinuousLinetypePattern": false
  },
  {
    "type": "MTEXT",
    "handle": "633",
    "ownerHandle": "1F",
    "layer": "Doc_Sembol_Listesi",
    "colorIndex": 1,
    "color": 16711680,
    "position": {
      "x": 765.0001182133072,
      "y": 694.9994442840866,
      "z": 0
    },
    "height": 9,
    "width": 37.00000002361063,
    "attachmentPoint": 5,
    "drawingDirection": 5,
    "text": "{\\fVerdana|b0|i0|c162|p34;Tlf-S}",
    "directionVector": {
      "x": 0.9999999998757351,
      "y": -0.0000157648229071,
      "z": 0
    }
  },
  {
    "type": "MTEXT",
    "handle": "634",
    "ownerHandle": "1F",
    "layer": "Doc_Sembol_Listesi",
    "position": {
      "x": 525.0001970648991,
      "y": 595.000098531571,
      "z": 0
    },
    "height": 9,
    "width": 24.9999999968934,
    "attachmentPoint": 5,
    "drawingDirection": 5,
    "text": "{\\fTimes New Roman|b0|i0|c162|p18;\\C0;F}",
    "directionVector": {
      "x": 0.9999999998757351,
      "y": -0.0000157648229071,
      "z": 0
    }
  },
  {
    "type": "MTEXT",
    "handle": "635",
    "ownerHandle": "1F",
    "layer": "Doc_Sembol_Listesi",
    "position": {
      "x": 526.7748306684553,
      "y": 545.000098531571,
      "z": 0
    },
    "height": 9,
    "width": 24.9999999968934,
    "attachmentPoint": 5,
    "drawingDirection": 5,
    "text": "{\\fTimes New Roman|b0|i0|c162|p18;\\C0;H}",
    "directionVector": {
      "x": 0.9999999998757351,
      "y": -0.0000157648229071,
      "z": 0
    }
  },
  {
    "type": "MTEXT",
    "handle": "636",
    "ownerHandle": "1F",
    "layer": "Doc_Sembol_Listesi",
    "position": {
      "x": 525.0001970648991,
      "y": 495.000098531571,
      "z": 0
    },
    "height": 9,
    "width": 24.9999999968934,
    "attachmentPoint": 5,
    "drawingDirection": 5,
    "text": "{\\fTimes New Roman|b0|i0|c162|p18;\\C0;G}",
    "directionVector": {
      "x": 0.9999999998757351,
      "y": -0.0000157648229071,
      "z": 0
    }
  },
  {
    "type": "HATCH",
    "handle": "4AC",
    "layer": "Doc_Sembol_Listesi",
    "color": "#C0C0C0 ",
    "colorIndex": "",
    "LineScale": 1,
    "LineType": "ByLayer",
    "Kalinlik": "-3",
    "x": 0,
    "y": 0,
    "HatchPatternName": "SOLID",
    "SolidFillFlag": 1,
    "MPolygon": null,
    "AssociativityFlag": 0,
    "NumberOfBoundaryPaths": 1,
    "boundaryPath": [
      {
        "groups": [
          {
            "edgeType": "Line",
            "IsClosedFlag": 1,
            "NumberOfPolylineVertices": 3,
            "bulge": true,
            "points": [
              528.0797159761041,
              95.99984869857781,
              0.1314549871023855,
              527.6789563065267,
              97.4978305758716,
              0,
              522.4804756456797,
              94.50186682128378,
              0.7676354983612083
            ]
          }
        ],
        "BoundaryPathTypeFlag": 7
      }
    ],
    "pattern": {}
  },
  {
    "type": "HATCH",
    "handle": "4B7",
    "layer": "Doc_Sembol_Listesi",
    "color": "#C0C0C0 ",
    "colorIndex": "",
    "LineScale": 1,
    "LineType": "ByLayer",
    "Kalinlik": "-3",
    "x": 0,
    "y": 0,
    "HatchPatternName": "SOLID",
    "SolidFillFlag": 1,
    "MPolygon": null,
    "AssociativityFlag": 0,
    "NumberOfBoundaryPaths": 1,
    "boundaryPath": [
      {
        "groups": [
          {
            "edgeType": "Line",
            "IsClosedFlag": 1,
            "NumberOfPolylineVertices": 3,
            "bulge": true,
            "points": [
              524.2607125504746,
              406,
              0,
              517.2607125504746,
              406.0000000000059,
              0.4142135623730951,
              524.2607125504691,
              399,
              0
            ]
          }
        ],
        "BoundaryPathTypeFlag": 7
      }
    ],
    "pattern": {}
  },
  {
    "type": "HATCH",
    "handle": "4CB",
    "layer": "Doc_Sembol_Listesi",
    "color": "#C0C0C0 ",
    "colorIndex": "",
    "LineScale": 1,
    "LineType": "ByLayer",
    "Kalinlik": "-3",
    "x": 0,
    "y": 0,
    "HatchPatternName": "SOLID",
    "SolidFillFlag": 1,
    "MPolygon": null,
    "AssociativityFlag": 0,
    "NumberOfBoundaryPaths": 1,
    "boundaryPath": [
      {
        "groups": [
          {
            "edgeType": "Line",
            "x1": 64.99999999993452,
            "y1": 187.4999999999777,
            "x2": 64.99999999994907,
            "y2": 202.4999999999777
          },
          {
            "edgeType": "Line",
            "x1": 64.99999999994907,
            "y1": 202.4999999999777,
            "x2": 24.99999999994179,
            "y2": 187.5000000000214
          },
          {
            "edgeType": "Line",
            "x1": 24.99999999994179,
            "y1": 187.5000000000214,
            "x2": 64.99999999993452,
            "y2": 187.4999999999777
          }
        ],
        "BoundaryPathTypeFlag": 1
      },
      {
        "groups": [
          {
            "edgeType": "Line",
            "x1": 65,
            "y1": 252.4999999999813,
            "x2": 64.99999999998545,
            "y2": 237.4999999999813
          },
          {
            "edgeType": "Line",
            "x1": 64.99999999998545,
            "y1": 237.4999999999813,
            "x2": 25.00000000003729,
            "y2": 252.500000000025
          },
          {
            "edgeType": "Line",
            "x1": 25.00000000003729,
            "y1": 252.500000000025,
            "x2": 25,
            "y2": 237.500000000025
          },
          {
            "edgeType": "Line",
            "x1": 25,
            "y1": 237.500000000025,
            "x2": 65,
            "y2": 252.4999999999813
          }
        ],
        "BoundaryPathTypeFlag": 1
      },
      {
        "groups": [
          {
            "edgeType": "Line",
            "x1": 64.99999999993452,
            "y1": 137.4999999999777,
            "x2": 64.99999999994179,
            "y2": 144.9999999999777
          },
          {
            "edgeType": "Line",
            "x1": 64.99999999994179,
            "y1": 144.9999999999777,
            "x2": 24.99999999994179,
            "y2": 145.0000000000214
          },
          {
            "edgeType": "Line",
            "x1": 24.99999999994179,
            "y1": 145.0000000000214,
            "x2": 24.99999999994179,
            "y2": 137.5000000000214
          },
          {
            "edgeType": "Line",
            "x1": 24.99999999994179,
            "y1": 137.5000000000214,
            "x2": 64.99999999993452,
            "y2": 137.4999999999777
          }
        ],
        "BoundaryPathTypeFlag": 1
      },
      {
        "groups": [
          {
            "edgeType": "Line",
            "x1": 64.99999999993452,
            "y1": 87.49999999997772,
            "x2": 64.99999999994907,
            "y2": 102.4999999999777
          },
          {
            "edgeType": "Line",
            "x1": 64.99999999994907,
            "y1": 102.4999999999777,
            "x2": 24.99999999994179,
            "y2": 102.4999999999777
          },
          {
            "edgeType": "Line",
            "x1": 24.99999999994179,
            "y1": 102.4999999999777,
            "x2": 24.99999999994179,
            "y2": 87.50000000002136
          },
          {
            "edgeType": "Line",
            "x1": 24.99999999994179,
            "y1": 87.50000000002136,
            "x2": 64.99999999993452,
            "y2": 87.49999999997772
          }
        ],
        "BoundaryPathTypeFlag": 1
      },
      {
        "groups": [
          {
            "edgeType": "Polyline",
            "IsClosedFlag": 1,
            "NumberOfPolylineVertices": 3,
            "points": [
              52.4999999999618,
              37.4999999999618,
              52.4999999999618,
              52.4999999999618,
              59.9999999999618,
              44.99999999996179
            ]
          }
        ],
        "BoundaryPathTypeFlag": 7
      }
    ],
    "pattern": {}
  },
  {
    "type": "HATCH",
    "handle": "4CD",
    "layer": "Doc_Sembol_Listesi",
    "color": "#C0C0C0 ",
    "colorIndex": "",
    "LineScale": 1,
    "LineType": "ByLayer",
    "Kalinlik": "-3",
    "x": 0,
    "y": 0,
    "HatchPatternName": "SOLID",
    "SolidFillFlag": 1,
    "MPolygon": null,
    "AssociativityFlag": 0,
    "NumberOfBoundaryPaths": 1,
    "boundaryPath": [
      {
        "groups": [
          {
            "edgeType": "Line",
            "x1": 65,
            "y1": 252.4999999999813,
            "x2": 64.99999999998545,
            "y2": 237.4999999999813
          },
          {
            "edgeType": "Line",
            "x1": 64.99999999998545,
            "y1": 237.4999999999813,
            "x2": 25.00000000003729,
            "y2": 252.500000000025
          },
          {
            "edgeType": "Line",
            "x1": 25.00000000003729,
            "y1": 252.500000000025,
            "x2": 25,
            "y2": 237.500000000025
          },
          {
            "edgeType": "Line",
            "x1": 25,
            "y1": 237.500000000025,
            "x2": 65,
            "y2": 252.4999999999813
          }
        ],
        "BoundaryPathTypeFlag": 1
      },
      {
        "groups": [
          {
            "edgeType": "Line",
            "x1": 64.99999999993452,
            "y1": 137.4999999999777,
            "x2": 64.99999999994179,
            "y2": 144.9999999999777
          },
          {
            "edgeType": "Line",
            "x1": 64.99999999994179,
            "y1": 144.9999999999777,
            "x2": 24.99999999994179,
            "y2": 145.0000000000214
          },
          {
            "edgeType": "Line",
            "x1": 24.99999999994179,
            "y1": 145.0000000000214,
            "x2": 24.99999999994179,
            "y2": 137.5000000000214
          },
          {
            "edgeType": "Line",
            "x1": 24.99999999994179,
            "y1": 137.5000000000214,
            "x2": 64.99999999993452,
            "y2": 137.4999999999777
          }
        ],
        "BoundaryPathTypeFlag": 1
      },
      {
        "groups": [
          {
            "edgeType": "Line",
            "x1": 64.99999999993452,
            "y1": 87.49999999997772,
            "x2": 64.99999999994907,
            "y2": 102.4999999999777
          },
          {
            "edgeType": "Line",
            "x1": 64.99999999994907,
            "y1": 102.4999999999777,
            "x2": 24.99999999994179,
            "y2": 102.4999999999777
          },
          {
            "edgeType": "Line",
            "x1": 24.99999999994179,
            "y1": 102.4999999999777,
            "x2": 24.99999999994179,
            "y2": 87.50000000002136
          },
          {
            "edgeType": "Line",
            "x1": 24.99999999994179,
            "y1": 87.50000000002136,
            "x2": 64.99999999993452,
            "y2": 87.49999999997772
          }
        ],
        "BoundaryPathTypeFlag": 1
      },
      {
        "groups": [
          {
            "edgeType": "Polyline",
            "IsClosedFlag": 1,
            "NumberOfPolylineVertices": 3,
            "points": [
              52.4999999999618,
              37.4999999999618,
              52.4999999999618,
              52.4999999999618,
              59.9999999999618,
              44.99999999996179
            ]
          }
        ],
        "BoundaryPathTypeFlag": 7
      }
    ],
    "pattern": {}
  },
  {
    "type": "HATCH",
    "handle": "4CF",
    "layer": "Doc_Sembol_Listesi",
    "color": "#FF0000 ",
    "colorIndex": "",
    "LineScale": 1,
    "LineType": "ByLayer",
    "Kalinlik": "-3",
    "x": 0,
    "y": 0,
    "HatchPatternName": "SOLID",
    "SolidFillFlag": 1,
    "MPolygon": null,
    "AssociativityFlag": 0,
    "NumberOfBoundaryPaths": 1,
    "boundaryPath": [
      {
        "groups": [
          {
            "edgeType": "Line",
            "x1": 64.99999999993452,
            "y1": 137.4999999999777,
            "x2": 64.99999999994179,
            "y2": 144.9999999999777
          },
          {
            "edgeType": "Line",
            "x1": 64.99999999994179,
            "y1": 144.9999999999777,
            "x2": 24.99999999994179,
            "y2": 145.0000000000214
          },
          {
            "edgeType": "Line",
            "x1": 24.99999999994179,
            "y1": 145.0000000000214,
            "x2": 24.99999999994179,
            "y2": 137.5000000000214
          },
          {
            "edgeType": "Line",
            "x1": 24.99999999994179,
            "y1": 137.5000000000214,
            "x2": 64.99999999993452,
            "y2": 137.4999999999777
          }
        ],
        "BoundaryPathTypeFlag": 1
      },
      {
        "groups": [
          {
            "edgeType": "Line",
            "x1": 64.99999999993452,
            "y1": 87.49999999997772,
            "x2": 64.99999999994907,
            "y2": 102.4999999999777
          },
          {
            "edgeType": "Line",
            "x1": 64.99999999994907,
            "y1": 102.4999999999777,
            "x2": 24.99999999994179,
            "y2": 102.4999999999777
          },
          {
            "edgeType": "Line",
            "x1": 24.99999999994179,
            "y1": 102.4999999999777,
            "x2": 24.99999999994179,
            "y2": 87.50000000002136
          },
          {
            "edgeType": "Line",
            "x1": 24.99999999994179,
            "y1": 87.50000000002136,
            "x2": 64.99999999993452,
            "y2": 87.49999999997772
          }
        ],
        "BoundaryPathTypeFlag": 1
      },
      {
        "groups": [
          {
            "edgeType": "Polyline",
            "IsClosedFlag": 1,
            "NumberOfPolylineVertices": 3,
            "points": [
              52.4999999999618,
              37.4999999999618,
              52.4999999999618,
              52.4999999999618,
              59.9999999999618,
              44.99999999996179
            ]
          }
        ],
        "BoundaryPathTypeFlag": 7
      }
    ],
    "pattern": {}
  },
  {
    "type": "HATCH",
    "handle": "4D1",
    "layer": "Doc_Sembol_Listesi",
    "color": "#FF0000 ",
    "colorIndex": "",
    "LineScale": 1,
    "LineType": "ByLayer",
    "Kalinlik": "-3",
    "x": 0,
    "y": 0,
    "HatchPatternName": "SOLID",
    "SolidFillFlag": 1,
    "MPolygon": null,
    "AssociativityFlag": 0,
    "NumberOfBoundaryPaths": 1,
    "boundaryPath": [
      {
        "groups": [
          {
            "edgeType": "Line",
            "x1": 64.99999999993452,
            "y1": 87.49999999997772,
            "x2": 64.99999999994907,
            "y2": 102.4999999999777
          },
          {
            "edgeType": "Line",
            "x1": 64.99999999994907,
            "y1": 102.4999999999777,
            "x2": 24.99999999994179,
            "y2": 102.4999999999777
          },
          {
            "edgeType": "Line",
            "x1": 24.99999999994179,
            "y1": 102.4999999999777,
            "x2": 24.99999999994179,
            "y2": 87.50000000002136
          },
          {
            "edgeType": "Line",
            "x1": 24.99999999994179,
            "y1": 87.50000000002136,
            "x2": 64.99999999993452,
            "y2": 87.49999999997772
          }
        ],
        "BoundaryPathTypeFlag": 1
      },
      {
        "groups": [
          {
            "edgeType": "Polyline",
            "IsClosedFlag": 1,
            "NumberOfPolylineVertices": 3,
            "points": [
              52.4999999999618,
              37.4999999999618,
              52.4999999999618,
              52.4999999999618,
              59.9999999999618,
              44.99999999996179
            ]
          }
        ],
        "BoundaryPathTypeFlag": 7
      }
    ],
    "pattern": {}
  },
  {
    "type": "HATCH",
    "handle": "4D3",
    "layer": "Doc_Sembol_Listesi",
    "color": "#C0C0C0 ",
    "colorIndex": "",
    "LineScale": 1,
    "LineType": "ByLayer",
    "Kalinlik": "-3",
    "x": 0,
    "y": 0,
    "HatchPatternName": "SOLID",
    "SolidFillFlag": 1,
    "MPolygon": null,
    "AssociativityFlag": 0,
    "NumberOfBoundaryPaths": 1,
    "boundaryPath": [
      {
        "groups": [
          {
            "edgeType": "Polyline",
            "IsClosedFlag": 1,
            "NumberOfPolylineVertices": 3,
            "points": [
              52.4999999999618,
              37.4999999999618,
              52.4999999999618,
              52.4999999999618,
              59.9999999999618,
              44.99999999996179
            ]
          }
        ],
        "BoundaryPathTypeFlag": 7
      }
    ],
    "pattern": {}
  },
  {
    "type": "HATCH",
    "handle": "4D8",
    "layer": "Doc_Sembol_Listesi",
    "color": "#C0C0C0 ",
    "colorIndex": "",
    "LineScale": 1,
    "LineType": "ByLayer",
    "Kalinlik": "-3",
    "x": 0,
    "y": 0,
    "HatchPatternName": "SOLID",
    "SolidFillFlag": 1,
    "MPolygon": null,
    "AssociativityFlag": 0,
    "NumberOfBoundaryPaths": 1,
    "boundaryPath": [
      {
        "groups": [
          {
            "edgeType": "Line",
            "IsClosedFlag": 1,
            "NumberOfPolylineVertices": 3,
            "bulge": true,
            "points": [
              528.2391479283615,
              194.2130437835433,
              0.1314549871023855,
              527.838388258784,
              195.7110256608373,
              0,
              522.6399075979388,
              192.7150619062495,
              0.7676354983612083
            ]
          }
        ],
        "BoundaryPathTypeFlag": 7
      }
    ],
    "pattern": {}
  },
  {
    "type": "HATCH",
    "handle": "53F",
    "layer": "Doc_Sembol_Listesi",
    "color": "#C0C0C0 ",
    "colorIndex": "",
    "LineScale": 1,
    "LineType": "ByLayer",
    "Kalinlik": "-3",
    "x": 0,
    "y": 0,
    "HatchPatternName": "SOLID",
    "SolidFillFlag": 1,
    "MPolygon": null,
    "AssociativityFlag": 0,
    "NumberOfBoundaryPaths": 3,
    "boundaryPath": [
      {
        "groups": [
          {
            "edgeType": "Line",
            "IsClosedFlag": 1,
            "NumberOfPolylineVertices": 3,
            "bulge": true,
            "points": [
              284.9999999999991,
              350.9999999999986,
              0.4142135623730951,
              278.9999999999991,
              344.9999999999986,
              0.4142135623730951,
              284.9999999999991,
              338.9999999999986,
              0
            ]
          }
        ],
        "BoundaryPathTypeFlag": 7
      },
      {
        "groups": [
          {
            "edgeType": "Line",
            "IsClosedFlag": 1,
            "NumberOfPolylineVertices": 3,
            "bulge": true,
            "points": [
              284.9999999999991,
              350.9999999999986,
              0,
              284.9999999999991,
              344.9999999999986,
              0,
              290.9999999999991,
              344.9999999999986,
              0.4142135623730951
            ]
          }
        ],
        "BoundaryPathTypeFlag": 7
      },
      {
        "groups": [
          {
            "edgeType": "Line",
            "IsClosedFlag": 1,
            "NumberOfPolylineVertices": 3,
            "bulge": true,
            "points": [
              290.9999999999991,
              344.9999999999986,
              0,
              284.9999999999991,
              344.9999999999986,
              0,
              284.9999999999991,
              338.9999999999986,
              0.4142135623730951
            ]
          }
        ],
        "BoundaryPathTypeFlag": 7
      }
    ],
    "pattern": {}
  },
  {
    "type": "HATCH",
    "handle": "540",
    "layer": "Doc_Sembol_Listesi",
    "color": "#C0C0C0 ",
    "colorIndex": "",
    "LineScale": 1,
    "LineType": "ByLayer",
    "Kalinlik": "-3",
    "x": 0,
    "y": 0,
    "HatchPatternName": "SOLID",
    "SolidFillFlag": 1,
    "MPolygon": null,
    "AssociativityFlag": 0,
    "NumberOfBoundaryPaths": 3,
    "boundaryPath": [
      {
        "groups": [
          {
            "edgeType": "Line",
            "IsClosedFlag": 1,
            "NumberOfPolylineVertices": 3,
            "bulge": true,
            "points": [
              289.4999999999991,
              294.9999999999986,
              0,
              284.9999999999991,
              294.9999999999986,
              0,
              284.9999999999991,
              290.4999999999986,
              0.4142135623730951
            ]
          }
        ],
        "BoundaryPathTypeFlag": 7
      },
      {
        "groups": [
          {
            "edgeType": "Line",
            "IsClosedFlag": 1,
            "NumberOfPolylineVertices": 3,
            "bulge": true,
            "points": [
              284.9999999999991,
              299.4999999999986,
              0,
              284.9999999999991,
              294.9999999999986,
              0,
              289.4999999999991,
              294.9999999999986,
              0.4142135623730951
            ]
          }
        ],
        "BoundaryPathTypeFlag": 7
      },
      {
        "groups": [
          {
            "edgeType": "Line",
            "IsClosedFlag": 1,
            "NumberOfPolylineVertices": 6,
            "bulge": true,
            "points": [
              284.9999999999991,
              303.9999999999982,
              0.4142135623730951,
              275.9999999999991,
              294.9999999999982,
              0.4142135623730951,
              284.9999999999991,
              285.9999999999982,
              0,
              284.9999999999991,
              290.4999999999986,
              -0.4142135623730951,
              280.4999999999991,
              294.9999999999986,
              -0.4142135623730951,
              284.9999999999991,
              299.4999999999986,
              0
            ]
          }
        ],
        "BoundaryPathTypeFlag": 7
      }
    ],
    "pattern": {}
  },
  {
    "type": "HATCH",
    "handle": "541",
    "layer": "Doc_Sembol_Listesi",
    "color": "#C0C0C0 ",
    "colorIndex": "",
    "LineScale": 1,
    "LineType": "ByLayer",
    "Kalinlik": "-3",
    "x": 0,
    "y": 0,
    "HatchPatternName": "SOLID",
    "SolidFillFlag": 1,
    "MPolygon": null,
    "AssociativityFlag": 0,
    "NumberOfBoundaryPaths": 2,
    "boundaryPath": [
      {
        "groups": [
          {
            "edgeType": "Line",
            "IsClosedFlag": 1,
            "NumberOfPolylineVertices": 4,
            "bulge": true,
            "points": [
              293.9999999999991,
              545,
              0.1989123673796395,
              291.3639610306782,
              551.3639610306781,
              0,
              284.9999999999991,
              544.9999999999981,
              0,
              284.9999999999991,
              536,
              0.4142135623730951
            ]
          }
        ],
        "BoundaryPathTypeFlag": 7
      },
      {
        "groups": [
          {
            "edgeType": "Line",
            "IsClosedFlag": 1,
            "NumberOfPolylineVertices": 3,
            "bulge": true,
            "points": [
              284.9999999999991,
              544.9999999999981,
              0,
              278.63603896932,
              538.63603896932,
              0.1989123673796395,
              284.9999999999991,
              536,
              0
            ]
          }
        ],
        "BoundaryPathTypeFlag": 7
      }
    ],
    "pattern": {}
  },
  {
    "type": "HATCH",
    "handle": "551",
    "layer": "Doc_Sembol_Listesi",
    "color": "#C0C0C0 ",
    "colorIndex": "",
    "LineScale": 1,
    "LineType": "ByLayer",
    "Kalinlik": "-3",
    "x": 0,
    "y": 0,
    "HatchPatternName": "SOLID",
    "SolidFillFlag": 1,
    "MPolygon": null,
    "AssociativityFlag": 0,
    "NumberOfBoundaryPaths": 4,
    "boundaryPath": [
      {
        "groups": [
          {
            "edgeType": "Polyline",
            "IsClosedFlag": 1,
            "NumberOfPolylineVertices": 4,
            "points": [
              297.4999999999591,
              152.9999999999982,
              297.4999999999591,
              157.4999999999981,
              284.9999999999591,
              157.4999999999981,
              284.9999999999591,
              152.9999999999982
            ]
          }
        ],
        "BoundaryPathTypeFlag": 7
      },
      {
        "groups": [
          {
            "edgeType": "Polyline",
            "IsClosedFlag": 1,
            "NumberOfPolylineVertices": 4,
            "points": [
              297.4999999999591,
              145.9999999999982,
              297.4999999999591,
              150.4999999999982,
              284.9999999999591,
              150.4999999999982,
              284.9999999999991,
              145.9999999999982
            ]
          }
        ],
        "BoundaryPathTypeFlag": 7
      },
      {
        "groups": [
          {
            "edgeType": "Polyline",
            "IsClosedFlag": 1,
            "NumberOfPolylineVertices": 4,
            "points": [
              297.4999999999591,
              139.5000000000282,
              297.4999999999591,
              144.0000000000582,
              284.9999999999991,
              144.0000000000582,
              284.9999999999991,
              139.5000000000282
            ]
          }
        ],
        "BoundaryPathTypeFlag": 7
      },
      {
        "groups": [
          {
            "edgeType": "Polyline",
            "IsClosedFlag": 1,
            "NumberOfPolylineVertices": 4,
            "points": [
              284.9999999999991,
              137.0000000000282,
              284.9999999999991,
              132.5000000000282,
              297.4999999999591,
              132.5000000000282,
              297.4999999999591,
              137.0000000000282
            ]
          }
        ],
        "BoundaryPathTypeFlag": 7
      }
    ],
    "pattern": {}
  },
  {
    "type": "HATCH",
    "handle": "55B",
    "layer": "Doc_Sembol_Listesi",
    "color": "#C0C0C0 ",
    "colorIndex": "",
    "LineScale": 1,
    "LineType": "ByLayer",
    "Kalinlik": "-3",
    "x": 0,
    "y": 0,
    "HatchPatternName": "SOLID",
    "SolidFillFlag": 1,
    "MPolygon": null,
    "AssociativityFlag": 0,
    "NumberOfBoundaryPaths": 2,
    "boundaryPath": [
      {
        "groups": [
          {
            "edgeType": "Polyline",
            "IsClosedFlag": 1,
            "NumberOfPolylineVertices": 4,
            "points": [
              284.9999999999991,
              45.00000000002865,
              284.9999999999991,
              32.50000000002865,
              297.4999999999591,
              32.50000000002865,
              297.4999999999591,
              45.00000000002865
            ]
          }
        ],
        "BoundaryPathTypeFlag": 7
      },
      {
        "groups": [
          {
            "edgeType": "Polyline",
            "IsClosedFlag": 1,
            "NumberOfPolylineVertices": 4,
            "points": [
              272.4999999999591,
              45.00000000002865,
              284.9999999999991,
              45.00000000002865,
              284.9999999999991,
              57.50000000002865,
              272.4999999999591,
              57.50000000002865
            ]
          }
        ],
        "BoundaryPathTypeFlag": 7
      }
    ],
    "pattern": {}
  },
  {
    "type": "HATCH",
    "handle": "56A",
    "layer": "Doc_Sembol_Listesi",
    "color": "#C0C0C0 ",
    "colorIndex": "",
    "LineScale": 1,
    "LineType": "ByLayer",
    "Kalinlik": "-3",
    "x": 0,
    "y": 0,
    "HatchPatternName": "SOLID",
    "SolidFillFlag": 1,
    "MPolygon": null,
    "AssociativityFlag": 0,
    "NumberOfBoundaryPaths": 2,
    "boundaryPath": [
      {
        "groups": [
          {
            "edgeType": "Line",
            "IsClosedFlag": 1,
            "NumberOfPolylineVertices": 4,
            "bulge": true,
            "points": [
              290.3999999999987,
              444.9999999999995,
              0.1989123673796395,
              288.8183766184066,
              448.8183766184061,
              0,
              284.9999999999991,
              444.9999999999986,
              0,
              284.9999999999991,
              439.599999999999,
              0.4142135623730951
            ]
          }
        ],
        "BoundaryPathTypeFlag": 7
      },
      {
        "groups": [
          {
            "edgeType": "Line",
            "IsClosedFlag": 1,
            "NumberOfPolylineVertices": 3,
            "bulge": true,
            "points": [
              284.9999999999991,
              444.9999999999986,
              0,
              281.1816233815916,
              441.1816233815911,
              0.1989123673796395,
              284.9999999999991,
              439.599999999999,
              0
            ]
          }
        ],
        "BoundaryPathTypeFlag": 7
      }
    ],
    "pattern": {}
  },
  {
    "type": "HATCH",
    "handle": "5D9",
    "layer": "Doc_Sembol_Listesi",
    "color": "#FF0000 ",
    "colorIndex": "",
    "LineScale": 1,
    "LineType": "ByLayer",
    "Kalinlik": "-3",
    "x": 0,
    "y": 0,
    "HatchPatternName": "SOLID",
    "SolidFillFlag": 1,
    "MPolygon": null,
    "AssociativityFlag": 1,
    "NumberOfBoundaryPaths": 1,
    "boundaryPath": [
      {
        "groups": [
          {
            "edgeType": "Polyline",
            "IsClosedFlag": 1,
            "NumberOfPolylineVertices": 4,
            "points": [
              760.8228795489485,
              103.925798494467,
              755.6578160394874,
              99.97964607176051,
              757.8228795489485,
              98.72964607176051,
              759.9879430584097,
              97.47964607176051
            ]
          }
        ],
        "BoundaryPathTypeFlag": 7
      }
    ],
    "pattern": {}
  },
  {
    "type": "HATCH",
    "handle": "5DB",
    "layer": "Doc_Sembol_Listesi",
    "color": "#FF0000 ",
    "colorIndex": "",
    "LineScale": 1,
    "LineType": "ByLayer",
    "Kalinlik": "-3",
    "x": 0,
    "y": 0,
    "HatchPatternName": "SOLID",
    "SolidFillFlag": 1,
    "MPolygon": null,
    "AssociativityFlag": 1,
    "NumberOfBoundaryPaths": 1,
    "boundaryPath": [
      {
        "groups": [
          {
            "edgeType": "Line",
            "IsClosedFlag": 1,
            "NumberOfPolylineVertices": 2,
            "bulge": true,
            "points": [
              759.5728795489485,
              106.0908620039281,
              1,
              764.5728795489485,
              106.0908620039281,
              1
            ]
          }
        ],
        "BoundaryPathTypeFlag": 7
      }
    ],
    "pattern": {}
  },
  {
    "type": "HATCH",
    "handle": "5DD",
    "layer": "Doc_Sembol_Listesi",
    "color": "#FF0000 ",
    "colorIndex": "",
    "LineScale": 1,
    "LineType": "ByLayer",
    "Kalinlik": "-3",
    "x": 0,
    "y": 0,
    "HatchPatternName": "SOLID",
    "SolidFillFlag": 1,
    "MPolygon": null,
    "AssociativityFlag": 1,
    "NumberOfBoundaryPaths": 10,
    "boundaryPath": [
      {
        "groups": [
          {
            "edgeType": "Polyline",
            "IsClosedFlag": 1,
            "NumberOfPolylineVertices": 4,
            "points": [
              770.5162552219226,
              86.07420150553298,
              775.6813187313837,
              90.0203539282395,
              773.5162552219226,
              91.2703539282395,
              771.3511917124614,
              92.5203539282395
            ]
          }
        ],
        "BoundaryPathTypeFlag": 7
      }
    ],
    "pattern": {}
  },
  {
    "type": "HATCH",
    "handle": "5DF",
    "layer": "Doc_Sembol_Listesi",
    "color": "#FF0000 ",
    "colorIndex": "",
    "LineScale": 1,
    "LineType": "ByLayer",
    "Kalinlik": "-3",
    "x": 0,
    "y": 0,
    "HatchPatternName": "SOLID",
    "SolidFillFlag": 1,
    "MPolygon": null,
    "AssociativityFlag": 1,
    "NumberOfBoundaryPaths": 1,
    "boundaryPath": [
      {
        "groups": [
          {
            "edgeType": "Line",
            "IsClosedFlag": 1,
            "NumberOfPolylineVertices": 2,
            "bulge": true,
            "points": [
              771.7662552219226,
              83.90913799607188,
              1,
              766.7662552219226,
              83.90913799607188,
              1
            ]
          }
        ],
        "BoundaryPathTypeFlag": 7
      }
    ],
    "pattern": {}
  },
  {
    "type": "HATCH",
    "handle": "5E2",
    "layer": "Doc_Sembol_Listesi",
    "color": "#C0C0C0 ",
    "colorIndex": "",
    "LineScale": 1,
    "LineType": "ByLayer",
    "Kalinlik": "-3",
    "x": 0,
    "y": 0,
    "HatchPatternName": "SOLID",
    "SolidFillFlag": 1,
    "MPolygon": null,
    "AssociativityFlag": 1,
    "NumberOfBoundaryPaths": 1,
    "boundaryPath": [
      {
        "groups": [
          {
            "edgeType": "Polyline",
            "IsClosedFlag": 1,
            "NumberOfPolylineVertices": 4,
            "points": [
              780,
              50,
              770,
              50,
              770,
              40,
              780,
              40
            ]
          }
        ],
        "BoundaryPathTypeFlag": 7
      }
    ],
    "pattern": {}
  },
  {
    "type": "HATCH",
    "handle": "5E4",
    "layer": "Doc_Sembol_Listesi",
    "color": "#C0C0C0 ",
    "colorIndex": "",
    "LineScale": 1,
    "LineType": "ByLayer",
    "Kalinlik": "-3",
    "x": 0,
    "y": 0,
    "HatchPatternName": "SOLID",
    "SolidFillFlag": 1,
    "MPolygon": null,
    "AssociativityFlag": 1,
    "NumberOfBoundaryPaths": 1,
    "boundaryPath": [
      {
        "groups": [
          {
            "edgeType": "Line",
            "IsClosedFlag": 1,
            "NumberOfPolylineVertices": 2,
            "bulge": true,
            "points": [
              760,
              45,
              1,
              750,
              45,
              1
            ]
          }
        ],
        "BoundaryPathTypeFlag": 7
      }
    ],
    "pattern": {}
  }
]
const jsonString = convertArrayToJSONString(result);
return {
  result: parseIfNeeded(result) ,
  width: 1000 * Scl,
  height: 1500 * Scl
};
  }

function parseIfNeeded(data) {
  if (typeof data === 'string') {
    try {
      return JSON.parse(data);
    } catch (e) {
      console.error('JSON parse hatası:', e);
      return null;
    }
  }
  return data;
}function convertArrayToJSONString(array) {
  if (!Array.isArray(array)) {
    throw new Error("Girdi bir dizi olmalı");
  }

  const converted = array.map((item, index) => {
    try {
      return JSON.stringify(item);
    } catch (e) {
      console.error(`Eleman ${index} dönüştürülemedi:`, e);
      return null;
    }
  }).filter(Boolean); // null veya undefined olanları çıkar

  return `[${converted.join(',')}]`; // JSON dizisi formatında string üret
}
